<template>
    <div class="inner-wrapper full-height" style="overflow-y: scroll;" v-if="planningView">
        <div class="report-container column-report">
            <img class="spinner" v-if="is_loading" src="/images/spinner.gif">
            <div class="mt-30 mb-20" v-click-outside="floatSecondOff">
                <h2 style="float: left;">VIEW RESULTS</h2>
                <img @click="goBackPlanning()" style="float: right; cursor: pointer;" width="50" height="50" src="/images/assets/googlemap_icon.png"><img style="float: right; cursor: pointer; margin-right: 20px;" width="50" height="50" src="/images/assets/export_icon.png">
                <div class="filter-update hollow text-center" style="float: right; cursor: pointer; margin-right: 20px; background: #495F74; margin-top: 0;
                    font-size: 1.1rem;
                    padding: 18px 0px;
                    width: 190px;
                    border-radius: 28px;" @click="toggleFloatingFilterSecond()">CUSTOM SEARCH</div>
                <div class="filter-update hollow text-center" style="float: right; cursor: pointer; margin-right: 20px; background: #495F74; margin-top: 0;
                    font-size: 1.1rem;
                    padding: 18px 0px;
                    width: 190px;
                    border-radius: 28px;" @click="cityPreviewOn()">CITY PREVIEW</div>
                <div class="city-tables" v-if="cityPreview">
                    <div class="city-header">
                        <h5>CITY PREVIEW</h5>
                        <img src="/images/assets/logo/RPD_logotype_skyblue.png" class="logo-modal">
                        <button type="button" aria-label="Close" class="close modal-close"  @click="cityPreviewOff()">×</button>
                    </div>
                    <div class="city-inner">
                        <div class="row">
                            <div class="col-sm-4 mt-20" v-for="(city, index) in citySummary" :key="index">
                                <div class="city-tb-wrapper">
                                    <h2 class="text-center mb-30">{{index}}</h2>
                                    <table class="table list-table">
                                        <thead class="summary-table-header">
                                            <th class="city-hd">Project Type</th>
                                            <th class="city-hd">#Projects</th>
                                            <th class="city-hd">Units</th>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(type, type_i) in city" :key="type_i">
                                                <td>{{type_i}}</td>
                                                <td>{{type.projects}}</td>
                                                <td>{{type.units}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="new-list floating-filters" v-if="floatSecond">
                    <div class="row">
                        <div class="col-sm-12 text-left">
                            <h3 class="filter-label">Region Location</h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-6" v-click-outside="gvPlanningSummaryOff">
                            <div class="type-filter-button-sm-wrap" @click="openPlanningGVSummary()">
                                <div class="text-left" :class="{buttonWithOpt: citiesSelected.some(g => gvCities.includes(g))}"><span style="float: left; margin-top: 7px;">GV: </span> <span class="choosen-opts" v-for="(city, index) in citiesSelected.filter(g => gvCities.includes(g))" :key="index" @click="removeCity(index)">{{nameSwitch(city)}}</span></div>
                            </div>
                            <div class="sale-pop dropdown-background-grey scroll-popup" :class="{active: gvPlanningSummaryOptions}">
                                <input class="checkbox-square" type="checkbox" id="planning_vancouver" value="2895" v-model="citiesSelected">
                                <label for="planning_vancouver"> Vancouver</label><br>
                                <input class="checkbox-square" type="checkbox" id="planning_coquitlam" value="2874" v-model="citiesSelected">
                                <label for="planning_coquitlam"> Coquitlam</label><br>
                                <input class="checkbox-square" type="checkbox" id="planning_burnaby" value="2873" v-model="citiesSelected">
                                <label for="planning_burnaby"> Burnaby</label><br>
                                <input class="checkbox-square" type="checkbox" id="planning_richmond" value="2877" v-model="citiesSelected">
                                <label for="planning_richmond"> Richmond</label><br>
                                <input class="checkbox-square" type="checkbox" id="planning_north_van_city" value="2949" v-model="citiesSelected">
                                <label for="planning_north_van_city"> North Van (City)</label><br>
                                <input class="checkbox-square" type="checkbox" id="planning_new_westminster" value="2889" v-model="citiesSelected">
                                <label for="planning_new_westminster"> New Westminster</label><br>
                                <input class="checkbox-square" type="checkbox" id="planning_north_vancouver_district" value="2950" v-model="citiesSelected">
                                <label for="planning_north_vancouver_district"> North Van (Dist)</label><br>
                                <input class="checkbox-square" type="checkbox" id="planning_west_vancouver" value="2896" v-model="citiesSelected">
                                <label for="planning_west_vancouver"> West Vancouver</label><br>
                                <input class="checkbox-square" type="checkbox" id="planning_squamish" value="2894" v-model="citiesSelected">
                                <label for="planning_squamish"> Squamish</label><br>
                                <input class="checkbox-square" type="checkbox" id="planning_port_coquitlam" value="2892" v-model="citiesSelected">
                                <label for="planning_port_coquitlam"> Port Coquitlam</label><br>
                                <input class="checkbox-square" type="checkbox" id="planning_port_moody" value="2893" v-model="citiesSelected">
                                <label for="planning_port_moody"> Port Moody</label><br>
                                <input class="checkbox-square" type="checkbox" id="planning_maple_ridge" value="2888" v-model="citiesSelected">
                                <label for="planning_maple_ridge"> Maple Ridge</label><br>
                                <input class="checkbox-square" type="checkbox" id="planning_pitt_meadows" value="2891" v-model="citiesSelected">
                                <label for="planning_pitt_meadows"> Pitt Meadows</label><br>
                            </div>
                        </div>
                        <div class="col-xs-6" v-click-outside="fvPlanningSummaryOff">
                            <div class="type-filter-button-sm-wrap" @click="openPlanningSummaryFV()">
                                <div class="text-left" :class="{buttonWithOpt: citiesSelected.some(g => fvCities.includes(g))}"><span style="float: left; margin-top: 7px;">FV: </span> <span class="choosen-opts" v-for="(city, index) in citiesSelected.filter(g => fvCities.includes(g))" :key="index" @click="removeCity(index)">{{nameSwitch(city)}}</span></div>
                            </div>
                            <div class="sale-pop dropdown-background-grey scroll-popup" :class="{active: fvPlanningSummaryOptions}">
                                <input class="checkbox-square" type="checkbox" id="planning_surrey" value="2887" v-model="citiesSelected">
                                <label for="planning_surrey"> Surrey</label><br>
                                <input class="checkbox-square" type="checkbox" id="planning_langley_township" value="2879" v-model="citiesSelected">
                                <label for="planning_langley_township"> Langley (Township)</label><br>
                                <input class="checkbox-square" type="checkbox" id="planning_langley_city" value="3556" v-model="citiesSelected">
                                <label for="planning_langley_city"> Langley (City)</label><br>
                                <input class="checkbox-square" type="checkbox" id="planning_abbotsford" value="2876" v-model="citiesSelected">
                                <label for="planning_abbotsford"> Abbotsford</label><br>
                                <input class="checkbox-square" type="checkbox" id="planning_delta" value="2898" v-model="citiesSelected">
                                <label for="planning_delta"> Delta</label><br>
                                <input class="checkbox-square" type="checkbox" id="planning_mission" value="3609" v-model="citiesSelected">
                                <label for="planning_mission"> Mission</label><br>
                                <input class="checkbox-square" type="checkbox" id="planning_white_rock" value="2897" v-model="citiesSelected">
                                <label for="planning_white_rock"> White Rock</label><br>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12 text-left">
                            <h3 class="filter-label">Transaction Type</h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-6" v-click-outside="salePlanningSummaryOff">
                            <div class="type-filter-button-sm-wrap" @click="openPlanningSummarySale()">
                                <div class="text-left" :class="{buttonWithOpt: (gutSelected.includes('2952') || gutSelected.includes('2954') || gutSelected.includes('2970'))}"><span style="float: left; margin-top: 7px;">Residential: </span> <span class="choosen-opts" v-for="(gut, index) in gutSelected.filter(g => ['2952', '2954', '2970'].includes(g))" :key="index" @click="removeGut(index)">{{nameSwitch(gut)}}</span></div>
                            </div>
                            <div class="sale-pop dropdown-background-grey" :class="{active: salePlanningSummaryOptions}">
                                <input class="checkbox-square" type="checkbox" id="planning_market_strata" value="2952" v-model="gutSelected">
                                <label for="planning_market_strata"> Market Strata</label><br>
                                <input class="checkbox-square" type="checkbox" id="planning_market_rental" value="2954" v-model="gutSelected">
                                <label for="planning_market_rental"> Market Rental</label><br>
                                <!-- <input class="checkbox-square" type="checkbox" id="planning_secured_market_rental" value="2970" v-model="gutSelected">
                                <label for="planning_secured_market_rental"> Secured Market Rental</label> -->
                            </div>
                        </div>
                        <div class="col-xs-6" v-click-outside="leasePlanningSummaryOff">
                            <div class="type-filter-button-sm-wrap" @click="openPlanningSummaryLease()">
                                <div class="text-left" :class="{buttonWithOpt: (gutSelected.includes('2960') || gutSelected.includes('3031') || gutSelected.includes('3515'))}"><span style="float: left; margin-top: 7px;">Commercial: </span> <span class="choosen-opts" v-for="(gut, index) in gutSelected.filter(g => ['2960', '3031', '3515'].includes(g))" :key="index" @click="removeGut(index)">{{nameSwitch(gut)}}</span></div>
                            </div>
                            <div class="sale-pop dropdown-background-grey" :class="{active: leasePlanningSummaryOptions}">
                                <input class="checkbox-square" type="checkbox" id="planning_office" value="3031" v-model="gutSelected">
                                <label for="planning_office"> Office</label><br>
                                <input class="checkbox-square" type="checkbox" id="planning_retail" value="2960" v-model="gutSelected">
                                <label for="planning_retail"> Retail</label><br>
                                <input class="checkbox-square" type="checkbox" id="planning_industrial" value="3515" v-model="gutSelected">
                                <label for="planning_industrial"> Industrial</label>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="filter-update hollow text-center" style="background: #495F74;"  @click="PlanningUTCGo(true)">FIND PROJECTS</div>
                        </div>
                        <div class="col-lg-6">
                            <div class="filter-update hollow text-center" style="background: #495F74;" @click="PlanningUTCGo(false)">SUMMARY RESULTS</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="table-wrap">
                <table v-if="!is_loading" class="table list-table">
                    <thead class="summary-table-header">
                        <th class="summary-sort">Project</th>
                        <th class="summary-sort">Developer/Applicant</th>
                        <th class="summary-sort">UTC Address</th>
                        <th class="summary-sort">City</th>
                        <th class="summary-sort">Neighbourhood</th>
                        <th class="summary-sort">Type &amp; Storey</th>
                        <th class="summary-sort">Units</th>
                        <th class="summary-sort">UTC Status</th>
                        <th class="summary-sort">Permit &amp; Bylaw Status</th>
                    </thead>
                    <tbody>
                        <tr v-for="(utc, index) in planningUTC" :key="index" @click="goto(utc.link)">
                            <td>{{utc.project_name}}</td>
                            <td>{{utc.developer}}</td>
                            <td>{{utc.address}}</td>
                            <td>{{utc.city}}</td>
                            <td>{{utc.neighbour}}</td>
                            <td>{{utc.type}}<br>{{utc.storey}}</td>
                            <td>{{utc.units}}</td>
                            <td>{{utc.status}}</td>
                            <td>
                                <div v-if="utc.rz">REZ: {{utc.rz}}</div>
                                <div v-if="utc.dp">DP: {{utc.dp}}</div>
                                <div v-if="utc.b">B: {{utc.b}}</div>
                                <div v-if="utc.ocp">OCP: {{utc.ocp}}</div>
                                <div v-if="utc.dvp">DVP: {{utc.dvp}}</div>
                                <div v-if="utc.sub">Sub: {{utc.sub}}</div>
                                <div v-if="utc.srv">Serv: {{utc.srv}}</div>
                                <div v-if="utc.demo">Demo: {{utc.demo}}</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div class="inner-wrapper full-height" v-else>
        <div v-show="listing" class="inner-wrapper full-height">
            <div v-if="currentTab == 'land'" class="land-extra new-list">
                <div class="start-label text-left">Let's Start</div>
                <div class="row">
                    <div class="col-sm-6">
                        <h3 class="filter-label text-left" style="width: 100%;">Lot Size</h3>
                        <div class="row">
                            <div class="col-sm-6 text-left">
                                <input class="type-filter-button-sm-wrap" placeholder="min" v-model="lotSizeMin">
                            </div>
                            <div class="col-sm-6 text-left">
                                <input class="type-filter-button-sm-wrap" placeholder="max" v-model="lotSizeMax">
                            </div>
                        </div>
                        <h3 class="filter-label text-left" style="width: 100%;">Land Price</h3>
                        <div class="row">
                            <div class="col-sm-6 text-left">
                                <input class="type-filter-button-sm-wrap" placeholder="min" v-model="landPriceMin">
                            </div>
                            <div class="col-sm-6 text-left">
                                <input class="type-filter-button-sm-wrap" placeholder="max" v-model="landPriceMax">
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 text-left">
                                <h3 class="filter-label">City &amp; Neighbourhood</h3>
                                <div class="filter-checkbox mt-10">
                                    <treeselect v-model="citiesSelected" :multiple="true" :flat="true" :options="cityoptions" :limit="3"/>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 text-left">
                                <h3 class="filter-label">Planning Designation - Land Use</h3>
                                <div class="filter-checkbox mt-10">
                                    <treeselect v-model="landSelected" :multiple="true" :flat="true" :options="landOptions" :limit="3"/>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 text-left">
                                <h3 class="filter-label">Planning Designation - Area Plan</h3>
                                <div class="filter-checkbox mt-10">
                                    <treeselect v-model="areaSelected" :multiple="true" :flat="true" :options="areaOptions" :limit="3"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <h3 class="filter-label mt-30 text-left" style="width: 100%;">Proposed Zoning</h3>
                        <div class="row">
                            <div class="col-sm-12 text-left">
                                <div class="filter-checkbox mt-10">
                                    <treeselect v-model="proposedSelected" :multiple="true" :async="true" :load-options="proposedZoningOptions" />
                                </div>
                            </div>
                        </div>
                        <h3 class="filter-label mt-30 text-left" style="width: 100%;">Existing Zoning</h3>
                        <div class="row">
                            <div class="col-sm-12 text-left">
                                <div class="filter-checkbox mt-10">
                                    <treeselect v-model="existingZSelected" :multiple="true" :async="true" :load-options="proposedZoningOptions" />
                                </div>
                            </div>
                        </div>
                        <h3 class="filter-label text-left" style="width: 100%;">FSR</h3>
                        <div class="row">
                            <div class="col-sm-6 text-left">
                                <input class="type-filter-button-sm-wrap" placeholder="min" v-model="fsrMin">
                            </div>
                            <div class="col-sm-6 text-left">
                                <input class="type-filter-button-sm-wrap" placeholder="max" v-model="fsrMax">
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-6 text-left">
                                <h3>Project Type</h3>
                                <div class="filter-checkbox mt-10">
                                    <treeselect v-model="typeSSelected" :multiple="true" :flat="true" :options="typeOptions" :limit="3"/>
                                </div>
                            </div>
                            <div class="col-sm-6 text-left">
                                <h3>Project Status</h3>
                                <div class="filter-checkbox mt-10">
                                    <treeselect v-model="statusSSelected" :multiple="true" :flat="true" :options="statusOptions" :limit="3"/>
                                </div>
                            </div>
                        </div>
                        <h3 class="filter-label mt-30 text-left" style="width: 100%;">Unit Type</h3>
                        <div class="row">
                            <div class="col-sm-12 text-left">
                                <div class="filter-checkbox mt-10">
                                    <treeselect v-model="gutSelected" :multiple="true" :flat="true" :options="gutoptions" :autoSelectDescendants="true" :limit="3" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>     
            </div>
            <div class="right-info" v-if="!rightToggle" :class="{'right-activated' : rightCollapse}">
                <img class="info-collapse" src="/images/assets/collapse.svg" @click="rightCollapse = !rightCollapse">
            </div>
            <div class="col-list-wrap right-list right-menu" :class="{'right-on' : !rightToggle && rightCollapse}">
                <div class="result-header-block">
                    <h2 class="result-title"><img @click="rightCollapse = !rightCollapse" class="right-t-icon" src="/images/assets/collapse.svg">Project Preview <img @click="sortDisplay = !sortDisplay" class="sort-icon" src="/images/assets/sort.png"></h2>
                    <div class="result-wrapper" style="background-color: #e7ecf6;" v-if="pickedProject">
                        <div class="result-row-feature focus-target col-xs-12 text-center">
                            <div class="text-center">
                                <div class="row">
                                    <div class="col-md-7">
                                        <div class="picked-result-pic-feature">
                                            <img v-if="pickedProject.pic && pickedProject.pic != 'https://www.realpropertydata.ca/backend/'" :src="pickedProject.pic">
                                            <img v-else src="/images/assets/placeholder.png">
                                        </div>
                                        <div class="picked-result-status-feature" :class="getColor(pickedProject.status)">{{pickedProject.status}}</div>
                                        <div class="picked-result-city-feature">{{pickedProject.city}}</div>
                                    </div>
                                    <div class="col-md-5 text-left" style="padding-left: 0;">
                                        <div v-if="pickedProject.name && pickedProject.name.length > 31" @click="openModal(pickedProject)"  class="result-name text-center" v-b-popover="{customClass: 'popover-custom', content: pickedProject.name, trigger: 'hover', placement: 'top'}">
                                            {{pickedProject.name.substring(0,31)+".."}}
                                        </div>
                                        <div v-else @click="openModal(project)" class="result-name text-center">{{pickedProject.name}}</div>
                                        <div class="result-type text-center">${{pickedProject.total_avg_price | numFormat}}</div>
                                        <div class="result-type">
                                            <span style="font-size: 1rem; font-weight: normal;">Avg Size: <strong>{{pickedProject.total_avg_size }}</strong></span>
                                            <span style="float: right; font-size: 1rem; font-weight: normal;">Avg $PSF: <strong>{{pickedProject.total_avg_psf }}</strong></span>
                                        </div>
                                        <div class="row" style="margin-left: 0; margin-right: 0; margin-top: 5px;">
                                            <div class="square-wrapper">
                                                <div class="square-white">
                                                    <div>Total Units:</div>
                                                    <div><strong>{{ pickedProject.total_units }}</strong></div>
                                                </div>
                                            </div>
                                            <div class="square-wrapper">
                                                <div class="square-white">
                                                    <div>Rlsd Units:</div>
                                                    <div><strong>{{ pickedProject.rlsd_units }}</strong></div>
                                                </div>
                                            </div>
                                            <div class="square-wrapper">
                                                <div class="square-white">
                                                    <div>Sold Units:</div>
                                                    <div><strong>{{ pickedProject.sold_units }}</strong></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt-5">
                                            <div class="col-md-6" style="padding-right: 3px;">
                                                <svg width="25" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M10.9357 13.1296V14.2518L11.888 14.601V13.4787L10.9357 13.1296ZM10.9357 10.9389V12.0611L11.888 12.4103V11.288L10.9357 10.9389ZM15.691 9.63534L13.5993 10.9943V16.6048C14.3106 16.6849 15.0089 16.7929 15.691 16.9289V9.63534ZM10.9357 8.74975V9.87039L11.888 10.2199V9.09889L10.9357 8.74975ZM4.99827 8.43499L2.90586 9.79434V17.5741C3.57461 17.3593 4.27491 17.1736 4.99827 17.0187V8.43499ZM12.8303 7.25488V8.37552L13.7826 8.72507V7.60442L12.8303 7.25488ZM10.9357 6.55943V7.68169L11.888 8.03083V6.90857L10.9357 6.55943ZM12.8303 5.06415V6.18682L13.7826 6.53434V5.4137L12.8303 5.06415ZM10.9357 4.36911V5.49137L11.888 5.84011V4.71784L10.9357 4.36911ZM12.8303 2.87383V3.9965L13.7826 4.34524V3.22297L12.8303 2.87383ZM10.9357 2.17838V3.30065L11.888 3.64979V2.52752L10.9357 2.17838ZM9.67182 1.10345L7.5794 2.46239V16.5975C8.26919 16.5239 8.96787 16.4753 9.67182 16.4551V1.10345ZM10.1096 0.293915L14.5942 1.93848V8.87193L12.5171 10.2224V16.5101C12.7303 16.5227 12.9452 16.5393 13.1588 16.5575V10.756L16.1303 8.82621L18.6609 10.4708V17.7169C19.5489 18.0248 20.3754 18.3808 21.1235 18.781H0.00390625C0.751949 18.3837 1.57807 18.0289 2.46529 17.7242V9.55645L5.43682 7.62586L7.13964 8.73154V2.22531L10.1096 0.293915Z" fill="black"/>
                                                    </svg>{{ pickedProject.type }}</div>
                                            <div class="col-md-6" style="padding-left: 3px; padding-right: 3px;">
                                                <svg width="25" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M0.745055 0.260229L0.0390625 1.82517C0.0390625 1.82666 0.0390625 1.82666 0.0390625 1.82778V16.8256C0.0390625 17.2156 0.330094 17.5673 0.719376 17.5837C1.12615 17.6026 1.46296 17.2762 1.46296 16.8728V1.82778C1.46296 1.82666 1.46296 1.82666 1.46296 1.82517H1.46147L0.757336 0.260229C0.754359 0.254647 0.746544 0.254647 0.745055 0.260229Z" fill="black"/>
                                                    <path d="M4.68294 1.98888C4.41648 1.98888 4.20025 1.77228 4.20025 1.50581C4.20025 1.24046 4.41648 1.02349 4.68294 1.02349C4.94941 1.02349 5.16415 1.24046 5.16415 1.50581C5.16415 1.77228 4.94941 1.98888 4.68294 1.98888ZM5.65801 0.256088H3.70825C3.55678 0.256088 3.43359 0.379274 3.43359 0.529628V3.1463C3.43359 3.16417 3.44997 3.18017 3.46746 3.18017H4.16527C4.25161 3.18017 4.32195 3.25088 4.32195 3.33722V3.43212C4.32195 3.51884 4.25161 3.58918 4.16527 3.58918H3.46746C3.44997 3.58918 3.43359 3.60555 3.43359 3.62453V4.9565C3.43359 4.97548 3.44997 4.99037 3.46746 4.99037H4.16527C4.25161 4.99037 4.32195 5.06071 4.32195 5.14891V5.24344C4.32195 5.33015 4.25161 5.40049 4.16527 5.40049H3.46746C3.44997 5.40049 3.43359 5.41687 3.43359 5.43436V6.76782C3.43359 6.7868 3.44997 6.80168 3.46746 6.80168H4.16527C4.25161 6.80168 4.32195 6.87202 4.32195 6.95874V7.05513C4.32195 7.14147 4.25161 7.21218 4.16527 7.21218H3.46746C3.44997 7.21218 3.43359 7.22706 3.43359 7.24567V8.5795C3.43359 8.59848 3.44997 8.61337 3.46746 8.61337H4.16527C4.25161 8.61337 4.32195 8.68371 4.32195 8.77042V8.86495C4.32195 8.95315 4.25161 9.02349 4.16527 9.02349H3.46746C3.44997 9.02349 3.43359 9.03838 3.43359 9.05736V10.3893C3.43359 10.4083 3.44997 10.4247 3.46746 10.4247H4.16527C4.25161 10.4247 4.32195 10.495 4.32195 10.5817V10.6763C4.32195 10.7645 4.25161 10.8348 4.16527 10.8348H3.46746C3.44997 10.8348 3.43359 10.8497 3.43359 10.8672V12.201C3.43359 12.2196 3.44997 12.2345 3.46746 12.2345H4.16527C4.25161 12.2345 4.32195 12.3063 4.32195 12.3931V12.488C4.32195 12.5747 4.25161 12.645 4.16527 12.645H3.46746C3.44997 12.645 3.43359 12.6599 3.43359 12.6789V14.0123C3.43359 14.0313 3.44997 14.0462 3.46746 14.0462H4.16527C4.25161 14.0462 4.32195 14.1165 4.32195 14.2033V14.2993C4.32195 14.386 4.25161 14.4563 4.16527 14.4563H3.46746C3.44997 14.4563 3.43359 14.4712 3.43359 14.4902V15.8236C3.43359 15.8426 3.44997 15.8575 3.46746 15.8575H4.16527C4.25161 15.8575 4.32195 15.9279 4.32195 16.0146V16.1095C4.32195 16.1973 4.25161 16.2676 4.16527 16.2676H3.46746C3.44997 16.2676 3.43359 16.2825 3.43359 16.3015V17.3101C3.43359 17.4619 3.55678 17.5851 3.70825 17.5851H5.65801C5.80911 17.5851 5.9308 17.4619 5.9308 17.3101V0.529628C5.9308 0.379274 5.80911 0.256088 5.65801 0.256088Z" fill="black"/>
                                                    <path d="M12.059 9.48195C12.0605 9.47265 12.0672 9.46297 12.0765 9.45776L14.0657 8.40826C14.0791 8.40008 14.0858 8.38668 14.0832 8.37179L13.8521 7.04503C13.8491 7.03015 13.8372 7.01935 13.8234 7.01787L11.5953 6.70525C11.5845 6.70376 11.5748 6.69855 11.5711 6.68887L11.0099 5.71418C11.0043 5.70488 11.0043 5.69408 11.0084 5.68441L11.8576 3.59955C11.8628 3.58615 11.8588 3.56978 11.848 3.56047L10.8193 2.69371C10.807 2.6844 10.7921 2.68292 10.7787 2.6911L8.87215 3.88537C8.86396 3.89207 8.85317 3.89207 8.84238 3.88947L7.78767 3.50353C7.77836 3.49944 7.77018 3.49125 7.76757 3.48195L7.07944 1.33718C7.07535 1.32229 7.06158 1.31298 7.04669 1.31298H6.3206C6.3113 1.31298 6.30311 1.31559 6.29641 1.32229C6.28971 1.32936 6.28711 1.33718 6.28711 1.34685V6.21772C6.28711 6.22739 6.28971 6.23558 6.2979 6.24228C6.30311 6.24898 6.31279 6.25158 6.32209 6.25158C7.70244 6.17454 8.95477 7.13696 9.20486 8.53443C9.47394 10.0439 8.47059 11.4868 6.96296 11.7577C6.74673 11.7957 6.53311 11.805 6.32209 11.7942C6.31279 11.7931 6.30311 11.7972 6.2979 11.8039C6.28971 11.8091 6.28711 11.8188 6.28711 11.8281V14.6971C6.28711 14.7157 6.302 14.7321 6.3206 14.7321H6.91979C6.92909 14.7321 6.93988 14.7361 6.94546 14.7455L8.3247 16.5244C8.334 16.5367 8.34889 16.5408 8.36378 16.5367L9.62801 16.0763C9.64141 16.0722 9.65109 16.0588 9.6496 16.0439L9.56996 13.7927C9.56847 13.783 9.57405 13.7722 9.58186 13.7655L10.4434 13.0439C10.4512 13.0372 10.462 13.0342 10.4717 13.0372L12.6701 13.5125C12.685 13.5151 12.6998 13.5084 12.7065 13.4961L13.3813 12.3305C13.388 12.3182 13.3869 12.3018 13.3772 12.291L11.8695 10.6193C11.8628 10.6111 11.8602 10.6003 11.8617 10.5895L12.059 9.48195Z" fill="black"/>
                                                    </svg>
                                                    {{ pickedProject.developer }}</div>
                                        </div>
                                        <div class="row mt-5">
                                            <div class="col-md-5">
                                                <svg width="25" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M15.4525 17.1805H0.623781C0.582992 17.1805 0.542918 17.1766 0.503202 17.1687C0.463486 17.1609 0.424844 17.1491 0.387275 17.1333C0.349706 17.1179 0.314284 17.099 0.280293 17.0764C0.246659 17.0539 0.215531 17.0281 0.186907 16.9995C0.158282 16.9709 0.132521 16.9394 0.109979 16.9058C0.0874379 16.8721 0.0684745 16.8363 0.0527313 16.7988C0.0373458 16.7612 0.0255385 16.7226 0.0176668 16.6828C0.00979523 16.6431 0.00585938 16.6027 0.00585938 16.5623V2.96011C0.00585938 2.91932 0.00979523 2.87925 0.0176668 2.83953C0.0255385 2.79981 0.0373458 2.76081 0.0527313 2.7236C0.0684745 2.68603 0.0874379 2.65025 0.109979 2.61662C0.132521 2.58299 0.158282 2.5515 0.186907 2.52288C0.215531 2.49425 0.246659 2.46849 0.280293 2.44595C0.314284 2.42341 0.349706 2.40444 0.387275 2.3887C0.424844 2.37332 0.463486 2.36151 0.503202 2.35364C0.542918 2.34577 0.582992 2.34183 0.623781 2.34183H15.4525C15.4929 2.34183 15.5333 2.34577 15.5731 2.35364C15.6128 2.36151 15.6514 2.37332 15.689 2.3887C15.7265 2.40444 15.762 2.42341 15.7956 2.44595C15.8296 2.46849 15.8607 2.49425 15.8893 2.52288C15.918 2.5515 15.9437 2.58299 15.9663 2.61662C15.9888 2.65025 16.0078 2.68603 16.0232 2.7236C16.0389 2.76081 16.0504 2.79981 16.0586 2.83953C16.0665 2.87925 16.0704 2.91932 16.0704 2.96011V16.5623C16.0704 16.6027 16.0665 16.6431 16.0586 16.6828C16.0504 16.7226 16.0389 16.7612 16.0232 16.7988C16.0078 16.8363 15.9888 16.8721 15.9663 16.9058C15.9437 16.9394 15.918 16.9709 15.8893 16.9995C15.8607 17.0281 15.8296 17.0539 15.7956 17.0764C15.762 17.099 15.7265 17.1179 15.689 17.1333C15.6514 17.1491 15.6128 17.1609 15.5731 17.1687C15.5333 17.1766 15.4929 17.1805 15.4525 17.1805ZM1.2417 15.944H14.8346V3.57839H1.2417V15.944Z" fill="black"/>
                                                    <path d="M3.09644 3.57828C3.05601 3.57828 3.01557 3.57434 2.97586 3.56647C2.93614 3.5586 2.8975 3.54679 2.85993 3.53105C2.82272 3.51566 2.78694 3.4967 2.75331 3.47416C2.71932 3.45161 2.68819 3.42585 2.65956 3.39723C2.63094 3.3686 2.60518 3.33712 2.58264 3.30348C2.56009 3.26985 2.54113 3.23407 2.52575 3.1965C2.51 3.15893 2.49855 3.12029 2.49032 3.08057C2.48245 3.04086 2.47852 3.00043 2.47852 2.96V1.10516C2.47852 1.06437 2.48245 1.02429 2.49032 0.984578C2.49855 0.944862 2.51 0.905862 2.52575 0.868651C2.54113 0.831082 2.56009 0.795302 2.58264 0.761668C2.60518 0.728035 2.63094 0.696549 2.65956 0.667925C2.68819 0.639301 2.71932 0.613539 2.75331 0.590997C2.78694 0.568456 2.82272 0.549493 2.85993 0.533749C2.8975 0.518364 2.93614 0.506557 2.97586 0.498685C3.01557 0.490813 3.05601 0.486877 3.09644 0.486877C3.13723 0.486877 3.1773 0.490813 3.21702 0.498685C3.25673 0.506557 3.29537 0.518364 3.33294 0.533749C3.37051 0.549493 3.40594 0.568456 3.43957 0.590997C3.47356 0.613539 3.50469 0.639301 3.53331 0.667925C3.56194 0.696549 3.5877 0.728035 3.61024 0.761668C3.63278 0.795302 3.65174 0.831082 3.66749 0.868651C3.68287 0.905862 3.69468 0.944862 3.70255 0.984578C3.71042 1.02429 3.71436 1.06437 3.71436 1.10516V2.96C3.71436 3.00043 3.71042 3.04086 3.70255 3.08057C3.69468 3.12029 3.68287 3.15893 3.66749 3.1965C3.65174 3.23407 3.63278 3.26985 3.61024 3.30348C3.5877 3.33712 3.56194 3.3686 3.53331 3.39723C3.50469 3.42585 3.47356 3.45161 3.43957 3.47416C3.40594 3.4967 3.37051 3.51566 3.33294 3.53105C3.29537 3.54679 3.25673 3.5586 3.21702 3.56647C3.1773 3.57434 3.13723 3.57828 3.09644 3.57828Z" fill="black"/>
                                                    <path d="M12.9792 3.57828C12.9385 3.57828 12.8984 3.57434 12.8587 3.56647C12.8186 3.5586 12.78 3.54679 12.7427 3.53105C12.7052 3.51566 12.6694 3.4967 12.6358 3.47416C12.6021 3.45161 12.571 3.42585 12.5424 3.39723C12.5134 3.3686 12.488 3.33712 12.4654 3.30348C12.4429 3.26985 12.4239 3.23407 12.4082 3.1965C12.3928 3.15893 12.381 3.12029 12.3731 3.08057C12.3653 3.04086 12.3613 3.00043 12.3613 2.96V1.10516C12.3613 1.06437 12.3653 1.02429 12.3731 0.984578C12.381 0.944862 12.3928 0.905862 12.4082 0.868651C12.4239 0.831082 12.4429 0.795302 12.4654 0.761668C12.488 0.728035 12.5134 0.696549 12.5424 0.667925C12.571 0.639301 12.6021 0.613539 12.6358 0.590997C12.6694 0.568456 12.7052 0.549493 12.7427 0.533749C12.78 0.518364 12.8186 0.506557 12.8587 0.498685C12.8984 0.490813 12.9385 0.486877 12.9792 0.486877C13.0197 0.486877 13.0598 0.490813 13.0995 0.498685C13.1395 0.506557 13.1782 0.518364 13.2154 0.533749C13.253 0.549493 13.2887 0.568456 13.3224 0.590997C13.356 0.613539 13.3871 0.639301 13.4161 0.667925C13.4447 0.696549 13.4702 0.728035 13.4927 0.761668C13.5152 0.795302 13.5346 0.831082 13.5499 0.868651C13.5653 0.905862 13.5771 0.944862 13.585 0.984578C13.5929 1.02429 13.5968 1.06437 13.5968 1.10516V2.96C13.5968 3.00043 13.5929 3.04086 13.585 3.08057C13.5771 3.12029 13.5653 3.15893 13.5499 3.1965C13.5346 3.23407 13.5152 3.26985 13.4927 3.30348C13.4702 3.33712 13.4447 3.3686 13.4161 3.39723C13.3871 3.42585 13.356 3.45161 13.3224 3.47416C13.2887 3.4967 13.253 3.51566 13.2154 3.53105C13.1782 3.54679 13.1395 3.5586 13.0995 3.56647C13.0598 3.57434 13.0197 3.57828 12.9792 3.57828Z" fill="black"/>
                                                    <path d="M3.71094 7.28794H4.94678V8.5245H3.71094V7.28794Z" fill="black"/>
                                                    <path d="M7.41797 7.28794H8.65381V8.5245H7.41797V7.28794Z" fill="black"/>
                                                    <path d="M11.125 7.28794H12.3608V8.5245H11.125V7.28794Z" fill="black"/>
                                                    <path d="M3.71094 10.3793H4.94678V11.6158H3.71094V10.3793Z" fill="black"/>
                                                    <path d="M7.41797 10.3793H8.65381V11.6158H7.41797V10.3793Z" fill="black"/>
                                                    <path d="M11.125 10.3793H12.3608V11.6158H11.125V10.3793Z" fill="black"/>
                                                    <path d="M3.71094 13.4707H4.94678V14.7072H3.71094V13.4707Z" fill="black"/>
                                                    <path d="M7.41797 13.4707H8.65381V14.7072H7.41797V13.4707Z" fill="black"/>
                                                    <path d="M11.125 13.4707H12.3608V14.7072H11.125V13.4707Z" fill="black"/>
                                                    <path d="M15.4525 6.33592H0.623781C0.582992 6.33592 0.542918 6.33199 0.503202 6.32412C0.463486 6.31589 0.424844 6.30444 0.387275 6.2887C0.349706 6.27331 0.314284 6.25435 0.280293 6.2318C0.246659 6.20926 0.215531 6.1835 0.186907 6.15488C0.158282 6.1259 0.132521 6.09477 0.109979 6.06113C0.0874379 6.02714 0.0684745 5.99172 0.0527313 5.95415C0.0373458 5.91658 0.0255385 5.87794 0.0176668 5.83822C0.00979523 5.79851 0.00585938 5.75808 0.00585938 5.71764C0.00585938 5.67686 0.00979523 5.63678 0.0176668 5.59707C0.0255385 5.55699 0.0373458 5.51835 0.0527313 5.48114C0.0684745 5.44357 0.0874379 5.40779 0.109979 5.37416C0.132521 5.34017 0.158282 5.30904 0.186907 5.28041C0.215531 5.25179 0.246659 5.22603 0.280293 5.20349C0.314284 5.18094 0.349706 5.16198 0.387275 5.14624C0.424844 5.13085 0.463486 5.11904 0.503202 5.11117C0.542918 5.1033 0.582992 5.09937 0.623781 5.09937H15.4525C15.4929 5.09937 15.5333 5.1033 15.5731 5.11117C15.6128 5.11904 15.6514 5.13085 15.689 5.14624C15.7265 5.16198 15.762 5.18094 15.7956 5.20349C15.8296 5.22603 15.8607 5.25179 15.8893 5.28041C15.918 5.30904 15.9437 5.34017 15.9663 5.37416C15.9888 5.40779 16.0078 5.44357 16.0232 5.48114C16.0389 5.51835 16.0504 5.55699 16.0586 5.59707C16.0665 5.63678 16.0704 5.67686 16.0704 5.71764C16.0704 5.75808 16.0665 5.79851 16.0586 5.83822C16.0504 5.87794 16.0389 5.91658 16.0232 5.95415C16.0078 5.99172 15.9888 6.02714 15.9663 6.06113C15.9437 6.09477 15.918 6.1259 15.8893 6.15488C15.8607 6.1835 15.8296 6.20926 15.7956 6.2318C15.762 6.25435 15.7265 6.27331 15.689 6.2887C15.6514 6.30444 15.6128 6.31589 15.5731 6.32412C15.5333 6.33199 15.4929 6.33592 15.4525 6.33592Z" fill="black"/>
                                                    </svg>
                                                    {{ pickedProject.sales_start_date }}</div>
                                            <div class="col-md-7">
                                                <svg width="25" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M0.367998 14.6147L8.82695 1.32502C9.38114 0.454287 10.2877 0.454287 10.8424 1.32502L19.3009 14.6147C19.9053 15.5639 19.3758 16.9826 18.4171 16.9826H14.9871L11.9324 12.8522C11.7786 12.6486 11.4889 12.6078 11.2854 12.7612L11.2423 12.7934L10.8724 12.3029C10.3658 11.5707 10.1537 10.8054 10.4294 10.2202C10.6935 9.63287 11.1482 9.05448 11.7418 8.77738C12.3354 8.50074 13.3497 8.66933 13.4456 8.70116C13.5416 8.733 14.1652 8.89172 14.2096 8.84105C14.254 8.78994 14.2365 8.43842 13.7635 8.11693C13.2905 7.79545 12.5206 7.60534 12.5206 7.60534C11.341 7.47666 10.1783 7.64749 8.93949 8.3057C7.70065 8.96346 7.18906 9.45263 6.97384 9.63422C6.75817 9.81536 6.59093 10.0001 6.56941 10.127C6.54744 10.2539 6.59765 10.7179 6.35598 10.8991C6.11476 11.0811 5.7175 10.9955 5.7175 10.9955L5.61079 10.8542C5.53995 10.7601 5.40589 10.7412 5.31173 10.8121L4.00607 11.7936C3.91192 11.8644 3.89309 11.998 3.96438 12.0922L5.56909 14.2197C5.64038 14.3139 5.774 14.3327 5.86816 14.2618L7.16574 13.2862C7.2599 13.2154 7.27873 13.0817 7.20744 12.988L6.92855 12.6181C6.95501 12.2724 7.38051 11.92 7.72665 11.9465C8.07279 11.9725 8.74714 11.9671 9.08252 12.4119C9.4179 12.8562 10.0479 13.6915 10.0479 13.6915L10.0398 13.6978C9.83578 13.8511 9.79498 14.1399 9.94877 14.3439L11.9001 16.9826H1.25218C0.293569 16.9826 -0.235957 15.5639 0.367998 14.6147Z" fill="black"/>
                                                    </svg>
                                                {{ pickedProject.construction_status }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="sort-block" :class="{'sort-display' : sortDisplay}">
                    <div class="sort-label">Sort $PSF By:</div>
                    <div class="row mt-15">
                        <div class="col-xs-6">
                            <div class="sort-btn" @click="sortUpdate('sort-psf', false)">High to Low</div>
                        </div>
                        <div class="col-xs-6">
                            <div class="sort-btn" @click="sortUpdate('sort-psf', true)">Low to High</div>
                        </div>
                    </div>
                    <div class="sort-label">Sort Average Size By:</div>
                    <div class="row mt-15">
                        <div class="col-xs-6">
                            <div class="sort-btn" @click="sortUpdate('sort-size', false)">High to Low</div>
                        </div>
                        <div class="col-xs-6">
                            <div class="sort-btn" @click="sortUpdate('sort-size', true)">Low to High</div>
                        </div>
                    </div>
                </div>
                <div class="result-wrapper row">
                    <div class="result-row focus-target col-xs-6" :marker="key" v-for="(project, key) in projectSort" :key="key" :id="'uid-'+project.uid">
                        <div class="text-center">
                            <div class="result-pic">
                                <img v-if="project.pic && project.pic != 'https://www.realpropertydata.ca/backend/'" :src="project.pic">
                                <img v-else src="/images/assets/placeholder.png">
                            </div>
                            <div class="result-status" :class="getColor(project.status)">{{project.status}}</div>
                            <div class="result-city">{{project.city}}</div>
                            <div class="row">
                                <div class="col-md-4 result-name" style="text-align: left;">${{project.total_avg_price | numFormat}}</div>
                                <div v-if="project.name && project.name.length > 18" @click="openModal(project)"  style="text-align: right" class="result-name col-md-8" v-b-popover="{customClass: 'popover-custom', content: project.name, trigger: 'hover', placement: 'top'}">
                                    {{project.name.substring(0,18)+".."}}
                                </div>
                                <div v-else @click="openModal(project)" class="result-name col-md-8" style="text-align: right">{{project.name}}</div>
                            </div>
                            <div class="result-type" style="display: block; height: 25px; margin-top: 5px;">
                                <span style="font-size: 1rem; font-weight: normal; float: left;">Avg Size: <strong>{{project.total_avg_size }}</strong></span>
                                <span style="float: right; font-size: 1rem; font-weight: normal;">Avg $PSF: <strong>{{project.total_avg_psf }}</strong></span>
                            </div>
                            <div class="row" style="margin-left: 0; margin-right: 0; margin-top: 5px;">
                                <div class="square-wrapper">
                                    <div class="square-blue">
                                        <div>Total Units:</div>
                                        <div><strong>{{ project.total_units }}</strong></div>
                                    </div>
                                </div>
                                <div class="square-wrapper">
                                    <div class="square-blue">
                                        <div>Rlsd Units:</div>
                                        <div><strong>{{ project.rlsd_units }}</strong></div>
                                    </div>
                                </div>
                                <div class="square-wrapper">
                                    <div class="square-blue">
                                        <div>Sold Units:</div>
                                        <div><strong>{{ project.sold_units }}</strong></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Map -->
            <div class="map-container column-map right-pos-map map-col" style="height: 100%;" :class="{'left-on' : searchStarted, 'right-on' : !rightToggle, 'right-collapse': !rightCollapse, 'land-on': currentTab == 'land'}">
                <img v-if="is_loading" style="width: 50%;" src="/images/spinner.gif">
                <div id="map-main"></div>
                <div class="marker-status hidden-xs">
                    <div class="status-row">
                        <span class="status-in">In Planning</span>
                        <span class="status-selling-soon">Selling Soon</span>
                        <span class="status-now-selling">Now Selling</span>
                        <span class="status-sold-out">Sold Out</span>
                    </div>
                    <div class="status-row">
                        <span class="status-in">In Planning</span>
                        <span class="status-leasing-soon">Leasing Soon</span>
                        <span class="status-now-leasing">Now Leasing</span>
                        <span class="status-leased-out">Leased Out</span>
                    </div>
                </div>
                <div class="marker-sample hidden-xs">
                    <div class="row">
                        <div class="col-xs-12 text-left marker-shape"><span class="circle marker-icon"></span><span class="marker-label"> Apartment</span></div>
                    </div>
                    <div class="row">
                        <div class="col-xs-12 text-left marker-shape"><span class="triangle marker-icon"></span><span class="marker-label"> Townhome</span></div>
                    </div>
                    <div class="row">
                        <div class="col-xs-12 text-left marker-shape"><span class="square marker-icon"></span><span class="marker-label"> Commercial</span></div>
                    </div>
                    <div class="row">
                        <div class="col-xs-12 text-left marker-shape"><span class="indust marker-icon"></span><span class="marker-label"> Industrial</span></div>
                    </div>
                    <!-- <div class="row">
                        <div class="col-xs-12 text-center in-planning-legend"><span class="circle"></span><span class="marker-label"> In Planning</span></div>
                    </div>
                    <div class="row">
                        <div class="col-xs-6 text-left selling-soon-legend">
                            <span class="circle"></span><span class="marker-label"> Selling Soon</span>
                        </div>
                        <div class="col-xs-6 text-left leasing-soon-legend">
                            <span class="circle"></span><span class="marker-label"> Leasing Soon</span>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-xs-6 text-left now-selling-legend">
                            <span class="circle"></span><span class="marker-label"> Now Selling</span>
                        </div>
                        <div class="col-xs-6 text-left now-leasing-legend">
                            <span class="circle"></span><span class="marker-label"> Now Leasing</span>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-xs-6 text-left sold-out-legend">
                            <span class="circle"></span><span class="marker-label"> Sold Out</span>
                        </div>
                        <div class="col-xs-6 text-left leased-out-legend">
                            <span class="circle"></span><span class="marker-label"> Leased Out</span>
                        </div>
                    </div> -->
                </div>
                <div class="poly-clean" title="Clean"><span><i class="fa fa-music"></i></span></div>
                <div class="scrollContorl mapnavbtn" title="Enable Scrolling"><span><i class="fa fa-lock"></i></span></div>
            </div>
            <!-- Map end -->          
            <!--col-list-wrap -->   
            <div class="left-info" :class="{'left-activated' : searchStarted, 'left-disabled' : !searchStarted}">
                <img class="info-open" src="/images/assets/open.png" @click="toggleListing()" v-b-popover="{customClass: 'popover-icons', content: 'Switch to Listing', trigger: 'hover', placement: 'top'}">
                <img class="info-collapse" src="/images/assets/collapse.svg" @click="searchStarted = !searchStarted" v-b-popover="{customClass: 'popover-icons', content: 'Close Search Bar', trigger: 'hover', placement: 'top'}">
            </div>
            <div class="col-list-wrap left-menu max-h-100" :class="{'left-disabled' : searchStarted, 'right-list' : currentTab == 'land', 'left-list' : currentTab != 'land'}">
                <div class="listsearch-options fl-wrap" id="lisfw">
                    <!-- <div class="menu-switch hidden-xs hidden-sm" @click="toggleMenu"><svg class="toggle-menu" width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="14" cy="14" r="14" fill="#1F293F"/>
                        <path d="M20.8987 13.1375L10.4042 13.1375L15.2246 8.31719L14.0001 7.10132L7.10156 13.9999L14.0001 20.8984L15.216 19.6826L10.4042 14.8622L20.8987 14.8622V13.1375Z" fill="white"/>
                        </svg>
                    </div> -->
                    <div class="small-container text-lg-left new-list-wrapper">
                        <div class="project-type-filter text-left"></div>
                        <div class="start-label">Let's Start</div>
                        <b-tabs style="clear: left;">
                            <b-tab title="Projects" :active="!planningTab" @click="cleanOpt('1')">
                                <!-- listsearch-input-wrap  -->  
                                <div class="row new-list mt-20">
                                    <div class="col-lg-12 pt-10">
                                        <div class="row">
                                            <div class="col-sm-12 text-left">
                                                <h3 class="filter-label">Region Location</h3>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <!-- <div class="col-xs-6">
                                                <div class="filter-checkbox mt-10" style="margin-right: -10px;">
                                                    <span style="float: left;margin-top: 17px;font-size: 1.5rem;font-weight: bold;margin-left: 10px;">GV: </span>
                                                    <treeselect class="city-special" v-model="gvCitiesSelected" :multiple="true" :flat="true" :options="gvCityOptions"/>
                                                </div>
                                            </div>
                                            <div class="col-xs-6">
                                                <div class="filter-checkbox mt-10" style="margin-right: -10px;">
                                                    <span style="float: left;margin-top: 17px;font-size: 1.5rem;font-weight: bold;margin-left: 10px;">FV: </span>
                                                    <treeselect class="city-special" v-model="fvCitiesSelected" :multiple="true" :flat="true" :options="fvCityOptions"/>
                                                </div>
                                            </div> -->
                                            <div class="col-xs-6" v-click-outside="gvOff">
                                                <div class="type-filter-button-sm-wrap" @click="openGV()">
                                                    <div class="text-left" :class="{buttonWithOpt: citiesSelected.some(g => gvCities.includes(g))}"><span style="float: left; margin-top: 7px;">GV: </span> <span class="choosen-opts" v-for="(city, index) in citiesSelected.filter(g => gvCities.includes(g))" :key="index" @click="removeCity(index)">{{nameSwitch(city)}}</span></div>
                                                </div>
                                                <div class="sale-pop dropdown-background-grey scroll-popup" :class="{active: gvOptions}">
                                                    <input class="checkbox-square" type="checkbox" id="vancouver" value="2895" v-model="citiesSelected">
                                                    <label for="vancouver"> Vancouver</label><br>
                                                    <input class="checkbox-square" type="checkbox" id="coquitlam" value="2874" v-model="citiesSelected">
                                                    <label for="coquitlam"> Coquitlam</label><br>
                                                    <input class="checkbox-square" type="checkbox" id="burnaby" value="2873" v-model="citiesSelected">
                                                    <label for="burnaby"> Burnaby</label><br>
                                                    <input class="checkbox-square" type="checkbox" id="richmond" value="2877" v-model="citiesSelected">
                                                    <label for="richmond"> Richmond</label><br>
                                                    <input class="checkbox-square" type="checkbox" id="north_van_city" value="2949" v-model="citiesSelected">
                                                    <label for="north_van_city"> North Van (City)</label><br>
                                                    <input class="checkbox-square" type="checkbox" id="new_westminster" value="2889" v-model="citiesSelected">
                                                    <label for="new_westminster"> New Westminster</label><br>
                                                    <input class="checkbox-square" type="checkbox" id="north_vancouver_district" value="2950" v-model="citiesSelected">
                                                    <label for="north_vancouver_district"> North Van (Dist)</label><br>
                                                    <input class="checkbox-square" type="checkbox" id="west_vancouver" value="2896" v-model="citiesSelected">
                                                    <label for="west_vancouver"> West Vancouver</label><br>
                                                    <input class="checkbox-square" type="checkbox" id="squamish" value="2894" v-model="citiesSelected">
                                                    <label for="squamish"> Squamish</label><br>
                                                    <input class="checkbox-square" type="checkbox" id="port_coquitlam" value="2892" v-model="citiesSelected">
                                                    <label for="port_coquitlam"> Port Coquitlam</label><br>
                                                    <input class="checkbox-square" type="checkbox" id="port_moody" value="2893" v-model="citiesSelected">
                                                    <label for="port_moody"> Port Moody</label><br>
                                                    <input class="checkbox-square" type="checkbox" id="maple_ridge" value="2888" v-model="citiesSelected">
                                                    <label for="maple_ridge"> Maple Ridge</label><br>
                                                    <input class="checkbox-square" type="checkbox" id="pitt_meadows" value="2891" v-model="citiesSelected">
                                                    <label for="pitt_meadows"> Pitt Meadows</label><br>
                                                </div>
                                            </div>
                                            <div class="col-xs-6" v-click-outside="fvOff">
                                                <div class="type-filter-button-sm-wrap" @click="openFV()">
                                                    <div class="text-left" :class="{buttonWithOpt: citiesSelected.some(g => fvCities.includes(g))}"><span style="float: left; margin-top: 7px;">FV: </span> <span class="choosen-opts" v-for="(city, index) in citiesSelected.filter(g => fvCities.includes(g))" :key="index" @click="removeCity(index)">{{nameSwitch(city)}}</span></div>
                                                </div>
                                                <div class="sale-pop dropdown-background-grey scroll-popup" :class="{active: fvOptions}">
                                                    <input class="checkbox-square" type="checkbox" id="surrey" value="2887" v-model="citiesSelected">
                                                    <label for="surrey"> Surrey</label><br>
                                                    <input class="checkbox-square" type="checkbox" id="langley_township" value="2879" v-model="citiesSelected">
                                                    <label for="langley_township"> Langley (Township)</label><br>
                                                    <input class="checkbox-square" type="checkbox" id="langley_city" value="3556" v-model="citiesSelected">
                                                    <label for="langley_city"> Langley (City)</label><br>
                                                    <input class="checkbox-square" type="checkbox" id="abbotsford" value="2876" v-model="citiesSelected">
                                                    <label for="abbotsford"> Abbotsford</label><br>
                                                    <input class="checkbox-square" type="checkbox" id="delta" value="2898" v-model="citiesSelected">
                                                    <label for="delta"> Delta</label><br>
                                                    <input class="checkbox-square" type="checkbox" id="mission" value="3609" v-model="citiesSelected">
                                                    <label for="mission"> Mission</label><br>
                                                    <input class="checkbox-square" type="checkbox" id="white_rock" value="2897" v-model="citiesSelected">
                                                    <label for="white_rock"> White Rock</label><br>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-12 text-left">
                                                <h3 class="filter-label">Transaction Type</h3>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-xs-6" v-click-outside="residentialOff">
                                                <div class="type-filter-button-sm-wrap" @click="openResidential()">
                                                    <div class="text-left" :class="{buttonWithOpt: (gutSelected.includes('2952') || gutSelected.includes('2954') || gutSelected.includes('2975') || gutSelected.includes('2953') || gutSelected.includes('2954') || typeSelected.includes('2886') || typeSelected.includes('2884') || typeSelected.includes('2870') || typeSelected.includes('3479'))}"><span style="float: left; margin-top: 7px;">Residential: </span> <span class="choosen-opts" v-for="(gut, index) in gutSelected.filter(g => ['2952', '2954', '2975', '2953', '2954'].includes(g))" :key="index" @click="removeGut(index)">{{nameSwitch(gut)}}</span> <span class="choosen-opts" v-for="(type, index) in typeSelected.filter(s => ['2886', '2884', '2870', '3479'].includes(s))" :key="index" @click="removeType(index)">{{typeName(type)}}</span> <span class="choosen-opts" v-for="(status, index) in statusSelected.filter(s => ['now_selling', 'sold_out'].includes(s))" :key="index" @click="removeStatus(index)">{{nameSwitch(status)}}</span> <span class="choosen-opts" v-for="(status, index) in statusSelected.filter(s => ['now_leasing', 'leased_out'].includes(s))" :key="index" @click="removeStatus(index)">{{nameSwitch(status)}}</span></div>
                                                </div>
                                                <div class="sale-pop dropdown-background-grey" :class="{active: residentialOption}">
                                                    <!-- <input class="checkbox-square" type="checkbox" id="residential_apartment" value="2886" v-model="typeSelected">
                                                    <label for="residential_apartment"> Apartment</label><br>
                                                    <input class="checkbox-square" type="checkbox" id="residential_mixed" value="2884" v-model="typeSelected">
                                                    <label for="residential_mixed"> Mixed-Use Apartment</label><br>
                                                    <input class="checkbox-square" type="checkbox" id="residential_townhome" value="2870" v-model="typeSelected">
                                                    <label for="residential_townhome"> Townhome</label><br>
                                                    <input class="checkbox-square" type="checkbox" id="residential_stacked_townhome" value="3479" v-model="typeSelected">
                                                    <label for="residential_stacked_townhome"> Stacked Townhome</label><br>
                                                    <div style="border-bottom: 3px solid #13293E; margin: 20px -20px;"></div> -->
                                                    <input class="checkbox-square" type="checkbox" id="market_strata" value="2952" v-model="gutSelected">
                                                    <label for="market_strata"> Market Strata</label><br>
                                                    <span class="st-symbol">⤷</span><input style="margin-left: 8px;" class="checkbox-square" type="checkbox" id="now_selling" value="now_selling" v-model="statusSelected">
                                                    <label for="now_selling"> Now Selling</label><br>
                                                    <span class="st-symbol">⤷</span><input style="margin-left: 8px;" class="checkbox-square" type="checkbox" id="sold_out" value="sold_out" v-model="statusSelected">
                                                    <label for="sold_out"> Sold Out</label><br>
                                                    <input class="checkbox-square" type="checkbox" id="market_rental" value="2954" v-model="gutSelected">
                                                    <label for="market_rental"> Market Rental</label><br>
                                                    <span class="st-symbol">⤷</span><input style="margin-left: 8px;" class="checkbox-square" type="checkbox" id="now_leasing" value="now_leasing" v-model="statusSelected">
                                                    <label for="now_leasing"> Now Leasing</label><br>
                                                    <span class="st-symbol">⤷</span><input style="margin-left: 8px;" class="checkbox-square" type="checkbox" id="leased_out" value="leased_out" v-model="statusSelected">
                                                    <label for="leased_out"> Leased Out</label>
                                                </div>
                                            </div>
                                            <div class="col-xs-6" v-click-outside="commercialOff">
                                                <div class="type-filter-button-sm-wrap" @click="openCommercial()">
                                                    <div class="text-left" :class="{buttonWithOpt: (gutSelected.includes('3031') || gutSelected.includes('2960') || gutSelected.includes('3515'))}"><span style="float: left; margin-top: 7px;">Commercial: </span> <span class="choosen-opts" v-for="(gut, index) in gutSelected.filter(g => ['3031', '2960', '3515'].includes(g))" :key="index" @click="removeGut(index)">{{nameSwitch(gut)}}</span></div>
                                                </div>
                                                <div class="sale-pop dropdown-background-grey" :class="{active: commercialOptions}">
                                                    <input class="checkbox-square" type="checkbox" id="commercial_office" value="3031" v-model="gutSelected">
                                                    <label for="commercial_office"> Office</label><br>
                                                    <input class="checkbox-square" type="checkbox" id="commercial_retail" value="2960" v-model="gutSelected">
                                                    <label for="commercial_retail"> Retail</label><br>                                                    
                                                    <input class="checkbox-square" type="checkbox" id="commercial_industrial" value="3515" v-model="gutSelected">
                                                    <label for="commercial_industrial"> Industrial</label><br>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-12 text-left">
                                                <h3 class="filter-label">Project Search</h3>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-12 developer-input">
                                                 <autocomplete
                                                    :search="nameSearch"
                                                    placeholder="Project Name, Address"
                                                    aria-label="Name"
                                                    :get-result-value="getNameResultValue"
                                                    @submit="onNameSubmit"
                                                >
                                                    <template #result="{ result, props }">
                                                        <li v-bind="props">
                                                            <div class="wiki-title">
                                                                <div class="auto-title">{{ result.title }}</div>
                                                                <div class="auto-second">{{ result.second }}</div>
                                                            </div>
                                                        </li>
                                                    </template>
                                                </autocomplete>
                                                <!-- <div class="filter-checkbox mt-10">
                                                    <treeselect class="no-extra-p-l" v-model="listSearch" :multiple="true" :async="true" :load-options="listSearchOptions" />
                                                </div> -->
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-12 text-left">
                                                <h3 class="filter-label">Developer Search</h3>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-12 developer-input">
                                                <autocomplete
                                                    data-position="below"
                                                    :search="devSearch"
                                                    placeholder="Developer"
                                                    aria-label="Developer"
                                                    :get-result-value="getResultValue"
                                                    @submit="onSubmit"
                                                ></autocomplete>
                                                <!-- <div class="filter-checkbox mt-10">
                                                    <treeselect class="no-extra-p-l" v-model="developerSearch" :multiple="true" :async="true" :load-options="developerOptions" />
                                                </div> -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <!-- <div class="col-sm-6 text-center">
                                        <img class="info-open" src="/images/assets/open.png" @click="onReport(true)">
                                        <div class="filter-update hollow text-center" style="background: #495F74;"  @click="onReport(false)">FIND PROJECTS</div>
                                    </div> -->
                                    <div class="col-sm-12 text-center">
                                        <div class="filter-update hollow text-center" style="background: #476E93;" @click="onReport(true)">SUMMARY RESULTS</div>
                                    </div>
                                </div>
                                <div class="row mt-30" style="align-items: center;">
                                    <div class="col-sm-12">
                                        <img class="left-toggle" src="/images/assets/collapse.svg" @click="searchStarted = !searchStarted" v-b-popover="{customClass: 'popover-icons', content: 'Close Search Bar', trigger: 'hover', placement: 'top'}">
                                        <img class="info-open-inline" style="margin-right: 50px;" src="/images/assets/open.png" @click="onReport(true)" v-b-popover="{customClass: 'popover-icons', content: 'Map View', trigger: 'hover', placement: 'top'}">
                                    </div>
                                </div>
                                <b-modal id="transaction-modal" ref="transaction-modal" hide-footer hide-header no-close-on-esc no-close-on-backdrop>
                                    <div style="font-size: 2rem; min-height: 300px; align-items: center;justify-content: center; display: flex;">{{switchMessage}}</div>
                                    <div class="row mt-20">
                                        <div class="col-sm-6 text-center">
                                            <div v-if="removeSaleVal" class="filter-update hollow text-center" style="background: #495F74;"  @click="removeSale()">Yes</div>
                                            <div v-else class="filter-update hollow text-center" style="background: #495F74;"  @click="removeLease()">Yes</div>
                                        </div>
                                        <div class="col-sm-6 text-center">
                                            <div v-if="removeSaleVal" class="filter-update hollow text-center" style="background: #476E93;" @click="removeLease()">No</div>
                                            <div v-else class="filter-update hollow text-center" style="background: #476E93;" @click="removeSale()">No</div>
                                        </div>
                                    </div>
                                </b-modal>
                                <!-- listsearch-input-wrap end -->
                            </b-tab>
                            <b-tab title="Planning" :disabled="role == 'plan_a'" :active="planningTab" @click="cleanOpt('2')">
                                <div class="row new-list">
                                    <div class="col-lg-12 pt-10">
                                        <div class="row">
                                            <div class="col-sm-12 text-left">
                                                <h3 class="filter-label">Region Location</h3>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-xs-6" v-click-outside="gvPlanningOff">
                                                <div class="type-filter-button-sm-wrap" @click="openPlanningGV()">
                                                    <div class="text-left" :class="{buttonWithOpt: citiesSelected.some(g => gvCities.includes(g))}"><span style="float: left; margin-top: 7px;">GV: </span> <span class="choosen-opts" v-for="(city, index) in citiesSelected.filter(g => gvCities.includes(g))" :key="index" @click="removeCity(index)">{{nameSwitch(city)}}</span></div>
                                                </div>
                                                <div class="sale-pop dropdown-background-grey scroll-popup" :class="{active: gvPlanningOptions}">
                                                    <input class="checkbox-square" type="checkbox" id="planning_vancouver" value="2895" v-model="citiesSelected">
                                                    <label for="planning_vancouver"> Vancouver</label><br>
                                                    <input class="checkbox-square" type="checkbox" id="planning_coquitlam" value="2874" v-model="citiesSelected">
                                                    <label for="planning_coquitlam"> Coquitlam</label><br>
                                                    <input class="checkbox-square" type="checkbox" id="planning_burnaby" value="2873" v-model="citiesSelected">
                                                    <label for="planning_burnaby"> Burnaby</label><br>
                                                    <input class="checkbox-square" type="checkbox" id="planning_richmond" value="2877" v-model="citiesSelected">
                                                    <label for="planning_richmond"> Richmond</label><br>
                                                    <input class="checkbox-square" type="checkbox" id="planning_north_van_city" value="2949" v-model="citiesSelected">
                                                    <label for="planning_north_van_city"> North Van (City)</label><br>
                                                    <input class="checkbox-square" type="checkbox" id="planning_new_westminster" value="2889" v-model="citiesSelected">
                                                    <label for="planning_new_westminster"> New Westminster</label><br>
                                                    <input class="checkbox-square" type="checkbox" id="planning_north_vancouver_district" value="2950" v-model="citiesSelected">
                                                    <label for="planning_north_vancouver_district"> North Van (Dist)</label><br>
                                                    <input class="checkbox-square" type="checkbox" id="planning_west_vancouver" value="2896" v-model="citiesSelected">
                                                    <label for="planning_west_vancouver"> West Vancouver</label><br>
                                                    <input class="checkbox-square" type="checkbox" id="planning_squamish" value="2894" v-model="citiesSelected">
                                                    <label for="planning_squamish"> Squamish</label><br>
                                                    <input class="checkbox-square" type="checkbox" id="planning_port_coquitlam" value="2892" v-model="citiesSelected">
                                                    <label for="planning_port_coquitlam"> Port Coquitlam</label><br>
                                                    <input class="checkbox-square" type="checkbox" id="planning_port_moody" value="2893" v-model="citiesSelected">
                                                    <label for="planning_port_moody"> Port Moody</label><br>
                                                    <input class="checkbox-square" type="checkbox" id="planning_maple_ridge" value="2888" v-model="citiesSelected">
                                                    <label for="planning_maple_ridge"> Maple Ridge</label><br>
                                                    <input class="checkbox-square" type="checkbox" id="planning_pitt_meadows" value="2891" v-model="citiesSelected">
                                                    <label for="planning_pitt_meadows"> Pitt Meadows</label><br>
                                                </div>
                                            </div>
                                            <div class="col-xs-6" v-click-outside="fvPlanningOff">
                                                <div class="type-filter-button-sm-wrap" @click="openPlanningFV()">
                                                    <div class="text-left" :class="{buttonWithOpt: citiesSelected.some(g => fvCities.includes(g))}"><span style="float: left; margin-top: 7px;">FV: </span> <span class="choosen-opts" v-for="(city, index) in citiesSelected.filter(g => fvCities.includes(g))" :key="index" @click="removeCity(index)">{{nameSwitch(city)}}</span></div>
                                                </div>
                                                <div class="sale-pop dropdown-background-grey scroll-popup" :class="{active: fvPlanningOptions}">
                                                    <input class="checkbox-square" type="checkbox" id="planning_surrey" value="2887" v-model="citiesSelected">
                                                    <label for="planning_surrey"> Surrey</label><br>
                                                    <input class="checkbox-square" type="checkbox" id="planning_langley_township" value="2879" v-model="citiesSelected">
                                                    <label for="planning_langley_township"> Langley (Township)</label><br>
                                                    <input class="checkbox-square" type="checkbox" id="planning_langley_city" value="3556" v-model="citiesSelected">
                                                    <label for="planning_langley_city"> Langley (City)</label><br>
                                                    <input class="checkbox-square" type="checkbox" id="planning_abbotsford" value="2876" v-model="citiesSelected">
                                                    <label for="planning_abbotsford"> Abbotsford</label><br>
                                                    <input class="checkbox-square" type="checkbox" id="planning_delta" value="2898" v-model="citiesSelected">
                                                    <label for="planning_delta"> Delta</label><br>
                                                    <input class="checkbox-square" type="checkbox" id="planning_mission" value="3609" v-model="citiesSelected">
                                                    <label for="planning_mission"> Mission</label><br>
                                                    <input class="checkbox-square" type="checkbox" id="planning_white_rock" value="2897" v-model="citiesSelected">
                                                    <label for="planning_white_rock"> White Rock</label><br>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-12 text-left">
                                                <h3 class="filter-label">Transaction Type</h3>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-xs-6" v-click-outside="salePlanningOff">
                                                <div class="type-filter-button-sm-wrap" @click="openPlanningSale()">
                                                    <div class="text-left" :class="{buttonWithOpt: (gutSelected.includes('2952') || gutSelected.includes('2954') || gutSelected.includes('2970'))}"><span style="float: left; margin-top: 7px;">Residential: </span> <span class="choosen-opts" v-for="(gut, index) in gutSelected.filter(g => ['2952', '2954', '2970'].includes(g))" :key="index" @click="removeGut(index)">{{nameSwitch(gut)}}</span></div>
                                                </div>
                                                <div class="sale-pop dropdown-background-grey" :class="{active: salePlanningOptions}">
                                                    <input class="checkbox-square" type="checkbox" id="planning_market_strata" value="2952" v-model="gutSelected">
                                                    <label for="planning_market_strata"> Market Strata</label><br>
                                                    <input class="checkbox-square" type="checkbox" id="planning_market_rental" value="2954" v-model="gutSelected">
                                                    <label for="planning_market_rental"> Market Rental</label><br>
                                                    <!-- <input class="checkbox-square" type="checkbox" id="planning_secured_market_rental" value="2970" v-model="gutSelected">
                                                    <label for="planning_secured_market_rental"> Secured Market Rental</label> -->
                                                </div>
                                            </div>

                                             <div class="col-xs-6" v-click-outside="leasePlanningOff">
                                                <div class="type-filter-button-sm-wrap" @click="openPlanningLease()">
                                                    <div class="text-left" :class="{buttonWithOpt: (gutSelected.includes('2960') || gutSelected.includes('3031') || gutSelected.includes('3515'))}"><span style="float: left; margin-top: 7px;">Commercial: </span> <span class="choosen-opts" v-for="(gut, index) in gutSelected.filter(g => ['2960', '3031', '3515'].includes(g))" :key="index" @click="removeGut(index)">{{nameSwitch(gut)}}</span></div>
                                                </div>
                                                <div class="sale-pop dropdown-background-grey" :class="{active: leasePlanningOptions}">
                                                    <input class="checkbox-square" type="checkbox" id="planning_office" value="3031" v-model="gutSelected">
                                                    <label for="planning_office"> Office</label><br>
                                                    <input class="checkbox-square" type="checkbox" id="planning_retail" value="2960" v-model="gutSelected">
                                                    <label for="planning_retail"> Retail</label><br>
                                                    <input class="checkbox-square" type="checkbox" id="planning_industrial" value="3515" v-model="gutSelected">
                                                    <label for="planning_industrial"> Industrial</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-12 text-left">
                                                <h3 class="filter-label">Project Search</h3>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-12 developer-input">
                                                 <autocomplete
                                                    :search="nameSearch"
                                                    placeholder="Project Name, Address"
                                                    aria-label="Name"
                                                    :get-result-value="getNameResultValue"
                                                    @submit="onNameSubmit"
                                                >
                                                    <template #result="{ result, props }">
                                                        <li v-bind="props">
                                                            <div class="wiki-title">
                                                                <div class="auto-title">{{ result.title }}</div>
                                                                <div class="auto-second">{{ result.second }}</div>
                                                            </div>
                                                        </li>
                                                    </template>
                                                </autocomplete>
                                                <!-- <div class="filter-checkbox mt-10">
                                                    <treeselect class="no-extra-p-l" v-model="listSearch" :multiple="true" :async="true" :load-options="listSearchOptions" />
                                                </div> -->
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-12 text-left">
                                                <h3 class="filter-label">Developer Search</h3>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-12 developer-input">
                                                <autocomplete
                                                    data-position="below"
                                                    :search="devSearch"
                                                    placeholder="Developer"
                                                    aria-label="Developer"
                                                    :get-result-value="getResultValue"
                                                    @submit="onSubmit"
                                                ></autocomplete>
                                                <!-- <div class="filter-checkbox mt-10">
                                                    <treeselect class="no-extra-p-l" v-model="developerSearch" :multiple="true" :async="true" :load-options="developerOptions" />
                                                </div> -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-20">
                                    <div class="col-sm-12 text-left">
                                        <h3 class="filter-label">Permits &amp; Bylaws</h3>
                                    </div>
                                </div>
                                <div class="row new-list">
                                    <div class="col-lg-6 pt-20">
                                        <div class="row">
                                            <div class="col-sm-12 text-left">
                                                <div class="filter-checkbox">
                                                    <h3 class="ptitle">RZ:</h3>
                                                    <treeselect v-model="rezoningSelected" :multiple="true" :flat="true" :options="rezoningOptions" :autoSelectDescendants="true" :limitText="() => '+'"/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 pt-20">
                                        <div class="row">
                                            <div class="col-sm-12 text-left">
                                                <div class="filter-checkbox filter-checkbox-longer">
                                                    <h3 class="ptitle">OCP:</h3>
                                                    <treeselect v-model="ocpSelected" :multiple="true" :flat="true" :options="rezoningOptions" :autoSelectDescendants="true" :limitText="() => '+'"/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row new-list">
                                    <div class="col-lg-6 pt-20">
                                        <div class="row">
                                            <div class="col-sm-12 text-left">
                                                <div class="filter-checkbox">
                                                    <h3 class="ptitle">DP:</h3>
                                                    <treeselect v-model="dpSelected" :multiple="true" :flat="true" :options="dpOptions" :autoSelectDescendants="true"  :limitText="() => '+'"/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 pt-20">
                                        <div class="row">
                                            <div class="col-sm-12 text-left">
                                                <div class="filter-checkbox filter-checkbox-longer">
                                                    <h3 class="ptitle">DVP:</h3>
                                                    <treeselect v-model="dvpSelected" :multiple="true" :flat="true" :options="dpOptions" :autoSelectDescendants="true" :limitText="() => '+'"/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row new-list">
                                    <div class="col-lg-6 pt-20">
                                        <div class="row">
                                            <div class="col-sm-12 text-left">
                                                <div class="filter-checkbox">
                                                    <h3 class="ptitle">BP:</h3>
                                                    <treeselect v-model="bpSelected" :multiple="true" :flat="true" :options="bpOptions" :autoSelectDescendants="true" :limitText="() => '+'"/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 pt-20">
                                        <div class="row">
                                            <div class="col-sm-12 text-left">
                                                <div class="filter-checkbox filter-checkbox-longer">
                                                    <h3 class="ptitle">Sub:</h3>
                                                    <treeselect v-model="subSelected" :multiple="true" :flat="true" :options="bpOptions" :autoSelectDescendants="true" :limitText="() => '+'"/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-6 text-center">
                                        <!-- <img class="info-open" src="/images/assets/open.png" @click="PlanningUTCGo(true)"> -->
                                        <div class="filter-update hollow text-center" style="background: #495F74;"  @click="PlanningUTCGo(true)">FIND PROJECTS</div>
                                    </div>
                                    <div class="col-sm-6 text-center">
                                        <div class="filter-update hollow text-center" style="background: #495F74;" @click="PlanningUTCGo(false)">SUMMARY RESULTS</div>
                                    </div>
                                    <div class="col-sm-12 text-center">
                                        <div class="filter-update hollow text-center" style="background: #426586;" @click="PlanningGo()">CITY UPDATES</div>
                                    </div>
                                </div>
                                <div class="row mt-30" style="align-items: center;">
                                    <div class="col-sm-12">
                                        <img class="left-toggle" src="/images/assets/collapse.svg" @click="searchStarted = !searchStarted" v-b-popover="{customClass: 'popover-icons', content: 'Close Search Bar', trigger: 'hover', placement: 'top'}">
                                    </div>
                                </div>
                            </b-tab>
                            <b-tab title="Units" :disabled="role == 'plan_a'" @click="cleanOpt('4')">
                                 <div class="row new-list-unit">
                                    <div class="col-lg-6 pt-20">
                                        <div class="row">
                                            <div class="col-sm-12 text-left p-0">
                                                <h3 class="filter-label">City</h3>
                                                <div class="filter-checkbox mt-10 mx-0">
                                                    <treeselect v-model="mlsCitiesSelected" :multiple="true" :flat="true" :options="cityoptions" :limit="3"/>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-12 text-left p-0">
                                                <h3 class="filter-label">General Unit Type</h3>
                                                <div class="filter-checkbox mt-10 mx-0">
                                                    <treeselect v-model="gutMLSSelected" :multiple="true" :flat="true" :options="gutUnitoptions" :autoSelectDescendants="true" :limit="3"/>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-12 text-left p-0">
                                                <h3 class="filter-label">FP Specs</h3>
                                                <div class="filter-checkbox mt-10 mx-0">
                                                    <treeselect v-model="fpSpecsSelected" :multiple="true" :flat="true" :options="mlsFP"/>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <!-- <div class="row mt-20">
                                            <div class="col-sm-12 text-left developer-input">
                                                <h3 class="filter-label">Project Type</h3>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-lg-12 developer-input">
                                                <div class="type-filter-button-sm" @click="toggleBool('aptMLSIsActive')" :class="{selected: aptMLSIsActive}">
                                                    <div>Apartment</div>
                                                    <svg class="apt-check filter-button-check" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <circle cx="5" cy="5" r="5" fill="#4D7CE1"/>
                                                        <path d="M2.77772 4.99991L4.24997 6.66361L7.22221 3.33323" stroke="white" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                </div>
                                            </div>
                                            <div class="col-lg-12 developer-input">
                                                <div class="type-filter-button-sm" @click="toggleBool('mixedUseAptMLSIsActive')" :class="{selected: mixedUseAptMLSIsActive}">
                                                    <div>Mixed-Use Apartment</div>
                                                    <svg class="mixed-user-check filter-button-check" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <circle cx="5" cy="5" r="5" fill="#4D7CE1"/>
                                                        <path d="M2.77772 4.99991L4.24997 6.66361L7.22221 3.33323" stroke="white" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-lg-12 developer-input">
                                                <div class="type-filter-button-sm" @click="toggleBool('townhomeMLSIsActive')" :class="{selected: townhomeMLSIsActive}">
                                                    <div>Townhome</div>
                                                    <svg class="townhome-check filter-button-check" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <circle cx="5" cy="5" r="5" fill="#4D7CE1"/>
                                                        <path d="M2.77772 4.99991L4.24997 6.66361L7.22221 3.33323" stroke="white" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                </div>
                                            </div>
                                            <div class="col-lg-12 developer-input">
                                                <div class="type-filter-button-sm" @click="toggleBool('stackedTownhomeMLSIsActive')" :class="{selected: stackedTownhomeMLSIsActive}">
                                                    <div>Stacked Townhome</div>
                                                    <svg class="stacked-townhome-check filter-button-check" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <circle cx="5" cy="5" r="5" fill="#4D7CE1"/>
                                                        <path d="M2.77772 4.99991L4.24997 6.66361L7.22221 3.33323" stroke="white" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-lg-12 developer-input">
                                                <div class="type-filter-button-sm" @click="toggleBool('commercialMLSIsActive')" :class="{selected: commercialMLSIsActive}">
                                                    <div>Commercial</div>
                                                    <svg class="stacked-townhome-check filter-button-check" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <circle cx="5" cy="5" r="5" fill="#4D7CE1"/>
                                                        <path d="M2.77772 4.99991L4.24997 6.66361L7.22221 3.33323" stroke="white" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                </div>
                                            </div>
                                            <div class="col-lg-12 developer-input">
                                                <div class="type-filter-button-sm" @click="toggleBool('industrialMLSIsActive')" :class="{selected: industrialMLSIsActive}">
                                                    <div>Industrial</div>
                                                    <svg class="stacked-townhome-check filter-button-check" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <circle cx="5" cy="5" r="5" fill="#4D7CE1"/>
                                                        <path d="M2.77772 4.99991L4.24997 6.66361L7.22221 3.33323" stroke="white" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-lg-12 developer-input">
                                                <div class="type-filter-button-sm" @click="toggleBool('podiumMLSIsActive')" :class="{selected: podiumMLSIsActive}">
                                                    <div>Podium</div>
                                                    <svg class="mixed-user-check filter-button-check" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <circle cx="5" cy="5" r="5" fill="#4D7CE1"/>
                                                        <path d="M2.77772 4.99991L4.24997 6.66361L7.22221 3.33323" stroke="white" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                </div>
                                            </div>
                                            <div class="col-lg-12 developer-input">
                                                <div class="type-filter-button-sm" @click="toggleBool('rowhomeMLSIsActive')" :class="{selected: rowhomeMLSIsActive}">
                                                    <div>Rowhome</div>
                                                    <svg class="stacked-townhome-check filter-button-check" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <circle cx="5" cy="5" r="5" fill="#4D7CE1"/>
                                                        <path d="M2.77772 4.99991L4.24997 6.66361L7.22221 3.33323" stroke="white" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                </div>
                                            </div>
                                        </div> -->

                                        <div class="row">
                                            <div class="col-sm-12 text-left">
                                                <h3 class="filter-label">Unit Size</h3>
                                            </div>
                                        </div>
                                        <div class="row mt-10">
                                            <div class="col-lg-12 input-border-new">
                                                <input class="demo-input-normal" v-model="mlsUnitMin" type="text" placeholder="Min Value">
                                            </div>
                                            <div class="col-lg-12 input-border-new">
                                                <input class="demo-input-normal" v-model="mlsUnitMax" type="text" placeholder="Max Value">
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-12 text-left">
                                                <h3 class="filter-label">List Price</h3>
                                            </div>
                                        </div>
                                        <div class="row mt-10">
                                            <div class="col-lg-12 input-border-new">
                                                <input class="demo-input-normal" v-model="mlsListPriceMin" type="text" placeholder="Min Value">
                                            </div>
                                            <div class="col-lg-12 input-border-new">
                                                <input class="demo-input-normal" v-model="mlsListPriceMax" type="text" placeholder="Min Value">
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-12 text-left">
                                                <h3 class="filter-label">Sold Price</h3>
                                            </div>
                                        </div>
                                        <div class="row mt-10">
                                            <div class="col-lg-12 input-border-new">
                                                <input class="demo-input-normal" v-model="mlsSoldPriceMin" type="text" placeholder="Min Value">
                                            </div>
                                            <div class="col-lg-12 input-border-new">
                                                <input class="demo-input-normal" v-model="mlsSoldPriceMax" type="text" placeholder="Min Value">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 pt-20">
                                        <div class="row">
                                            <div class="col-sm-12 text-left">
                                                <h3 class="filter-label">Beds</h3>
                                            </div>
                                        </div>
                                        <div class="row mt-10 ml-10">
                                            <div class="col-lg-6 input-border-new">
                                                <input class="demo-input-normal" v-model="mlsBedsMin" type="text" placeholder="Min Value">
                                            </div>
                                            <div class="col-lg-6 input-border-new">
                                                <input class="demo-input-normal" v-model="mlsBedsMax" type="text" placeholder="Max Value">
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-12 text-left">
                                                <h3 class="filter-label">Baths</h3>
                                            </div>
                                        </div>
                                        <div class="row mt-10 ml-10">
                                            <div class="col-lg-6 input-border-new">
                                                <input class="demo-input-normal" v-model="mlsBathsMin" type="text" placeholder="Min Value">
                                            </div>
                                            <div class="col-lg-6 input-border-new">
                                                <input class="demo-input-normal" v-model="mlsBathsMax" type="text" placeholder="Max Value">
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-12 text-left">
                                                <h3 class="filter-label">MLS Status</h3>
                                                <div class="filter-checkbox mt-10">
                                                    <treeselect v-model="statusMLSSelected" :multiple="true" :flat="true" :options="MLSStatusOptions" :autoSelectDescendants="true" :limit="3" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mt-10">
                                            <div class="col-lg-12 text-left ">
                                                <h3 class="filter-label">List Date</h3>
                                                <date-picker class="demo-date" v-model="listMLSDate" type="date" range placeholder="Select date range"></date-picker>
                                            </div>
                                            <div class="col-lg-12 text-left">
                                                <h3 class="filter-label">Sold Date</h3>
                                                <date-picker class="demo-date" v-model="soldMLSDate" type="date" range placeholder="Select date range"></date-picker>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-12">
                                            <div class="filter-update-unit" @click="MLSReset">RESET</div>
                                            <div class="filter-update-unit" @click="MLSGo">SEARCH</div>
                                    </div>
                                </div>
                            </b-tab>
                            <!-- <b-tab title="LAND" :disabled="role == 'plan_a'" @click="cleanOpt('3')" class="new-list">
                                <div class="row const">
                                    <div class="col-sm-12 text-left">
                                        <h3 class="filter-label mt-30 text-left" style="width: 100%;">Construction Status</h3>
                                        <div class="filter-checkbox mt-10">
                                            <treeselect v-model="constructionSelected" :multiple="true" :flat="true" :options="constructionOptions" :autoSelectDescendants="true" :limit="3" />
                                        </div>
                                    </div>
                                </div>
                                <h3 class="filter-label">Construction Start</h3>
                                <div class="row">
                                    <div class="col-sm-12 text-left">
                                        <date-picker class="demo-date" v-model="constructionStart" type="date" range placeholder="min"></date-picker>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-12 text-left">
                                        <h3 class="filter-label">Construction Completion</h3>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-12 pt-20">
                                        <date-picker class="demo-date" v-model="constructionCompletion" type="date" range placeholder="min"></date-picker>
                                    </div>
                                </div>
                                <div class="row mt-20">
                                    <div class="col-sm-12 text-left">
                                        <h3 class="filter-label">Permits &amp; Bylaws</h3>
                                    </div>
                                </div>
                                <div class="row new-list">
                                    <div class="col-lg-6 pt-20">
                                        <div class="row">
                                            <div class="col-sm-12 text-left">
                                                <div class="filter-checkbox">
                                                    <h3 class="ptitle">RZ:</h3>
                                                    <treeselect v-model="rezoningSelected" :multiple="true" :flat="true" :options="rezoningOptions" :autoSelectDescendants="true" :limitText="() => '+'"/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 pt-20">
                                        <div class="row">
                                            <div class="col-sm-12 text-left">
                                                <div class="filter-checkbox filter-checkbox-longer">
                                                    <h3 class="ptitle">OCP:</h3>
                                                    <treeselect v-model="ocpSelected" :multiple="true" :flat="true" :options="rezoningOptions" :autoSelectDescendants="true" :limitText="() => '+'"/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row new-list">
                                    <div class="col-lg-6 pt-20">
                                        <div class="row">
                                            <div class="col-sm-12 text-left">
                                                <div class="filter-checkbox">
                                                    <h3 class="ptitle">DP:</h3>
                                                    <treeselect v-model="dpSelected" :multiple="true" :flat="true" :options="dpOptions" :autoSelectDescendants="true"  :limitText="() => '+'"/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 pt-20">
                                        <div class="row">
                                            <div class="col-sm-12 text-left">
                                                <div class="filter-checkbox filter-checkbox-longer">
                                                    <h3 class="ptitle">DVP:</h3>
                                                    <treeselect v-model="dvpSelected" :multiple="true" :flat="true" :options="dpOptions" :autoSelectDescendants="true" :limitText="() => '+'"/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row new-list">
                                    <div class="col-lg-6 pt-20">
                                        <div class="row">
                                            <div class="col-sm-12 text-left">
                                                <div class="filter-checkbox">
                                                    <h3 class="ptitle">BP:</h3>
                                                    <treeselect v-model="bpSelected" :multiple="true" :flat="true" :options="bpOptions" :autoSelectDescendants="true" :limitText="() => '+'"/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 pt-20">
                                        <div class="row">
                                            <div class="col-sm-12 text-left">
                                                <div class="filter-checkbox filter-checkbox-longer">
                                                    <h3 class="ptitle">Sub:</h3>
                                                    <treeselect v-model="subSelected" :multiple="true" :flat="true" :options="bpOptions" :autoSelectDescendants="true" :limitText="() => '+'"/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6 text-center">
                                    <div class="filter-update hollow text-center" style="background: #476E93;" @click="LandGo()">SUMMARY RESULTS</div>
                                </div>
                            </b-tab> -->
                        </b-tabs>
                    </div>
                </div>
                <!-- list-main-wrap-->
            </div>
            <!--col-list-wrap -->  
            <div class="limit-box fl-wrap"></div>
            <b-modal ref="my-modal" hide-footer id="listing-modal">
                <template #modal-header="{ close }">
                    <!-- Emulate built in modal header close button action -->
                    <a :href="modalContent.href" class="detail-link">SEE FULL DETAILS</a>
                    <div class="detail-row">
                        <div class="detail-title">{{modalContent.presale_name}}</div>
                        <div class="detail-address">{{modalContent.address}}</div>
                    </div>
                    <button type="button" aria-label="Close" class="close modal-close"  @click="close()">×</button>
                </template>
                <div class="listing-modal-wrapper text-left">
                    <div class="row mb-20">
                        <div class="col-xs-3">
                            <div>Project Type</div>
                        </div>
                        <div class="col-xs-3">
                            <div><b>{{modalContent.project_type}}</b></div>
                        </div>
                        <div class="col-xs-3">
                            <div>Gross Floor Area’</div>
                        </div>
                        <div class="col-xs-3">
                            <div><b>{{modalContent.gross_floor}}</b></div>
                        </div>
                    </div>
                    <div class="row mb-20">
                        <div class="col-xs-3">
                            <div>City</div>
                        </div>
                        <div class="col-xs-3">
                            <div><b>{{modalContent.city}}</b></div>
                        </div>
                        <div class="col-xs-3">
                            <div>Developer</div>
                        </div>
                        <div class="col-xs-3">
                            <div><b>{{modalContent.developer}}</b></div>
                        </div>
                    </div>
                    <div class="row mb-20">
                        <div class="col-xs-3">
                            <div>Storey</div>
                        </div>
                        <div class="col-xs-3">
                            <div><b>{{modalContent.storey}}</b></div>
                        </div>
                        <div class="col-xs-3">
                            <div>FSR/FAR</div>
                        </div>
                        <div class="col-xs-3">
                            <div><b>{{modalContent.fsr_far}}</b></div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-12 text-left mt-20">
                            <h3>Project Total</h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-12">
                            <table class="table mt-3">
                                <thead class="fp-header">
                                    <th>Total Units</th>
                                    <th>Rlsd Units</th>
                                    <th>Sold Units</th>
                                    <th>Avail Units</th>
                                    <th>DOM</th>
                                    <th>Avg SF</th>
                                    <th>Avg Price</th>
                                    <th>Avg $PSF</th>
                                    <th>Updated</th>
                                </thead>
                                <tbody class="fp-body row-grey">
                                    <tr>
                                        <td>{{modalContent.total_units}}</td>
                                        <td>{{modalContent.rlsd_units}}</td>
                                        <td>{{modalContent.sold_units}}</td>
                                        <td>{{modalContent.available ? modalContent.available : '0'}}</td>
                                        <td>{{modalContent.dom}}</td>
                                        <td>{{numberWithCommas(modalContent.total_avg_size)}}</td>
                                        <td>{{modalContent.total_avg_price > 0 ? '$' + numberWithCommas(modalContent.total_avg_price) : '-'}}</td>
                                        <td>{{modalContent.total_avg_psf ? '$' + numberWithCommas(modalContent.total_avg_psf) : '-'}}</td>
                                        <td>{{modalContent.updated}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <template v-if="unitComponent.bed && unitComponent.bed.length !== 0">
                        <div class="row">
                            <div class="col-xs-12 text-left mt-20">
                                <h3>Unit Breakdown</h3>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-12">
                                <div class="row">
                                    <table class="table mt-3">
                                        <thead class="fp-header">
                                            <!-- <th>Plan Name</th> -->
                                            <th>Beds</th>
                                            <th>FP Specs</th>
                                            <th>Baths</th>
                                            <th># Units</th>
                                            <th>Parking</th>
                                            <th>Stalls</th>
                                            <th>Min SF</th>
                                            <th>Max SF</th>
                                            <th>Avg SF</th>
                                            <th>Min Price</th>
                                            <th>Max Price</th>
                                            <th>Avg Price</th>
                                            <th>Avg $PSF</th>
                                        </thead>
                                        <tbody class="fp-body">
                                            <tr style="cursor: pointer;" @click="assignFP(unit_t)" v-for="(unit_t, unit_key) in mlsTotalSort" v-bind:key="unit_key">
                                                <!-- <td v-if="typeof unit_t.plan_name != 'undefined'">{{unit_t.plan_name.join(', ')}}</td> -->
                                                <!-- <td v-else></td> -->
                                                <td class="bed-column" style="color: #FC5868; text-decoration: underline;" v-if="unit_t.bed == '-'">{{unit_t.bed}}</td>
                                                <td class="bed-column" style="color: #FC5868; text-decoration: underline;" v-else>{{unit_t.bed ? unit_t.bed : '0'}}</td>
                                                <td>{{unit_t.fp_specs}}</td>
                                                <td>{{unit_t.bath}}</td>
                                                <td>{{unit_t.num}}</td>
                                                <td>{{unit_t.parking}}</td>
                                                <td>{{unit_t.stall ? unit_t.stall.final : ''}}</td>
                                                <td>{{unit_t.minSize | numFormat}}</td>
                                                <td>{{unit_t.maxSize | numFormat}}</td>
                                                <td>{{unit_t.total_size*1.0 / unit_t.num | numFormat}}</td>
                                                <td>{{unit_t.minPrice ? '$'+numberWithCommas(unit_t.minPrice) : '-'}}</td>
                                                <td>{{unit_t.maxPrice ? '$'+numberWithCommas(unit_t.maxPrice) : '-'}}</td>
                                                <td>{{unit_t.avgPrice ? '$'+numberWithCommas(unit_t.avgPrice) : '-'}}</td>
                                                <td>{{(unit_t.avgPrice && unit_t.total_size && unit_t) ? '$'+numberWithCommas((unit_t.avgPrice/(unit_t.total_size/unit_t.num)).toFixed(0)) : '-'}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </b-modal>
            <b-modal id="mls-unit-modal" hide-footer ref="mls-unit-modal" hide-header>
                <button type="button" aria-label="Close" class="close modal-close"  @click="closeFP()">×</button>
                <template v-if="selectedFP">
                    <table class="table text-left table-borderless plan-table">
                        <thead>
                            <th>BED</th>
                            <th>BATH</th>
                            <th>FP SPECS</th>
                            <th>SF</th>
                            <th>PLAN NAME</th>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="bed-column">
                                    {{selectedFP.bed ? selectedFP.bed : '0'}}-bed
                                </td>
                                <td>
                                    {{selectedFP.bath ? selectedFP.bath : '0'}}-bath
                                </td>
                                <td>{{selectedFP.fp_specs}}</td>
                                <td>
                                    {{selectedFP.minSize | numFormat}} - {{selectedFP.maxSize | numFormat}} SF
                                </td>
                                <td>
                                    <span v-if="(typeof selectedFP.plan_name != 'undefined')">{{selectedFP.plan_name.join(', ')}}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="col-xs-6 d-block text-center" v-for="(file, file_key) in selectedFP.floor_plan" :key="file_key">
                        <div class="row fp-img">
                            <a target="_blank" :href="file.link">
                                <img class='floorplan-pdf' :src="file.preview">
                            </a>
                        </div>
                        <div class="row floor-plan-block">
                            <div class="col-xs-4"><b>Unit #</b></div>
                            <div class="col-xs-4"><b>Status</b></div>
                            <div class="col-xs-4" v-if="file.status == 'Active'"><b>List Price</b></div>
                            <div class="col-xs-4" v-else><b>Sold Price</b></div>
                        </div>
                        <div class="row floor-plan-block">
                            <div class="col-xs-4">{{file.unit_num}}</div>
                            <div class="col-xs-4">{{file.status}}</div>
                            <div v-if="file.status == 'Active'" class="col-xs-4">{{file.list_price ? '$'+numberWithCommas(file.list_price) : '$0'}}</div>
                            <div v-else class="col-xs-4">{{file.sold_price ? '$'+numberWithCommas(file.sold_price) : '$0'}}</div>
                        </div>
                        <div class="row floor-plan-block">
                            <div class="col-xs-4"><b>Beds</b></div>
                            <div class="col-xs-4"><b>Baths</b></div>
                            <div class="col-xs-4"><b>Size</b></div>
                        </div>
                        <div class="row floor-plan-block">
                            <div class="col-xs-4">{{selectedFP.bed ? selectedFP.bed : '0'}}</div>
                            <div class="col-xs-4">{{selectedFP.bath ? selectedFP.bath : '0'}}</div>
                            <div class="col-xs-4">{{file.unit_size}}</div>
                        </div>
                    </div>
                </template>
            </b-modal>
        </div>
        <div class="report-container column-report" v-show="!listing">
            <div v-click-outside="fieldsToggleOff" style="display: inline-block; width: 100%;">
                <h2 style="float: left;" class="view-result">VIEW RESULTS</h2>
                <img @click="listing = true" class="print-none" style="float: right; cursor: pointer; margin-right: 20px;" width="50" height="50" src="/images/assets/googlemap_icon.png">
                <img class="print-none" style="float: right; cursor: pointer; margin-right: 20px;" width="50" height="50" src="/images/assets/export_icon.png">
                <img class="print-none" style="float: right; cursor: pointer; margin-right: 20px; margin-top: 7px;" width="40" height="40" src="/images/assets/fields.png" @click="fieldsToggle = !fieldsToggle">
                <div class="filter-update hollow text-center" style="float: right; cursor: pointer; margin-right: 20px; background: #476E93; margin-top: 0;
                    font-size: 1.1rem;
                    padding: 18px 0px;
                    width: 190px;
                    border-radius: 28px;" @click="refreshResults()">UPDATE TABLE</div>
                <div class="filter-update hollow text-center" style="float: right; cursor: pointer; margin-right: 20px; background: #495F74; margin-top: 0;
                    font-size: 1.1rem;
                    padding: 18px 0px;
                    width: 190px;
                    border-radius: 28px;" @click="toggleFloatingFilter()">CUSTOM SEARCH</div>
                <div v-if="floatingFilters" class="new-list floating-filters">
                    <div class="row">
                        <div class="col-sm-12 text-left">
                            <h3 class="filter-label">Region Location</h3>
                        </div>
                    </div>
                    <div class="row">
                        <!-- <div class="col-xs-6">
                            <div class="filter-checkbox mt-10" style="margin-right: -10px;">
                                <span style="float: left;margin-top: 17px;font-size: 1.5rem;font-weight: bold;margin-left: 10px;">GV: </span>
                                <treeselect class="city-special" v-model="gvCitiesSelected" :multiple="true" :flat="true" :options="gvCityOptions"/>
                            </div>
                        </div>
                        <div class="col-xs-6">
                            <div class="filter-checkbox mt-10" style="margin-right: -10px;">
                                <span style="float: left;margin-top: 17px;font-size: 1.5rem;font-weight: bold;margin-left: 10px;">FV: </span>
                                <treeselect class="city-special" v-model="fvCitiesSelected" :multiple="true" :flat="true" :options="fvCityOptions"/>
                            </div>
                        </div> -->
                        <div class="col-xs-6" v-click-outside="gvSummaryOff">
                            <div class="type-filter-button-sm-wrap" @click="openSummaryGV()">
                                <div class="text-left" :class="{buttonWithOpt: citiesSelected.some(g => gvCities.includes(g))}"><span style="float: left; margin-top: 7px;">GV: </span> <span class="choosen-opts" v-for="(city, index) in citiesSelected.filter(g => gvCities.includes(g))" :key="index" @click="removeCity(index)">{{nameSwitch(city)}}</span></div>
                            </div>
                            <div class="sale-pop dropdown-background-grey scroll-popup" :class="{active: gvSummaryOptions}">
                                <input class="checkbox-square" type="checkbox" id="vancouver" value="2895" v-model="citiesSelected">
                                <label for="vancouver"> Vancouver</label><br>
                                <input class="checkbox-square" type="checkbox" id="coquitlam" value="2874" v-model="citiesSelected">
                                <label for="coquitlam"> Coquitlam</label><br>
                                <input class="checkbox-square" type="checkbox" id="burnaby" value="2873" v-model="citiesSelected">
                                <label for="burnaby"> Burnaby</label><br>
                                <input class="checkbox-square" type="checkbox" id="richmond" value="2877" v-model="citiesSelected">
                                <label for="richmond"> Richmond</label><br>
                                <input class="checkbox-square" type="checkbox" id="north_van_city" value="2949" v-model="citiesSelected">
                                <label for="north_van_city"> North Van (City)</label><br>
                                <input class="checkbox-square" type="checkbox" id="new_westminster" value="2889" v-model="citiesSelected">
                                <label for="new_westminster"> New Westminster</label><br>
                                <input class="checkbox-square" type="checkbox" id="north_vancouver_district" value="2950" v-model="citiesSelected">
                                <label for="north_vancouver_district"> North Van (Dist)</label><br>
                                <input class="checkbox-square" type="checkbox" id="west_vancouver" value="2896" v-model="citiesSelected">
                                <label for="west_vancouver"> West Vancouver</label><br>
                                <input class="checkbox-square" type="checkbox" id="squamish" value="2894" v-model="citiesSelected">
                                <label for="squamish"> Squamish</label><br>
                                <input class="checkbox-square" type="checkbox" id="port_coquitlam" value="2892" v-model="citiesSelected">
                                <label for="port_coquitlam"> Port Coquitlam</label><br>
                                <input class="checkbox-square" type="checkbox" id="port_moody" value="2893" v-model="citiesSelected">
                                <label for="port_moody"> Port Moody</label><br>
                                <input class="checkbox-square" type="checkbox" id="maple_ridge" value="2888" v-model="citiesSelected">
                                <label for="maple_ridge"> Maple Ridge</label><br>
                                <input class="checkbox-square" type="checkbox" id="pitt_meadows" value="2891" v-model="citiesSelected">
                                <label for="pitt_meadows"> Pitt Meadows</label><br>
                            </div>
                        </div>
                        <div class="col-xs-6" v-click-outside="fvSummaryOff">
                            <div class="type-filter-button-sm-wrap" @click="openSummaryFV()">
                                <div class="text-left" :class="{buttonWithOpt: citiesSelected.some(g => fvCities.includes(g))}"><span style="float: left; margin-top: 7px;">FV: </span> <span class="choosen-opts" v-for="(city, index) in citiesSelected.filter(g => fvCities.includes(g))" :key="index" @click="removeCity(index)">{{nameSwitch(city)}}</span></div>
                            </div>
                            <div class="sale-pop dropdown-background-grey scroll-popup" :class="{active: fvSummaryOptions}">
                                <input class="checkbox-square" type="checkbox" id="surrey" value="2887" v-model="citiesSelected">
                                <label for="surrey"> Surrey</label><br>
                                <input class="checkbox-square" type="checkbox" id="langley_township" value="2879" v-model="citiesSelected">
                                <label for="langley_township"> Langley (Township)</label><br>
                                <input class="checkbox-square" type="checkbox" id="langley_city" value="3556" v-model="citiesSelected">
                                <label for="langley_city"> Langley (City)</label><br>
                                <input class="checkbox-square" type="checkbox" id="abbotsford" value="2876" v-model="citiesSelected">
                                <label for="abbotsford"> Abbotsford</label><br>
                                <input class="checkbox-square" type="checkbox" id="delta" value="2898" v-model="citiesSelected">
                                <label for="delta"> Delta</label><br>
                                <input class="checkbox-square" type="checkbox" id="mission" value="3609" v-model="citiesSelected">
                                <label for="mission"> Mission</label><br>
                                <input class="checkbox-square" type="checkbox" id="white_rock" value="2897" v-model="citiesSelected">
                                <label for="white_rock"> White Rock</label><br>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12 text-left">
                            <h3 class="filter-label">Transaction Type</h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-6" v-click-outside="residentialSummaryOff">
                            <div class="type-filter-button-sm-wrap" @click="openResidentialSummary()">
                                <div class="text-left" :class="{buttonWithOpt: (gutSelected.includes('2952') || gutSelected.includes('2954') || gutSelected.includes('2975') || gutSelected.includes('2953') || gutSelected.includes('2954') || typeSelected.includes('2886') || typeSelected.includes('2884') || typeSelected.includes('2870') || typeSelected.includes('3479'))}"><span style="float: left; margin-top: 7px;">Residential: </span> <span class="choosen-opts" v-for="(gut, index) in gutSelected.filter(g => ['2952', '2954', '2975', '2953', '2954'].includes(g))" :key="index" @click="removeGut(index)">{{nameSwitch(gut)}}</span> <span class="choosen-opts" v-for="(type, index) in typeSelected.filter(s => ['2886', '2884', '2870', '3479'].includes(s))" :key="index" @click="removeType(index)">{{typeName(type)}}</span> <span class="choosen-opts" v-for="(status, index) in statusSelected.filter(s => ['now_selling', 'sold_out'].includes(s))" :key="index" @click="removeStatus(index)">{{nameSwitch(status)}}</span> <span class="choosen-opts" v-for="(status, index) in statusSelected.filter(s => ['now_leasing', 'leased_out'].includes(s))" :key="index" @click="removeStatus(index)">{{nameSwitch(status)}}</span></div>
                            </div>
                            <div class="sale-pop dropdown-background-grey" :class="{active: residentialSummaryOption}">
                                <!-- <input class="checkbox-square" type="checkbox" id="residential_apartment" value="2886" v-model="typeSelected">
                                <label for="residential_apartment"> Apartment</label><br>
                                <input class="checkbox-square" type="checkbox" id="residential_mixed" value="2884" v-model="typeSelected">
                                <label for="residential_mixed"> Mixed-Use Apartment</label><br>
                                <input class="checkbox-square" type="checkbox" id="residential_townhome" value="2870" v-model="typeSelected">
                                <label for="residential_townhome"> Townhome</label><br>
                                <input class="checkbox-square" type="checkbox" id="residential_stacked_townhome" value="3479" v-model="typeSelected">
                                <label for="residential_stacked_townhome"> Stacked Townhome</label><br>
                                <div style="border-bottom: 3px solid #13293E; margin: 20px -20px;"></div> -->
                                <input class="checkbox-square" type="checkbox" id="market_strata" value="2952" v-model="gutSelected">
                                <label for="market_strata"> Market Strata</label><br>
                                <input style="margin-left: 25px;" class="checkbox-square" type="checkbox" id="now_selling" value="now_selling" v-model="statusSelected">
                                <label for="now_selling"> Now Selling</label><br>
                                <input style="margin-left: 25px;" class="checkbox-square" type="checkbox" id="sold_out" value="sold_out" v-model="statusSelected">
                                <label for="sold_out"> Sold Out</label><br>
                                <input class="checkbox-square" type="checkbox" id="market_rental" value="2954" v-model="gutSelected">
                                <label for="market_rental"> Market Rental</label><br>
                                <input style="margin-left: 25px;" class="checkbox-square" type="checkbox" id="now_leasing" value="now_leasing" v-model="statusSelected">
                                <label for="now_leasing"> Now Leasing</label><br>
                                <input style="margin-left: 25px;" class="checkbox-square" type="checkbox" id="leased_out" value="leased_out" v-model="statusSelected">
                                <label for="leased_out"> Leased Out</label>
                            </div>
                        </div>
                        <div class="col-xs-6" v-click-outside="commercialSummaryOff">
                            <div class="type-filter-button-sm-wrap" @click="openCommercialSummary()">
                                <div class="text-left" :class="{buttonWithOpt: (gutSelected.includes('3031') || gutSelected.includes('2960') || gutSelected.includes('3515'))}"><span style="float: left; margin-top: 7px;">Commercial: </span> <span class="choosen-opts" v-for="(gut, index) in gutSelected.filter(g => ['3031', '2960', '3515'].includes(g))" :key="index" @click="removeGut(index)">{{nameSwitch(gut)}}</span></div>
                            </div>
                            <div class="sale-pop dropdown-background-grey" :class="{active: commercialSummaryOptions}">
                                <input class="checkbox-square" type="checkbox" id="commercial_office" value="3031" v-model="gutSelected">
                                <label for="commercial_office"> Office</label><br>
                                <input class="checkbox-square" type="checkbox" id="commercial_retail" value="2960" v-model="gutSelected">
                                <label for="commercial_retail"> Retail</label><br>                                                    
                                <input class="checkbox-square" type="checkbox" id="commercial_industrial" value="3515" v-model="gutSelected">
                                <label for="commercial_industrial"> Industrial</label><br>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="filter-update hollow text-center" style="background: #495F74;"  @click="onReport(false)">FIND PROJECTS</div><br>
                        </div>
                        <div class="col-lg-6">
                            <div class="filter-update hollow text-center" style="background: #476E93;" @click="onReport(true)">SUMMARY RESULTS</div>
                        </div>
                    </div>
                </div>


                <div class="fields-toggle-wrapper" v-if="fieldsToggle">
                    <div class="fields-toggle-block selected-fields">
                        <div class="fields-toggle-title">Shown Data Points</div>
                        <draggable class="list-group row" :list="list1" group="field" @change="fieldsOn" :sort="true">
                            <div
                            class="list-group-item"
                            v-for="(element) in list1"
                            :key="element.name"
                            >{{ element.name }}</div>
                        </draggable>
                    </div>
                    <div class="fields-toggle-bar"></div>
                    <div class="fields-toggle-block">
                        <div class="fields-toggle-title">Drag and Drop Data Points</div>
                        <draggable class="list-group row" :list="list2" group="field" :sort="true">
                            <div
                            class="list-group-item"
                            v-for="(element) in list2"
                            :key="element.name"
                            >{{ element.name }}</div>
                        </draggable>
                    </div>
                </div>
            </div>
            <div class="table-wrap">
                <table v-if="!is_loading" class="table list-table">
                    <thead class="summary-table-header">
                        <th class="summary-sort"><input type="checkbox" style="height: 20px; width: 20px;" @click="selectAll" v-model="allSelected"></th>
                        <th scope="col" class="summary-sort text-left" @click="sort('name')">Project</th>
                        <th v-for="(row, key) in reportFields" v-bind:key="key" scope="col" class="summary-sort" :class="{'hidden-xs' : !['project_type', 'general_unit_type', 'developer', 'dp_status', 'total_avg_size'].includes(row), 'text-left' : key < 3}">
                            <div v-if="filterOptions[row] && filterOptions[row].length">
                                <span @click="displayOptions(row)" class="m-1">
                                    {{fieldSwitch(row)}} <i class="fa fa-angle-down" :class="optionsIsVisible[row] ? 'rotate-180' : 'rotate-360'"></i>
                                </span>
                                <ul :class="optionsIsVisible[row] ? 'visible' : 'invisible'">
                                    <template v-if="row == 'general_unit_type'">
                                        <li v-for="item in filterOptions[row]" 
                                            :key="item" 
                                            :class="filter[row].includes(item) ? 'selected' : ''"
                                            @click="containOption(row, item)"
                                        >
                                            <span v-if="row.includes('status')" :class="classStatus(item)"></span>{{item}}
                                        </li>
                                    </template>
                                    <template v-else>
                                        <li v-for="item in filterOptions[row]" 
                                            :key="item" 
                                            :class="filter[row].includes(item) ? 'selected' : ''"
                                            @click="selectOption(row, item)"
                                        >
                                            <span v-if="row.includes('status')" :class="classStatus(item)"></span>{{item}}
                                        </li>
                                    </template>
                                </ul>
                            </div>
                            <span v-else @click="sort(row)">{{fieldSwitch(row)}}</span>
                        </th>
                    </thead>
                    <tbody>
                        <tr v-for="(row, key) in filteredReportDetail" v-bind:key="key">
                            <td><input type="checkbox" style="height: 20px; width: 20px;" :value="row.uid" v-model="selectedSummary"></td>
                            <td style="padding-right: 0;">
                                <div class="text-left" :title="row.name"><a :href="row.ref_link">{{row.name.length > 30 ? row.name.substring(0,28)+".." : row.name}}</a></div>
                                <div class="text-left" :title="row.developer">{{row.developer.length> 30 ? row.developer.substring(0,28)+".." : row.developer}}</div>
                            </td>
                            <td v-for="(field, index) in reportFields" v-bind:key="index" :class="{'hidden-xs' : !['project_type', 'general_unit_type', 'developer', 'dp_status', 'total_avg_size'].includes(field), 'text-left' : index < 3, 'no-p-right': field == 'location'}">
                                <span v-if="field.includes('status')" :class="classStatus(dataSwitch(field, row))"></span>
                                <span v-else-if="field=='project_type'">{{dataSwitch(field, row)}}<br>{{row.storey}}</span>
                                <span class="text-left" v-else-if="field=='location'"><div :title="row.address">{{row.address.length> 20 ? row.address.substring(0,18)+".." : row.address}}</div><div>{{row.city}}</div></span>
                                <span v-else v-html='dataSwitch(field, row)'></span>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="row">
                    <div class="col-xs-12 status-wrapper">
                        <div style="float: left; margin-left: 20px;" class="project-status-btn" :class="statusOriginal">{{statusList[0]}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';
    import {BACKEND_URL} from '../variables.js';
    import {BTabs, BModal, BTab, BPopover, VBPopover} from 'bootstrap-vue';
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import Autocomplete from '@trevoreyre/autocomplete-vue'
    import '@trevoreyre/autocomplete-vue/dist/style.css'
    import ClickOutside from 'vue-click-outside';
    import { cloneDeep } from 'lodash';
    import { classStatus } from '../shared/services'
    import draggable from 'vuedraggable'
    import Multiselect from 'vue-multiselect'

    // import BTab from 'bootstrap-vue';
    export default {
        components: { 
            'b-modal': BModal,
            DatePicker,
            'b-tabs': BTabs,
            'b-tab': BTab,
            'b-popover': BPopover,
            Treeselect,
            Autocomplete,
            draggable
        },
        directives: {
            'b-modal': BModal,
            'b-popover': VBPopover,
            ClickOutside
        },
        data() {
            return {
                allSelected: false,
                list1: [
                    // { name: "Project", field: 'project_name', id: 1 },
                    { name: "Type & Storey", field: 'project_type', id: 2 },
                    { name: "Location", field: 'location', id: 3 },
                    { name: "Sales Start", field: 'sales_start_date', id: 4 },
                    { name: "Total Units", field: 'total_units', id: 5 },
                    { name: "Rlsd Units", field: 'rlsd_units', id: 6 },
                    { name: "Sold Units", field: 'total_sold_units', id: 7 },
                    { name: "Avail Units", field: 'available', id: 8 },
                    { name: "Avg $PSF", field: 'total_avg_psf', id: 9 },
                    { name: "Avg Size", field: 'total_avg_size', id: 10 },
                    { name: "Avg Price", field: 'total_avg_price', id: 11 }
                ],
                list2: [
                    { name: "Last Updated", field: 'updated', id: 12 },
                    { name: "General Unit Type", field: 'general_unit_type', id: 13 },
                    { name: "Municipality", field: 'city', id: 14 },
                    { name: "Neighbourhood", field: 'neighbour', id: 15 },
                    { name: "Construction Status", field: 'construction_status', id: 16 },
                    { name: "Lot Size (sqft)", field: 'presale_lot_area', id: 17 },
                    { name: "Construction Start", field: 'construction_start_date', id: 18 },
                    { name: "Construction Completion", field: 'construction_complete_date', id: 19 },
                    { name: "Current Availability", field: 'available', id: 20 },
                    { name: "Current Avg Size", field: 'current_avg_size', id: 21 },
                    { name: "Current Avg Price", field: 'current_avg_price', id: 22 },
                    { name: "Current Avg $PSF", field: 'current_avg_psf', id: 23 },
                    { name: "Days on Market", field: 'dom', id: 24 }
                ],
                drag: false,
                query: this.$route.query,
                projects: [],
                locations: [],
                all_types: [
                    {name: 'Apartments', value: 'apt'},
                    {name: 'Townhome', value: '2870'}
                ],
                all_type: null,
                all_city: null,
                all_status: null,
                new_type: null,
                new_city: null,
                new_status: null,
                listSearch: '',
                initBeforeSearch: true,
                mapSwitch: false,
                types: [],
                sortColumn: 'address',
                sortBy: 'sort-ad',
                orderAsc: true,
                is_loading: true,
                rzStatus: [],
                bpStatus: [],
                dpStatus: [],
                rzSubDate: [],
                rzAppDate: [],
                dpSubDate: [],
                dpIssueDate: [],
                bpSubDate: [],
                bpIssueDate: [],
                aptIsActive: false,
                townhomeIsActive: false,
                mixedUseAptIsActive: false,
                podiumIsActive: false,
                stackedTownhomeIsActive: false,
                commercialIsActive: false,
                industrialIsActive: false,
                rowhomeIsActive: false,
                aptMLSIsActive: false,
                townhomeMLSIsActive: false,
                mixedUseAptMLSIsActive: false,
                podiumMLSIsActive: false,
                stackedTownhomeMLSIsActive: false,
                commercialMLSIsActive: false,
                industrialMLSIsActive: false,
                rowhomeMLSIsActive: false,
                mapActive: true,
                menuStatus: true,
                mapBox: [],
                dateSort: 'app',
                dateNameSort: '',
                constructionFilter: '',
                rzFilter: '',
                dpFilter: '',
                bpFilter: '',
                dpDateSort: false,
                bpDateSort: false,
                rzDateSort: false,
                mapPop: false,
                searchStart: false,
                citiesSelected: [],
                gvCitiesSelected: [],
                fvCitiesSelected: [],
                mlsCitiesSelected: [],
                landCitiesSelected: [],
                statusSelected: [],
                gutSelected: [],
                gutMLSSelected: [],
                cityoptions: [],
                gvCityOptions: [],
                fvCityOptions: [],
                landOptions: [],
                proposedZoningOpt: [],
                developerOpt: [],
                listOpt: [],
                areaSelected: [],
                areaOptions: [],
                typeOptions: [],
                typeSSelected: [],
                statusSSelected: [],
                statusOptions: [],
                proposedSelected: [],
                existingZSelected: [],
                landSelected: [],
                gutoptions: [],
                gutUnitoptions: [],
                constructionSelected: [],
                constructionOptions:[],
                mlsBedsMax: null,
                mlsBedsMin: null,
                mlsUnitMax: null,
                mlsBathsMin: null,
                mlsBathsMax: null,
                mlsUnitMin: null,
                listMLSDate: [],
                soldMLSDate: [],
                mlsListPriceMin: null,
                mlsListPriceMax: null,
                mlsSoldPriceMin: null,
                mlsSoldPriceMax: null,
                developerSearch: null,
                selectedSummary: [],
                statusList: [],
                selectedFP: null,
                mapObj: null,
                mlsFP: [],
                fpSpecsSelected: [],
                modalContent: {
                    href: '',
                    presale_name: '',
                    address: '',
                    project_type: '',
                    construction_status: '',
                    developer: '',
                    deposit: '',
                    storey: '',
                    sales_start_date: '',
                    type: '',
                    city: '',
                    rlsd_units: '',
                    sold_units: '',
                    available: '',
                    dom: '',
                    total_avg_size: '',
                    total_avg_price: '',
                    total_avg_psf: '',
                    updated: '',
                    total_units: '',
                    gross_floor: ''
                },
                MLSStatusOptions: [
                    {id: 8197, label: 'Active'},
                    {id: 8198, label: 'Sold'},
                    {id: 8205, label: 'Terminated'},
                    {id: 8203, label: 'Withdrawn'},
                ],
                parcelStatusLandOptions: [
                    {id: 11195, label: 'Active'},
                    {id: 11196, label: 'Cancelled'},
                    {id: 11197, label: 'Inactive'}
                ],
                regTypeOptions: [
                    {id: 11249, label: 'Title Cancel'},
                    {id: 11191, label: 'Title Transfer'},
                    {id: 11190, label: 'Mortgage'}
                ],
                rezoningOptions: [
                    {id: 10943, label: 'In Process'},
                    {id: 10944, label: 'Approved'},
                    {id: 10945, label: 'Adopted'},
                    {id: 10946, label: 'Denied'}
                ],
                dpOptions: [
                    {id: 10943, label: 'In Process'},
                    {id: 10944, label: 'Approved'},
                    {id: 10947, label: 'Issued'}
                ],
                bpOptions: [
                    {id: 10943, label: 'In Process'},
                    {id: 10944, label: 'Approved'},
                ],
                LTSAPlanSearch: null,
                LTSARegistrationSearch: null,
                parcelStatusLandSelected: [],
                statusMLSSelected: [],
                regTypeSelected: [],
                typeSelected: [],
                ltsapid: null,
                registrationLandDate: [],
                landSalePriceMin: null,
                landSalePriceMax: null,
                landLotSizeMin: null,
                landLotSizeMax: null,
                subSelected: [],
                bpSelected: [],
                dvpSelected: [],
                dpSelected: [],
                ocpSelected: [],
                rezoningSelected: [],
                role: '',
                dateSearch: [],
                loading: false,
                isLoggedin: false,
                cityList: [],
                unitsMin: null,
                unitsMax: null,
                storeyMin: null,
                storeyMax: null,
                searchStarted: false,
                sortDisplay: false,
                pickedProject: null,
                saleOptions: false,
                salePlanningOptions: false,
                salePlanningSummaryOptions: false,
                leaseOptions: false,
                residentialOption: false,
                commercialOptions: false,
                leaseSummaryOptions: false,
                residentialSummaryOption: false,
                commercialSummaryOptions: false,
                leasePlanningOptions: false,
                leasePlanningSummaryOptions: false,
                gvOptions: false,
                gvSummaryOptions: false,
                gvPlanningOptions: false,
                gvPlanningSummaryOptions: false,
                fvOptions: false,
                fvSummaryOptions: false,
                fvPlanningOptions: false,
                fvPlanningSummaryOptions: false,
                rightToggle: true,
                listing: true,
                reportDetail: [],
                filteredReportDetail: [],
                floatingFilters: false,
                floatSecond: false,
                cityPreview: false,
                reportFields: [],
                filter: {},
                optionsIsVisible: {},
                filterOptions: {},
                pTypeList: [],
                generalUnitType: [],
                statusOriginal: null,
                reportType: 'Project Report',
                citySelected: [],
                rightCollapse: true,
                unitComponent: {},
                closed: true,
                switchMessage: '',
                removeSaleVal: false,
                saleWithOptions: false,
                leaseWithOptions: false,
                planningView: false,
                planningTab: false,
                currentTab: 'projects',
                fieldsToggle: false,
                permits: {
                    sub: [],
                    bp: [],
                    dvp: [],
                    dp: [],
                    ocp: [],
                    rez: []
                },
                citySummary: [],
                planningUTC: [],
                gvCities: ['2895', '2874', '2873', '2877', '2949', '2889', '2950', '2896', '2894', '2892', '2893', '2888', '2891'],
                fvCities: ['2887', '2879', '3556', '2876', '2898', '3609', '2897'],
                constructionStart: [],
                constructionCompletion: [],
            }
        },
        mounted: function() {
            this.list1.forEach((val, key) => {
                this.reportFields.push(val.field);
            });
            $.get({
                url: BACKEND_URL + 'api/get_fp_specs_tree',
            }, (data, status) => {
                if (status === 'success') {
                    this.mlsFP = data;
                }
            });
            $.get({
                url: BACKEND_URL + 'api/get_role',
            }, (data, status) => {
                if (status === 'success') {
                    this.role = data.role;
                    this.loggedinEmail = data.email;
                    // this.role = '';
                    // this.loggedinEmail = 'admin@test.com';
                }
                if (this.role == 'admin' || this.role == 'plan_a' || this.role == 'plan_b') {
                    this.isLoggedin = true;
                }
            });
            $.get({
                url: BACKEND_URL + 'api/get_proposed_zoning',
            }, (data, status) => {
                if (status === 'success') {
                    this.proposedZoningOpt = data;
                }
            });
            // $.get({
            //     url: BACKEND_URL + 'api/get_developer_opts',
            // }, (data, status) => {
            //     if (status === 'success') {
            //         this.developerOpt = data;
            //     }
            // });
            // $.get({
            //     url: BACKEND_URL + 'api/get_name_address_opt',
            // }, (data, status) => {
            //     if (status === 'success') {
            //         this.listOpt = data;
            //     }
            // });
            $.get({
                url: BACKEND_URL + 'api/get_construction_status',
            }, (data, status) => {
                if (status === 'success') {
                    this.constructionOptions = data;
                }
            });
            $.get({
                url: BACKEND_URL + 'api/get_project_status',
            }, (data, status) => {
                if (status === 'success') {
                    this.statusOptions = data;
                }
            });
            $.get({
                url: BACKEND_URL + 'api/get_types',
            }, (data, status) => {
                if (status === 'success') {
                    this.typeOptions = data;
                }
            });
            $.get({
                url: BACKEND_URL + 'api/get_region',
            }, (data, status) => {
                if (status === 'success') {
                    this.cityoptions = data;
                    this.gvCityOptions = data.filter( i => this.gvCities.includes(i.id))
                    this.fvCityOptions = data.filter( i => this.fvCities.includes(i.id))
                    this.cityoptions.forEach((key) => {
                        this.cityList.forEach((val) => {
                            if (key.id == val) {
                                this.mlsCitiesSelected.push(key.label);
                            }
                            if (key.id == val) {
                                this.citySelected.push(key.label);
                            }
                        });
                    });
                }
            });
            $.get({
                url: BACKEND_URL + 'api/get_land_use_designation',
            }, (data, status) => {
                if (status === 'success') {
                    this.landOptions = data;
                }
            });

            $.get({
                url: BACKEND_URL + 'api/get_area_plan_designation',
            }, (data, status) => {
                if (status === 'success') {
                    this.areaOptions = data;
                }
            });
            $.get({
                url: BACKEND_URL + 'api/get_gut_children',
            }, (data, status) => {
                if (status === 'success') {
                    this.gutoptions = data;
                    Object.keys(this.gutoptions).forEach((key) => {
                        if (vm.query['unittype[]'] && vm.query['unittype[]'].includes(this.gutoptions[key].id)) {
                            this.generalUnitType.push(this.gutoptions[key].label)
                        }
                    })
                }
            });

            $.get({
                url: BACKEND_URL + 'api/get_gut',
            }, (data, status) => {
                if (status === 'success') {
                    this.gutUnitoptions = data;
                }
            });
            $.get({
                url: BACKEND_URL + 'api/get_status_short',
            }, (data, status) => {
                if (status === 'success') {
                    data.forEach((a) => {
                        // if (this.statusList.includes(a.tid.replace(' ', ''))) {
                        //     $('#step3').append('<option selected value="'+ a.tid.replace(' ', '') + '">' + a.name + '</option>');
                        //     this.new_status = a.tid.replace(' ', '');
                        //     $('#stepStatus').append('<option selected value="'+ a.tid.replace(' ', '') + '">' + a.name + '</option>');
                        // }
                        // else {
                            $('#step3').append('<option value="'+ a.tid.replace(' ', '') + '">' + a.name + '</option>');
                            $('#stepStatus').append('<option value="'+ a.tid.replace(' ', '') + '">' + a.name + '</option>');
                        // }
                    })
                    setTimeout(function(){
                        $('.better-select').niceSelect();
                        if ($.isArray(vm.query['status[]'])) {
                            vm.query['status[]'].forEach((a) => {
                                $('#step3').next().find('ul li[data-value='+a+']').click();
                            });
                        }
                        else if (vm.query['status[]']) {
                            $('#step3').next().find('ul li[data-value='+vm.query['status[]']+']').click();
                        }
                        $('#step3').click();
                    }, 500);
                }
            });
            const vm = this;
            let param = '';
            if ($.isArray(vm.$route.query['sub[]'])) {
                vm.$route.query['sub[]'].forEach((a) => {
                    if (vm.permitName(a)) {
                        vm.permits.sub.push(vm.permitName(a));
                    }
                    param += 'sub[]=' + a + '&';
                });
            }
            else {
                if (vm.$route.query['sub[]']) {
                    if (vm.$route.query['sub[]']) {
                        vm.permits.sub.push(vm.permitName(vm.$route.query['sub[]']));
                    }
                    param += 'sub[]=' + vm.$route.query['sub[]'] + '&';
                }
            }
            // if ($.isArray(vm.query['type[]'])) {
            //     vm.query['type[]'].forEach((a) => {
            //         switch (a) {
            //             case '2886':
            //                 vm.aptIsActive = true;
            //                 break;
            //             case '2870':
            //                 vm.townhomeIsActive = true;
            //                 break;
            //             case '2884':
            //                 vm.mixedUseAptIsActive = true;
            //                 break;
            //             case '3479':
            //                 vm.stackedTownhomeIsActive = true;
            //                 break;
            //             case '2962':
            //                 vm.commercialIsActive = true;
            //                 break;
            //             case '3047':
            //                 vm.industrialIsActive = true;
            //                 break;
            //             case '6240':
            //                 vm.rowhomeIsActive = true;
            //                 break;
            //             case '5910':
            //                 vm.podiumIsActive = true;
            //                 break;
            //         }
            //         param += 'type[]=' + a + '&';
            //         this.pTypeList.push(this.typeName(a));
            //     });
            // }
            // else if (typeof vm.query['type[]'] == 'undefined') {
            // }
            // else {
            //     switch (vm.query['type[]']) {
            //         case '2886':
            //             vm.aptIsActive = true;
            //             break;
            //         case '2870':
            //             vm.townhomeIsActive = true;
            //             break;
            //         case '2884':
            //             vm.mixedUseAptIsActive = true;
            //             break;
            //         case '3479':
            //             vm.stackedTownhomeIsActive = true;
            //             break;
            //         case '2962':
            //             vm.commercialIsActive = true;
            //             break;
            //         case '3047':
            //             vm.industrialIsActive = true;
            //             break;
            //         case '6240':
            //             vm.rowhomeIsActive = true;
            //             break;
            //         case '5910':
            //             vm.podiumIsActive = true;
            //             break;
            //     }
            //     param += 'type[]=' + vm.query['type[]'] + '&';
            // }
            if (vm.query['salestart']) {
                param += 'salestart=' + vm.query['salestart'] + '&';
            }
            if (vm.query['saleend']) {
                param += 'saleend=' + vm.query['saleend'] + '&';
            }
            if ($.isArray(vm.query['city[]'])) {
                vm.query['city[]'].forEach((a) => {
                    param += 'city[]=' + a + '&';
                    vm.cityList.push(a);
                    vm.citiesSelected.push(a);
                });
            }
            else if (typeof vm.query['city[]'] == 'undefined') {
            }
            else {
                param += 'city[]=' + vm.query['city[]'] + '&';
                vm.citiesSelected.push(vm.query['city[]'])
                vm.cityList.push(vm.query['city[]']);
            }
            if ($.isArray(vm.query['rez[]'])) {
                vm.query['rez[]'].forEach((a) => {
                    param += 'rez[]=' + a + '&';
                    vm.rezoningSelected.push(a);
                });
            }
            else if (typeof vm.query['rez[]'] == 'undefined') {
            }
            else {
                param += 'rez[]=' + vm.query['rez[]'] + '&';
                vm.rezoningSelected.push(vm.query['rez[]'])
            }
            if ($.isArray(vm.query['bp[]'])) {
                vm.query['bp[]'].forEach((a) => {
                    param += 'bp[]=' + a + '&';
                    vm.bpSelected.push(a);
                });
            }
            else if (typeof vm.query['bp[]'] == 'undefined') {
            }
            else {
                param += 'bp[]=' + vm.query['bp[]'] + '&';
                vm.bpSelected.push(vm.query['bp[]'])
            }
            if ($.isArray(vm.query['dvp[]'])) {
                vm.query['dvp[]'].forEach((a) => {
                    param += 'dvp[]=' + a + '&';
                    vm.dvpSelected.push(a);
                });
            }
            else if (typeof vm.query['dvp[]'] == 'undefined') {
            }
            else {
                param += 'dvp[]=' + vm.query['dvp[]'] + '&';
                vm.dvpSelected.push(vm.query['dvp[]'])
            }
            if ($.isArray(vm.query['ocp[]'])) {
                vm.query['ocp[]'].forEach((a) => {
                    param += 'ocp[]=' + a + '&';
                    vm.ocpSelected.push(a);
                });
            }
            else if (typeof vm.query['ocp[]'] == 'undefined') {
            }
            else {
                param += 'ocp[]=' + vm.query['ocp[]'] + '&';
                vm.ocpSelected.push(vm.query['ocp[]'])
            }
            if ($.isArray(vm.query['sub[]'])) {
                vm.query['sub[]'].forEach((a) => {
                    param += 'sub[]=' + a + '&';
                    vm.subSelected.push(a);
                });
            }
            else if (typeof vm.query['sub[]'] == 'undefined') {
            }
            else {
                param += 'sub[]=' + vm.query['sub[]'] + '&';
                vm.subSelected.push(vm.query['sub[]'])
            }
            if ($.isArray(vm.query['dp[]'])) {
                vm.query['dp[]'].forEach((a) => {
                    param += 'dp[]=' + a + '&';
                    vm.dpSelected.push(a);
                });
            }
            else if (typeof vm.query['dp[]'] == 'undefined') {
            }
            else {
                param += 'dp[]=' + vm.query['dp[]'] + '&';
                vm.dpSelected.push(vm.query['dp[]'])
            }

            if (vm.dateSearch.length > 0) {
                if (vm.dateSearch[0]) {
                    vm.query['salestart'] = vm.toTimestamp(vm.dateSearch[0]);
                }
                if (vm.dateSearch[1]) {
                    vm.query['saleend'] = vm.toTimestamp(vm.dateSearch[1]);
                }
            }
            if ($.isArray(vm.query['unittype[]'])) {
                vm.query['unittype[]'].forEach((a) => {
                    param += 'unittype[]=' + a + '&';
                    vm.gutSelected.push(a)
                });
            }
            else if (typeof vm.query['unittype[]'] == 'undefined') {
            }
            else {
                param += 'unittype[]=' + vm.query['unittype[]'] + '&';
                vm.gutSelected.push(vm.query['unittype[]'])
            }
            if ($.isArray(vm.query['type[]'])) {
                vm.query['type[]'].forEach((a) => {
                    param += 'type[]=' + a + '&';
                    vm.typeSelected.push(a)
                });
            }
            else if (typeof vm.query['type[]'] == 'undefined') {
            }
            else {
                param += 'type[]=' + vm.query['type[]'] + '&';
                vm.typeSelected.push(vm.query['type[]'])
            }
            if (vm.query['search']) {
                param += 'search='+vm.query['search'] + '&';;
            }
            if (vm.query['developer']) {
                param += 'developer='+vm.query['developer']+  '&';;
            }
            if ($.isArray(vm.query['status[]'])) {
                vm.query['status[]'].forEach((a) => {
                    param += 'status[]=' + a + '&';
                    this.statusSelected.push(a);
                    this.statusList.push(this.statusName(a));
                });
            }
            else if (typeof vm.query['status[]'] == 'undefined') {

            }
            else {
                param += 'status[]=' + vm.query['status[]'];
                this.statusSelected.push(vm.query['status[]']);
                this.statusList.push(this.statusName(vm.query['status[]']));
            }
            if (vm.query['unitsmin']) {
                vm.unitsMin = vm.query['unitsmin'];
            }
            if (vm.query['unitsmax']) {
                vm.unitsMax = vm.query['unitsmax'];
            }
            if (vm.query['storeymin']) {
                vm.storeyMin = vm.query['storeymin'];
            }
            if (vm.query['storeymax']) {
                vm.storeyMax = vm.query['storeymax'];
            }
            if (vm.query['search']) {
                vm.listSearch = vm.query['search'];
            }
            if (vm.query['developer']) {
                vm.developerSearch = vm.query['developer'];
            }
            if (vm.query['planningMap'] == '1') {
                this.planningView = false
                this.planningTab = true
                this.getPlanningDetails(param);
                this.searchStarted = true
                this.rightToggle = false
                this.currentTab = 'planning'
            }
            else if (vm.query['planningMap'] == '2') {
                this.planningTab = true
                this.planningView = true
                this.getPlanningDetails(param);
                this.searchStarted = true
                this.rightToggle = false
                this.currentTab = 'planning'
            }
            else {
                if (param) {
                    if (vm.query['report']) {
                        this.listing = false;
                    }
                    this.getReportDetails(param)
                    this.getReportExtra(param)
                    this.searchStarted = true
                    this.rightToggle = false
                }
                else {
                    this.mainMap();
                }
            }
        },
        computed: {
            mlsTotalSort: function () {
                var vm = this;
                var result = [];
                if (typeof vm.unitComponent.bed != 'undefined') {
                    Object.values(vm.unitComponent.bed).forEach(el => {
                        Object.values(el).forEach(single => {
                            result.push(single);
                        })
                    });
                    result.sort(function (a,b) {
                        if (a['bed'] == b['bed']) {
                            if (a['bath'] == b['bath']) {
                                if (a['total_size']/a['num'] < b['total_size']/b['num']) {
                                    return -1;
                                }
                                else {
                                    return 1;
                                }
                            }
                            else {
                                return (a['bath'] - b['bath']);
                            }
                        }
                        else {
                            return (a['bed'] - b['bed']);
                        }
                    })
                }
                return result.filter(i => i.bed != '');
            },
            projectSort: function () {
                var vm = this;
                var ob = this.projects;
                let digitSorting = {
                    'sort-psf' : 'total_avg_psf',
                    'sort-size' : 'total_avg_size'
                }
                Object.keys(digitSorting).forEach(function (k) {
                    if (k == vm.sortBy) {
                        if (vm.orderAsc) {
                            ob = vm.projects.sort((a,b) => 
                                {
                                    if (a[digitSorting[k]] == '' || a[digitSorting[k]] == null) {
                                        if (b[digitSorting[k]] > 0) {
                                            return -1;
                                        }
                                        else {
                                            return 1;
                                        }
                                    }
                                    if (b[digitSorting[k]] == '' || b[digitSorting[k]] == null) {
                                        if (a[digitSorting[k]] > 0) {
                                            return 1;
                                        }
                                        else {
                                            return -1;
                                        }
                                    }
                                    if (parseInt(a[digitSorting[k]]) > parseInt(b[digitSorting[k]])) {
                                        return 1;
                                    }
                                    else {
                                        return -1;
                                    }
                                }
                            );
                        }
                        else {
                            ob = vm.projects.sort((a,b) => 
                                {
                                    if (a[digitSorting[k]] == '' || a[digitSorting[k]] == null) {
                                        if (b[digitSorting[k]] > 0) {
                                            return 1;
                                        }
                                        else {
                                            return -1;
                                        }
                                    }
                                    if (b[digitSorting[k]] == '' || b[digitSorting[k]] == null) {
                                        if (a[digitSorting[k]] > 0) {
                                            return -1;
                                        }
                                        else {
                                            return 1;
                                        }
                                    }
                                    if (parseInt(a[digitSorting[k]]) > parseInt(b[digitSorting[k]])) {
                                        return -1;
                                    }
                                    else {
                                        return 1;
                                    }
                                }
                            );
                        }
                    }
                });
                return ob;
            },
            typesSort: function () {
                let alphSorting = {
                    'sort-ad' : 'address',
                    'sort-dev' : 'developer',
                    'sort-ptype' : 'project_type',
                    'sort-name' : 'project_name',
                    'sort-construction-status' : 'construction_status',
                }
                var vm = this;
                var ob = this.types;
                Object.keys(alphSorting).forEach(function (k) {
                    if (k == vm.sortBy) {
                        if (vm.orderAsc) {
                            ob = vm.types.sort((a,b) => (a[alphSorting[k]] > b[alphSorting[k]]) ? 1 : ((b[alphSorting[k]] > a[alphSorting[k]]) ? -1 : 0));
                        }
                        else {
                            ob = vm.types.sort((a,b) => (a[alphSorting[k]] < b[alphSorting[k]]) ? 1 : ((b[alphSorting[k]] < a[alphSorting[k]]) ? -1 : 0));
                        }
                    }
                });

                if (this.sortBy == 'date-special-sorting') {
                    let dateSortProcess = '';
                    let tmpAsc = true;
                    if (this.dpDateSort == 1) {
                        dateSortProcess = 'dp_sub_date';
                        tmpAsc = true;
                    }
                    if (this.dpDateSort == 2) {
                        dateSortProcess = 'dp_sub_date';
                        tmpAsc = false;
                    }
                    if (this.dpDateSort == 3) {
                        dateSortProcess = 'dp_app_date';
                        tmpAsc = true;
                    }
                    if (this.dpDateSort == 4) {
                        dateSortProcess = 'dp_app_date';
                        tmpAsc = false;
                    }
                    if (this.bpDateSort == 1) {
                        dateSortProcess = 'bp_sub_date';
                        tmpAsc = true;
                    }
                    if (this.bpDateSort == 2) {
                        dateSortProcess = 'bp_sub_date';
                        tmpAsc = false;
                    }
                    if (this.bpDateSort == 3) {
                        dateSortProcess = 'bp_app_date';
                        tmpAsc = true;
                    }
                    if (this.bpDateSort == 4) {
                        dateSortProcess = 'bp_app_date';
                        tmpAsc = false;
                    }
                    if (this.rzDateSort == 1) {
                        dateSortProcess = 'rz_sub_date';
                        tmpAsc = true;
                    }
                    if (this.rzDateSort == 2) {
                        dateSortProcess = 'rz_sub_date';
                        tmpAsc = false;
                    }
                    if (this.rzDateSort == 3) {
                        dateSortProcess = 'rz_app_date';
                        tmpAsc = true;
                    }
                    if (this.rzDateSort == 4) {
                        dateSortProcess = 'rz_app_date';
                        tmpAsc = false;
                    }
                    if (tmpAsc) {
                        ob = vm.types.sort((a,b) => 
                            {
                                if (a[dateSortProcess] == '') {
                                    return 1;
                                }
                                if (b[dateSortProcess] == '') {
                                    return -1;
                                }
                                if (Date.parse(a[dateSortProcess]) > Date.parse(b[dateSortProcess])) {
                                    return -1;
                                }
                                else {
                                    return 1;
                                }
                            }
                        );
                    }
                    else {
                        ob = vm.types.sort((a,b) => 
                            {
                                if (a[dateSortProcess] == '') {
                                    return -1;
                                }
                                if (b[dateSortProcess] == '') {
                                    return 1;
                                }
                                if (Date.parse(a[dateSortProcess]) > Date.parse(b[dateSortProcess])) {
                                    return 1;
                                }
                                else {
                                    return -1;
                                }
                            }
                        );
                    }
                }

                let digitSorting = {
                    'sort-story' : 'storeys',
                    'sort-total-u' : 'units',
                    'sort-sold' : 'sold_unit_percent',
                    'sort-psf': 'psf'
                }
                Object.keys(digitSorting).forEach(function (k) {
                    if (k == vm.sortBy) {
                        if (vm.orderAsc) {
                            ob = vm.types.sort((a,b) => 
                                {
                                    if (a[digitSorting[k]] == '' || a[digitSorting[k]] == null) {
                                        if (b[digitSorting[k]] > 0) {
                                            return -1;
                                        }
                                        else {
                                            return 1;
                                        }
                                    }
                                    if (b[digitSorting[k]] == '' || b[digitSorting[k]] == null) {
                                        if (a[digitSorting[k]] > 0) {
                                            return 1;
                                        }
                                        else {
                                            return -1;
                                        }
                                    }
                                    if (parseInt(a[digitSorting[k]]) > parseInt(b[digitSorting[k]])) {
                                        return 1;
                                    }
                                    else {
                                        return -1;
                                    }
                                }
                            );
                        }
                        else {
                            ob = vm.types.sort((a,b) => 
                                {
                                    if (a[digitSorting[k]] == '' || a[digitSorting[k]] == null) {
                                        if (b[digitSorting[k]] > 0) {
                                            return 1;
                                        }
                                        else {
                                            return -1;
                                        }
                                    }
                                    if (b[digitSorting[k]] == '' || b[digitSorting[k]] == null) {
                                        if (a[digitSorting[k]] > 0) {
                                            return -1;
                                        }
                                        else {
                                            return 1;
                                        }
                                    }
                                    if (parseInt(a[digitSorting[k]]) > parseInt(b[digitSorting[k]])) {
                                        return -1;
                                    }
                                    else {
                                        return 1;
                                    }
                                }
                            );
                        }
                    }
                });

                let dateSorting = {
                    'sort-sales-start-date' : 'sales_start_date',
                    'sort-construction-complete-date' : 'construction_complete_date',
                    'sort-sold-out-date' : 'sold_out_date',
                }
                Object.keys(dateSorting).forEach(function (k) {
                    if (k == vm.sortBy) {
                        if (vm.orderAsc) {
                            ob = vm.types.sort((a,b) => 
                                {
                                    if (a[dateSorting[k]] == '') {
                                        return 1;
                                    }
                                    if (b[dateSorting[k]] == '') {
                                        return -1;
                                    }
                                    if (Date.parse(a[dateSorting[k]]) > Date.parse(b[dateSorting[k]])) {
                                        return -1;
                                    }
                                    else {
                                        return 1;
                                    }
                                }
                            );
                        }
                        else {
                            ob = vm.types.sort((a,b) => 
                                {
                                    if (a[dateSorting[k]] == '') {
                                        return 1;
                                    }
                                    if (b[dateSorting[k]] == '') {
                                        return -1;
                                    }
                                    if (Date.parse(a[dateSorting[k]]) > Date.parse(b[dateSorting[k]])) {
                                        return -1;
                                    }
                                    else {
                                        return 1;
                                    }
                                }
                            );
                        }
                    }
                });

                return ob;
            }
        },
        watch: {
            citiesSelected: function(val, oldVal) {
                if (val.length === 1) {
                    var center = this.cityCenter(val[0]);
                    if (center) {
                        if (this.mapObj) {
                            this.mapObj.setZoom(center.zoom);
                            this.mapObj.setCenter(center);
                        }
                    }
                }
                else {
                    if (this.mapObj) {
                        this.mapObj.setZoom(11);
                        this.mapObj.setCenter({
                            lat: 49.18872777889199,
                            lng: -122.846467155292
                        });
                    }
                }
            },
            gutSelected: function(val, oldVal) {
                if (this.currentTab == 'projects') {
                    if ((val.includes('2952') && !oldVal.includes('2952'))) {
                        if (!this.statusSelected.includes('now_selling')) {
                            this.statusSelected.push('now_selling');
                        }
                        if (!this.statusSelected.includes('sold_out')) {
                            this.statusSelected.push('sold_out');
                        }
                    }
                    if ((val.includes('2954') && !oldVal.includes('2954'))) {
                        if (!this.statusSelected.includes('now_leasing')) {
                            this.statusSelected.push('now_leasing');
                        }
                        if (!this.statusSelected.includes('leased_out')) {
                            this.statusSelected.push('leased_out');
                        }
                    }
                }
                // const sale = ['2952', '2953'];
                // const lease = ['2954', '2955'];
                // const saleTest = sale.some(el => val.includes(el));
                // const leaseTest = lease.some(el => val.includes(el));

                // const status = this.statusSelected
                // const saleStatus = ['selling_soon', 'now_selling', 'sold_out'];
                // const leaseStatus = ['leasing_soon', 'now_leasing', 'leased_out'];
                // const saleStatusTest = saleStatus.some(el => status.includes(el));
                // const leaseStatusTest = leaseStatus.some(el => status.includes(el));

                // if ((saleTest && (leaseTest || leaseStatusTest)) || (leaseTest && (saleTest || saleStatusTest))) {
                //     const oldValTest = sale.some(el => oldVal.includes(el));
                //     if (oldValTest) {
                //         // old val contains sale, remove sale
                //         this.switchMessage = 'For Sale selections will be removed';
                //         this.$refs['transaction-modal'].show();
                //         this.removeSaleVal = true
                //     }
                //     else {
                //         // remove lease
                //         this.switchMessage = 'For Lease selections will be removed';
                //         this.$refs['transaction-modal'].show();
                //         this.removeSaleVal = false
                //     }
                // }

                // if (saleTest || saleStatusTest) {
                //     this.saleWithOptions = true
                // }
                // else {
                //     this.saleWithOptions = false
                // }
                // if (leaseTest || leaseStatusTest) {
                //     this.leaseWithOptions = true
                // }
                // else {
                //     this.leaseWithOptions = false
                // }
            },
            statusSelected: function(val, oldVal) {
                if (this.currentTab == 'projects') {
                    if ((val.includes('now_selling') && !oldVal.includes('now_selling')) || val.includes('sold_out') && !oldVal.includes('sold_out')) {
                        if (!this.gutSelected.includes('2952')) {
                            this.gutSelected.push('2952');
                        }
                    }
                    if ((val.includes('now_leasing') && !oldVal.includes('now_leasing')) || val.includes('leased_out') && !oldVal.includes('leased_out')) {
                        if (!this.gutSelected.includes('2954')) {
                            this.gutSelected.push('2954');
                        }
                    }
                }
                // if (this.currentTab == 'planning') {
                //     return
                // }
                // const sale = ['selling_soon', 'now_selling', 'sold_out'];
                // const lease = ['leasing_soon', 'now_leasing', 'leased_out'];
                // const saleTest = sale.some(el => val.includes(el));
                // const leaseTest = lease.some(el => val.includes(el));

                // const gut = this.gutSelected;
                // const saleGUT = ['2952', '2953'];
                // const leaseGUT = ['2954', '2955'];
                // const saleGUTTest = saleGUT.some(el => gut.includes(el));
                // const leaseGUTTest = leaseGUT.some(el => gut.includes(el));

                // if ((saleTest && (leaseTest || leaseGUTTest)) || (leaseTest && (saleTest || saleGUTTest))) {
                //     const oldValTest = sale.some(el => oldVal.includes(el));
                //     if (oldValTest) {
                //         // old val contains sale, remove sale
                //         this.switchMessage = 'For Sale selections will be removed';
                //         this.$refs['transaction-modal'].show();
                //         this.removeSaleVal = true
                //     }
                //     else {
                //         // remove lease
                //         this.switchMessage = 'For Lease selections will be removed';
                //         this.$refs['transaction-modal'].show();
                //         this.removeSaleVal = false
                //     }
                // }

                // if (saleTest || saleGUTTest) {
                //     this.saleWithOptions = true
                // }
                // else {
                //     this.saleWithOptions = false
                // }
                // if (leaseTest || leaseGUTTest) {
                //     this.leaseWithOptions = true
                // }
                // else {
                //     this.leaseWithOptions = false
                // }
            }
        },
        methods:{
            MLSReset() {

            },
            MLSGo() {
                if (!this.role) {
                    return;
                }
                const vm = this;
                let q = {};
                q['type[]'] = new Array();
                if (this.aptMLSIsActive) {
                    q['type[]'].push('2886');
                }
                // if (this.townhomeMLSIsActive) {
                //         q['type[]'].push('2870');
                // }
                // if (this.mixedUseAptMLSIsActive) {
                //         q['type[]'].push('2884');
                // }
                // if (this.podiumMLSIsActive) {
                //         q['type[]'].push('5910');
                // }
                // if (this.stackedTownhomeMLSIsActive) {
                //         q['type[]'].push('3479');
                // }
                // if (this.commercialMLSIsActive) {
                //         q['type[]'].push('2962');
                // }
                // if (this.industrialMLSIsActive) {
                //         q['type[]'].push('3047');
                // }
                // if (this.rowhomeMLSIsActive) {
                //         q['type[]'].push('6240');
                // }
                if (this.statusMLSSelected) {
                    q['status[]'] = this.statusMLSSelected;
                }
                if (this.mlsCitiesSelected) {
                    q['city[]'] = this.mlsCitiesSelected;
                }
                if (this.gutMLSSelected) {
                    q['gut[]'] = this.gutMLSSelected;
                }
                if (this.fpSpecsSelected) {
                    q['fp[]'] = this.fpSpecsSelected;
                }
                if (this.mlsBedsMax) {
                    q['mlsbedsmax'] = this.mlsBedsMax;
                }
                if (this.mlsBedsMin) {
                    q['mlsbedsmin'] = this.mlsBedsMin;
                }
                if (this.mlsBathsMax) {
                    q['mlsbathsmax'] = this.mlsBathsMax;
                }
                if (this.mlsBathsMin) {
                    q['mlsbathsmin'] = this.mlsBathsMin;
                }
                if (this.mlsUnitMax) {
                    q['mlsunitmax'] = this.mlsUnitMax;
                }
                if (this.mlsUnitMin) {
                    q['mlsunitmin'] = this.mlsUnitMin;
                }
                if (this.listMLSDate) {
                    q['listmlsdate[]'] = new Array();
                }
                this.listMLSDate.forEach(function(value, i){
                    q['listmlsdate[]'].push(vm.toTimestamp(value));
                });
                if (this.soldMLSDate) {
                    q['soldmlsdate[]'] = new Array();
                }
                this.soldMLSDate.forEach(function(value, i){
                    q['soldmlsdate[]'].push(vm.toTimestamp(value));
                });
                if (this.mlsListPriceMin) {
                    q['mlslistpricemin'] = this.mlsListPriceMin;
                }
                if (this.mlsListPriceMax) {
                    q['mlslistpricemax'] = this.mlsListPriceMax;
                }
                if (this.mlsSoldPriceMin) {
                    q['mlssoldpricemin'] = this.mlsSoldPriceMin;
                }
                if (this.mlsSoldPriceMax) {
                    q['mlssoldpricemax'] = this.mlsSoldPriceMax;
                }
            
                this.$router.push({ path: '/mls-list', query: q});
                this.$router.go();
            },
            proposedZoningOptions({ action, searchQuery, callback }) {
                var vm = this
                const simulateAsyncOperation = fn => {
                    setTimeout(fn, 2000)
                }
                simulateAsyncOperation(() => {
                    const options = vm.proposedZoningOpt.filter(word => word.label.includes(searchQuery))
                    callback(null, options)
                })
            },
            // developerOptions({ action, searchQuery, callback }) {
            //     var vm = this
            //     const simulateAsyncOperation = fn => {
            //         setTimeout(fn, 2000)
            //     }
            //     simulateAsyncOperation(() => {
            //         const options = vm.developerOpt.filter(word => word.label.includes(searchQuery))
            //         callback(null, options)
            //     })
            // },
            // listSearchOptions({ action, searchQuery, callback }) {
            //     var vm = this
            //     const simulateAsyncOperation = fn => {
            //         setTimeout(fn, 2000)
            //     }
            //     simulateAsyncOperation(() => {
            //         const options = vm.listOpt.filter(word => word.label.includes(searchQuery))
            //         callback(null, options)
            //     })
            // },
            closeFP() {
                this.$refs['mls-unit-modal'].hide();
            },
            assignFP: function(fp) {
                this.selectedFP = fp
                this.$refs['mls-unit-modal'].show();
                console.log(this.selectedFP)
            },
            removeCity: function(index) {
                this.citiesSelected.splice(index, 1);
            },
            removeGut: function(index) {
                this.gutSelected.splice(index, 1);
            },
            removeType: function(index) {
                this.typeSelected.splice(index, 1);
            },
            removeStatus: function(index) {
                this.statusSelected.splice(index, 1);
            },
            cityCenter: function(tid) {
                switch (tid) {
                    case '2895':
                        // vancouver
                        return {
                            zoom: 13,
                            lat: 49.250313510566556,
                            lng: -123.14344144576891
                        };
                    case '2877':
                        // richmond
                        return {
                            zoom: 15,
                            lat: 49.16252386075193,
                            lng: -123.13185419447657
                        };
                    case '2873':
                        // surrey
                        return {
                            zoom: 15,
                            lat: 49.24611675552011,
                            lng: -122.98174313299656
                        };
                    case '2887':
                        // burnaby
                        return {
                            zoom: 15,
                            lat: 49.18961451378553,
                            lng: -122.85001640971345
                        };
                }
            },
            nameSwitch: function(tid) {
                switch (tid) {
                    case '2952':
                        return 'Market Strata'
                    case '2970':
                        return 'Secured Market Rental'
                    case '2953':
                        return 'Below-Market Strata'
                    case '3482':
                        return 'Commercial'
                    case '3515':
                        return 'Industrial'
                    case 'selling_soon':
                        return 'Selling Soon'
                    case 'now_selling':
                        return 'Now Selling'
                    case 'sold_out':
                        return 'Sold Out'
                    case '2954':
                        return 'Market Rental'
                    case '2955':
                        return 'Below-Market Rental'
                    case 'leasing_soon':
                        return 'Leasing Soon'
                    case 'now_leasing':
                        return 'Now Leasing'
                    case 'leased_out':
                        return 'Leased Out'
                    case '2887':
                        return 'Surrey'
                    case '2879':
                        return 'Langley (Township)'
                    case '3556':
                        return 'Langley (City)'
                    case '2876':
                        return 'Abbotsford'
                    case '2898':
                        return 'Delta'
                    case '3609':
                        return 'Mission'
                    case '2897':
                        return 'White Rock'
                    case '2895':
                        return 'Vancouver'
                    case '2874':
                        return 'Coquitlam'
                    case '2873':
                        return 'Burnaby'
                    case '2877':
                        return 'Richmond'
                    case '2949':
                        return 'North Van (City)'
                    case '2889':
                        return 'New Westminster'
                    case '2950':
                        return 'North Van (Dist)'
                    case '2896':
                        return 'West Vancouver'
                    case '2894':
                        return 'Squamish'
                    case '2892':
                        return 'Port Coquitlam'
                    case '2893':
                        return 'Port Coquitlam'
                    case '2888':
                        return 'Maple Ridge'
                    case '2891':
                        return 'Pitt Meadows'
                    case 'in_planning':
                        return 'In Planning';
                    case '3031':
                        return 'Office';
                    case '2960':
                        return 'Retail';
                    case '3515':
                        return 'Industrial';
                }
            },
            selectAll: function() {
                if (!this.allSelected) {
                    for (let report in this.filteredReportDetail) {
                        this.selectedSummary.push(this.filteredReportDetail[report].uid);
                    }
                }
                else {
                    this.selectedSummary = [];
                }
            },
            cityPreviewOn: function() {
                this.cityPreview = true;
            },
            cityPreviewOff: function() {
                if (this.cityPreview) {
                    this.cityPreview = false;
                }
            },
            fieldsToggleOff: function() {
                this.fieldsToggle = false;
                if (this.floatingFilters) {
                    this.floatingFilters = false;
                }
            },
            fieldsOn: function() {
                this.reportFields = [];
                if (this.list1.length > 12) {
                    let poped = this.list1.pop();
                    this.list2.push(poped);
                }
                this.list1.forEach((val, key) => {
                    this.reportFields.push(val.field);
                });
            },
            goto(link) {
                window.open(link, '_blank');
            },
            cleanOpt(mode) {
                this.gutSelected = [];
                this.typeSelected = [];
                this.statusSelected = [];
                this.citiesSelected = [];
                if (mode == '1') {
                    this.currentTab = 'projects'
                }
                if (mode == '2') {
                    this.currentTab = 'planning'
                }
                if (mode == '3') {
                    this.currentTab = 'land'
                }
                if (mode == '4') {
                    this.currentTab = 'unit'
                }
            },
            toggleListing() {
                if (this.planningTab) {
                    this.planningView = true;
                    this.currentTab = 'planning'
                }
                else {
                    this.listing = false
                    this.currentTab = 'projects'
                }
            },
            permitName (name) {
                switch (name) {
                    case '0':
                        return 'Not Submitted'
                    case '10943':
                        return 'In Process'
                    case '10944':
                        return 'Approved'
                    case '10945':
                        return 'Adopted'
                    case '10946':
                        return 'Denied'
                    default:
                        return ''
                }
            },
            statusName (name) {
                switch (name) {
                    case 'now_selling':
                        return 'Now Selling';
                    case 'selling_soon':
                        return 'Selling Soon';
                    case 'in_planning':
                        return 'In Planning';
                    case 'sold_out':
                    case 'sold_out_2':
                        return 'Sold Out';
                    case 'new_leasing':
                        return 'Now Leasing';
                    case 'leased_out':
                        return 'Leased Out';
                    case 'leasing_soon':
                        return 'Leasing Soon';
                }
            },
            typeName (name) {
                switch (name) {
                    case '2886':
                        return 'Apartment';
                    case '2870':
                        return 'Townhome';
                    case '2884':
                        return 'Mixed-Use Apt';
                    case '3479':
                        return 'Stacked Townhome';
                    case '2962':
                        return 'Commercial';
                    case '3047':
                        return 'Industrial';
                    case '6240':
                        return 'Row Home';
                    case '5910':
                        return 'Podium';
                }
            },
            goBackPlanning() {
                this.planningView = false
                setTimeout(() => {
                    this.planningMap();
                }, "300");
            },
            removeSale() {
                this.statusSelected = this.statusSelected.filter(status => ['leasing_soon', 'now_leasing', 'leased_out'].includes(status));
                this.gutSelected = this.gutSelected.filter(gut => ['2954', '2955'].includes(gut));
                this.$refs['transaction-modal'].hide();
            },
            removeLease() {
                this.statusSelected = this.statusSelected.filter(status => ['selling_soon', 'now_selling', 'sold_out'].includes(status));
                this.gutSelected = this.gutSelected.filter(gut => ['2952', '2953'].includes(gut));
                this.$refs['transaction-modal'].hide();
            },
            hideTransaction() {
                this.$refs['transaction-modal'].hide();
            },
            toTimestamp(strDate){
                var datum = Date.parse(strDate);
                return datum/1000;
            },
            openGV: function() {
                this.gvOptions = !this.gvOptions
            },
            openSummaryGV: function() {
                this.gvSummaryOptions = !this.gvSummaryOptions
            },
            gvSummaryOff: function() {
                this.gvSummaryOptions = false
            },
            gvOff: function() {
                this.gvOptions = false
            },
            openFV: function() {
                this.fvOptions = !this.fvOptions
            },
            openSummaryFV: function() {
                this.fvSummaryOptions = !this.fvSummaryOptions
            },
            fvSummaryOff: function() {
                this.fvSummaryOptions = false
            },
            fvOff: function() {
                this.fvOptions = false
            },
            openLease: function() {
                this.leaseOptions = !this.leaseOptions
            },
            openLeaseSummary: function() {
                this.leaseSummaryOptions = !this.leaseSummaryOptions
            },
            openCommercialSummary: function() {
                this.commercialSummaryOptions = !this.commercialSummaryOptions
            },
            openCommercial: function() {
                this.commercialOptions = !this.commercialOptions
            },
            leaseSummaryOff: function(event) {
                this.leaseSummaryOptions = false;
            },
            residentialOff: function() {
                this.residentialOption = false;
            },
            commercialOff: function() {
                this.commercialOptions = false;
            },
            commercialSummaryOff: function() {
                this.commercialSummaryOptions = false;
            },
            residentialSummaryOff: function() {
                this.residentialSummaryOptions = false;
            },
            openSale: function() {
                this.saleOptions = !this.saleOptions
            },
            openResidential: function() {
                this.residentialOption = !this.residentialOption
            },
            openResidentialSummary: function() {
                this.residentialSummaryOption = !this.residentialSummaryOption
            },
            saleOff: function(event) {
                this.saleOptions = false
            },
            openPlanningGVSummary: function() {
                this.gvPlanningSummaryOptions = !this.gvPlanningSummaryOptions
            },
            openPlanningGV: function() {
                this.gvPlanningOptions = !this.gvPlanningOptions
            },
            gvPlanningOff: function() {
                this.gvPlanningOptions = false
            },
            gvPlanningSummaryOff: function() {
                this.gvPlanningSummaryOptions = false
            },
            openPlanningFV: function() {
                this.fvPlanningOptions = !this.fvPlanningOptions
            },
            openPlanningSummaryFV: function() {
                this.fvPlanningSummaryOptions = !this.fvPlanningSummaryOptions
            },
            fvPlanningOff: function() {
                this.fvPlanningOptions = false
            },
            fvPlanningSummaryOff: function() {
                this.fvPlanningSummaryOptions = false
            },
            openPlanningLease: function() {
                this.leasePlanningOptions = !this.leasePlanningOptions
            },
            leasePlanningOff: function(event) {
                this.leasePlanningOptions = false;
            },
            openPlanningSummaryLease: function() {
                this.leasePlanningSummaryOptions = !this.leasePlanningSummaryOptions
            },
            leasePlanningSummaryOff: function(event) {
                this.leasePlanningSummaryOptions = false;
            },
            openPlanningSale: function() {
                this.salePlanningOptions = !this.salePlanningOptions
            },
            salePlanningOff: function(event) {
                this.salePlanningOptions = false
            },
            salePlanningSummaryOff: function(event) {
                this.salePlanningSummaryOptions = false
            },
            openPlanningSummarySale: function() {
                this.salePlanningSummaryOptions = !this.salePlanningSummaryOptions
            },
            sortUpdate: function(sortBy, orderAsc) {
                this.sortBy = sortBy
                this.orderAsc = orderAsc
            },
            getColor: function(color) {
                switch (color) {
                    case "Selling Soon":
                        return 'status-color-selling-soon'
                    case "In Planning":
                        return 'status-color-in-planning'
                    case "Leasing Soon":
                        return 'status-color-leasing-soon'
                    case "Now Selling":
                        return 'status-color-now-selling'
                    case "Now Leasing":
                        return 'status-color-now-leasing'
                    case "Leased Out":
                        return 'status-color-leased-out'
                    case "Sold Out":
                        return 'status-color-sold-out'
                    case "Sold Out 2":
                        return 'status-color-sold-out'
                    default:
                        break;
                }
            },
            numberWithCommas: function(x) {
                if (x) {
                    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                }
                else {
                    return x;
                }
            },
            moreFilter() {
                $(".hidden-listing-filter").slideToggle(500);
                // $(this).find("span").toggleClass("mfilopact");
            },
            toggleBool(val) {
                this[val] = !this[val];
            },
            statusName (name) {
                switch (name) {
                    case 'now_selling':
                        return 'Now Selling';
                    case 'selling_soon':
                        return 'Selling Soon';
                    case 'in_planning':
                        return 'In Planning';
                    case 'sold_out':
                    case 'sold_out_2':
                        return 'Sold Out';
                    case 'new_leasing':
                        return 'Now Leasing';
                    case 'leased_out':
                        return 'Leased Out';
                    case 'leasing_soon':
                        return 'Leasing Soon';
                }
            },
            typeName (name) {
                switch (name) {
                    case '2886':
                        return 'Apartment';
                    case '2870':
                        return 'Townhome';
                    case '2884':
                        return 'Mixed-Use Apt';
                    case '3479':
                        return 'Stacked Townhome';
                    case '2962':
                        return 'Commercial';
                    case '3047':
                        return 'Industrial';
                    case '6240':
                        return 'Row Home';
                    case '5910':
                        return 'Podium';
                }
            },
            classStatus: classStatus,
            displayOptions (field, skipCurrentField) {
                if (!skipCurrentField) this.optionsIsVisible[field] = !this.optionsIsVisible[field];
                Object.keys(this.optionsIsVisible).forEach((key) => {
                    if (key !== field) this.optionsIsVisible[key] = false;
                })
                this.optionsIsVisible = Object.assign({}, this.optionsIsVisible);
            },
            containOption (field, selectedItem) {
                if (this.filter[field].includes(selectedItem)) {
                    this.filter[field].splice(this.filter[field].indexOf(selectedItem), 1)
                } else {
                    this.filter[field].push(selectedItem);
                }
                this.filter = Object.assign({}, this.filter);
                this.filterReportDetailContains(field);
            },
            selectOption (field, selectedItem) {
                if (this.filter[field].includes(selectedItem)) {
                    this.filter[field].splice(this.filter[field].indexOf(selectedItem), 1)
                } else {
                    this.filter[field].push(selectedItem);
                }
                this.filter = Object.assign({}, this.filter);
                this.filterReportDetail(field);
            },
            fieldSwitch(field) {
                switch (field) {
                    case 'project_type':
                        return "Type & Storey";
                    case 'location':
                        return "Location";
                    case 'general_unit_type':
                        return 'General Unit Type';
                    case 'rezoning_status':
                        return 'Rezoning Status';
                    case 'dp_status':
                        return 'DP Status';
                    case 'bp_status':
                        return 'BP Status';
                    case 'floor_area':
                        return 'Floor Area';
                    case 'units_utc_da':
                        return 'Units DA';
                    case 'units_utc':
                        return 'Units';
                    case 'construction_status':
                        return 'Construction Status';
                    case 'presale_name':
                        return 'Presale Name';
                    case 'presale_lot_area':
                        return 'Total Lot Area (Sqft)';
                    case 'nid':
                        return 'Page ID';
                    case 'status':
                        return 'Project Status';
                    case 'developer':
                        return 'Developer';
                    case 'current_avg_psf':
                        return 'Current Average $PSF';
                    case 'sold_units':
                        return 'Sold Units';
                    case 'sales_start_date':
                        return 'Sales Start';
                    case 'project_market':
                        return 'Project Marketing';
                    case 'general_contractor':
                        return 'General Contractor';
                    case 'construction_start_date':
                        return 'Construction Start Date';
                    case 'construction_complete_date':
                        return 'Construction Completion Date';
                    case 'total_units':
                        return 'Total Units';
                    case 'rlsd_units':
                        return 'Rlsd Units';
                    case 'available':
                        return 'Avail Units';
                    case 'total_psf':
                        return 'Total PSF';
                    case 'total_sold_units':
                        return 'Sold Units';
                    case 'total_avg_size':
                        return 'Avg Size';
                    case 'sold_out_date':
                        return 'Sales Finish';
                    case 'total_avg_psf':
                        return 'Avg $PSF';
                    case 'total_avg_price':
                        return 'Avg Price';
                    case 'updated':
                        return 'Last Updated';
                    case 'current_avg_size':
                        return 'Current Avg Size';
                    case 'current_avg_price':
                        return 'Current Avg Price';
                    case 'storey':
                        return 'Storey';
                    case 'application_stage':
                        return 'Application Stage';
                    case 'application_date':
                        return 'Application Date';
                    case 'current_avg_psf':
                        return 'Current Avg $PSF';
                    case 'dom':
                        return 'Days On Market';
                    case 'city':
                        return 'Municipality';
                    case 'neighbour':
                        return 'Neighbourhood';
                }
            },
            dataSwitch(field, data) {
                switch (field) {
                    case 'project_type':
                        return data.project_type.replace('Mixed-Use Apartment', 'Mixed-Use Apt');
                    case 'general_unit_type':
                        return data.type;
                    case 'rezoning_status':
                        return data.rz_status ? data.rz_status : '-';
                    case 'dp_status':
                        return data.dp_status ? data.dp_status : '-';
                    case 'bp_status':
                        return data.bp_status ? data.bp_status : '-';
                    case 'units_utc_da':
                        return data.units_utc_da ? data.units_utc_da : '-';
                    case 'floor_area':
                        return data.floor_area ? data.floor_area : '-';
                    case 'units_utc':
                        return data.units_utc ? data.units_utc : '-';
                    case 'construction_status':
                        return data.construction_status ? data.construction_status : '-';
                    case 'presale_name':
                        return data.presale_name ? data.presale_name : '-';
                    case 'presale_lot_area':
                        return data.presale_lot_area ? data.presale_lot_area : '-';
                    case 'nid':
                        return data.nid ? data.nid : '-';
                    case 'status':
                        return data.status ? data.status : '-';
                    case 'developer':
                        return data.developer ? data.developer : '-';
                    case 'total_avg_psf':
                        return data.total_avg_psf ? '$' + this.numberWithCommas(data.total_avg_psf) : '-';
                    case 'current_avg_psf':
                        return data.current_avg_psf ? '$' + this.numberWithCommas(data.current_avg_psf) : '-';
                    case 'sales_start_date':
                        return data.sales_start_date ? data.sales_start_date : '-';
                    case 'sold_out_date':
                        return data.sold_out_date ? data.sold_out_date : '-';
                    case 'project_market':
                        return data.project_marketing ? data.project_marketing : '-';
                    case 'general_contractor':
                        return data.general_contractor ? data.general_contractor : '-';
                    case 'construction_start_date':
                        return data.construction_start_date ? data.construction_start_date : '-';
                    case 'construction_complete_date':
                        return data.construction_complete_date ? data.construction_complete_date : '-';
                    case 'original_type':
                        return data.original_type ? data.original_type : '-';
                    case 'total_units':
                        return data.total_units ? data.total_units : '-';
                    case 'total_psf':
                        return data.total_psf ? data.total_psf : '-';
                    case 'total_sold_units':
                        return (data.sold_units === '0' || data.sold_units > 0) ? data.sold_units : '-';
                    case 'sold_units':
                        return (data.sold_units === '0' || data.sold_units > 0) ? data.sold_units : '-';
                    case 'rlsd_units':
                        return (data.rlsd_units === '0' || data.rlsd_units > 0) ? data.rlsd_units : '-';
                    case 'available':
                        return data.available ? data.available : '0';
                    case 'updated':
                        return data.updated ? data.updated : '-';
                    case 'total_avg_size':
                        return data.total_avg_size ? this.numberWithCommas(data.total_avg_size) : '-';
                    case 'total_avg_price':
                        return data.total_avg_price ? '$' + this.numberWithCommas(data.total_avg_price) : '-';
                    case 'current_avg_size':
                        return data.current_avg_size ? this.numberWithCommas(data.current_avg_size) : '-';
                    case 'current_avg_price':
                        return data.current_avg_price ? '$' + this.numberWithCommas(data.current_avg_price) : '-';
                    case 'storey':
                        return (data.storey === '0' || data.storey > 0) ? data.storey : '-';
                    case 'application_stage':
                        return data.application_stage ? data.application_stage : '-';
                    case 'application_date':
                        return data.application_date ? data.application_date : '-';
                    case 'dom':
                        return data.dom ? data.dom : '-';
                    case 'city':
                        return data.city ? data.city : '-';
                    case 'neighbour':
                        return data.neighbour ? data.neighbour : '-';
                }
            },
            filterReportDetailContains (field) {
                this.displayOptions(field, true);
                this.filteredReportDetail = this.reportDetail
                    .filter((item) => (!this.filter[field].length || this.filter[field].some(el => this.dataSwitch(field, item).includes(el))))
                Object.keys(this.filter).forEach((key) => {
                    if (key !== field) this.filter[key] = []
                })
            },
            filterReportDetail (field) {
                this.displayOptions(field, true);
                this.filteredReportDetail = this.reportDetail
                    .filter((item) => (!this.filter[field].length || this.filter[field].includes(this.dataSwitch(field, item))))
                Object.keys(this.filter).forEach((key) => {
                    if (key !== field) this.filter[key] = []
                })
            },
            getReportExtra (params) {
                const endPoint = `api/get_projects_report_utc?${params}`;
                this.is_loading = true;
                $.get({
                    url: BACKEND_URL + endPoint,
                }, (data, status) => {
                    this.is_loading = false;
                    if (status !== 'success') return;
                    const keys = ['project_type', 'rezoning_status', 'dp_status', 'bp_status', 'construction_status', 'status']
                    keys.forEach((key) => {
                        this.filter[key] = [];
                        this.optionsIsVisible[key] = false;
                        this.filterOptions[key] = this.unique(data.map((item) => this.dataSwitch(key, item)));
                    })

                    let gut_all = [];
                    for (let val of data) {
                        for (let obj of val.original_type) {
                            gut_all.push(obj)
                        }
                    }
                    this.filter['general_unit_type'] = [];
                    this.optionsIsVisible['general_unit_type'] = false;
                    this.filterOptions['general_unit_type'] = this.unique(gut_all);

                    this.reportDetail = cloneDeep(data);
                    this.filteredReportDetail = cloneDeep(data);
                });
                
            },
            unique(arr){
                var newArr = [];
                for(var i = 0; i < arr.length; i++){
                    if(arr[i] && newArr.indexOf(arr[i]) === -1){
                        newArr.push(arr[i])
                    }
                }
                return newArr;
            },   
            sort(name) {
                this.asc = !this.asc
                let alphSorting = {
                    'application_stage' : 'application_stage',
                    'developer' : 'developer',
                    'name' : 'name',
                    'city' : 'city',
                    'neighbour' : 'neighbour',
                }
                var vm = this;
                var ob = this.filteredReportDetail;
                Object.keys(alphSorting).forEach(function (k) {
                    if (k == name) {
                        if (vm.asc) {
                            ob = vm.filteredReportDetail.sort((a,b) => (a[alphSorting[k]] > b[alphSorting[k]]) ? 1 : ((b[alphSorting[k]] > a[alphSorting[k]]) ? -1 : 0));
                        }
                        else {
                            ob = vm.filteredReportDetail.sort((a,b) => (a[alphSorting[k]] < b[alphSorting[k]]) ? 1 : ((b[alphSorting[k]] < a[alphSorting[k]]) ? -1 : 0));
                        }
                    }
                });

                let dateSorting = {
                    'sales_start_date' : 'sales_start_date',
                    'application_date' : 'application_date',
                    'sold_out_date' : 'sold_out_date',
                    'updated' : 'updated',
                }
                Object.keys(dateSorting).forEach(function (k) {
                    if (k == name) {
                        if (vm.asc) {
                            ob = vm.filteredReportDetail.sort((a,b) => 
                                {
                                    if (a[dateSorting[k]] == '') {
                                        return 1;
                                    }
                                    if (b[dateSorting[k]] == '') {
                                        return -1;
                                    }
                                    if (Date.parse(a[dateSorting[k]]) > Date.parse(b[dateSorting[k]])) {
                                        return -1;
                                    }
                                    else {
                                        return 1;
                                    }
                                }
                            );
                        }
                        else {
                            ob = vm.filteredReportDetail.sort((a,b) => 
                                {
                                    if (a[dateSorting[k]] == '') {
                                        return -1;
                                    }
                                    if (b[dateSorting[k]] == '') {
                                        return 1;
                                    }
                                    if (Date.parse(a[dateSorting[k]]) > Date.parse(b[dateSorting[k]])) {
                                        return 1;
                                    }
                                    else {
                                        return -1;
                                    }
                                }
                            );
                        }
                    }
                });

                let digitSorting = {
                    'total_units' : 'total_units',
                    'rlsd_units' : 'rlsd_units',
                    'sold_units' : 'sold_units',
                    'available' : 'available',
                    'total_avg_size' : 'total_avg_size',
                    'total_avg_psf' : 'total_avg_psf',
                    'total_avg_price' : 'total_avg_price',
                    'storey' : 'storey',
                    'current_avg_size' : 'current_avg_size',
                    'current_avg_price' : 'current_avg_price',
                    'current_avg_psf' : 'current_avg_psf',
                    'dom' : 'dom',
                }
                Object.keys(digitSorting).forEach(function (k) {
                    if (k == name) {
                        if (vm.asc) {
                            ob = vm.filteredReportDetail.sort((a,b) => 
                                {
                                    if (a[digitSorting[k]] == '' || a[digitSorting[k]] == null) {
                                        if (b[digitSorting[k]] > 0) {
                                            return -1;
                                        }
                                        else {
                                            return 1;
                                        }
                                    }
                                    if (b[digitSorting[k]] == '' || b[digitSorting[k]] == null) {
                                        if (a[digitSorting[k]] > 0) {
                                            return 1;
                                        }
                                        else {
                                            return -1;
                                        }
                                    }
                                    if (parseInt(a[digitSorting[k]]) > parseInt(b[digitSorting[k]])) {
                                        return 1;
                                    }
                                    else {
                                        return -1;
                                    }
                                }
                            );
                        }
                        else {
                            ob = vm.filteredReportDetail.sort((a,b) => 
                                {
                                    if (a[digitSorting[k]] == '' || a[digitSorting[k]] == null) {
                                        if (b[digitSorting[k]] > 0) {
                                            return 1;
                                        }
                                        else {
                                            return -1;
                                        }
                                    }
                                    if (b[digitSorting[k]] == '' || b[digitSorting[k]] == null) {
                                        if (a[digitSorting[k]] > 0) {
                                            return -1;
                                        }
                                        else {
                                            return 1;
                                        }
                                    }
                                    if (parseInt(a[digitSorting[k]]) > parseInt(b[digitSorting[k]])) {
                                        return -1;
                                    }
                                    else {
                                        return 1;
                                    }
                                }
                            );
                        }
                    }
                });
                this.filteredReportDetail = ob
            },
            onReport(table) {
                if (!this.role) {
                    return;
                }
                const vm = this;
                let q = {};
                q['type[]'] = new Array();
                q['city[]'] = new Array();
                q['status[]'] = new Array();
                q['constructionstatus[]'] = new Array();
                q['unittype[]'] = new Array();
                if (this.unitsMin) {
                    q['unitsmin'] = this.unitsMin;
                }
                if (this.unitsMax) {
                    q['unitsmax'] = this.unitsMax;
                }
                if (this.storeyMin) {
                    q['storeymin'] = this.storeyMin;
                }
                if (this.storeyMax) {
                    q['storeymax'] = this.storeyMax;
                }
                if (this.rzSubDate) {
                    q['rzSubDate[]'] = new Array();
                }
                if (this.citiesSelected) {
                    q['city[]'] = this.citiesSelected;
                }
                // if (this.gvCitiesSelected || this.fvCitiesSelected) {
                //     q['city[]'] = this.gvCitiesSelected.concat(this.fvCitiesSelected);
                // }
                if (this.statusSelected.length > 0) {
                    q['status[]'] = this.statusSelected;
                }
                else {
                    q['status[]'] = ['now_selling', 'now_leasing', 'sold_out', 'leased_out'];
                }
                if (this.gutSelected) {
                    q['unittype[]'] = this.gutSelected;
                }
                if (this.typeSelected.length > 0) {
                    q['type[]'] = this.typeSelected;
                }
                else {
                    q['type[]'] = ['2886', '2884', '2870', '3479'];
                }
                this.rzSubDate.forEach(function(value, i){
                    q['rzSubDate[]'].push(vm.toTimestamp(value));
                });

                if (this.rzAppDate) {
                    q['rzAppDate[]'] = new Array();
                }
                this.rzAppDate.forEach(function(value, i){
                    q['rzAppDate[]'].push(vm.toTimestamp(value));
                });

                if (this.dpSubDate) {
                    q['dpSubDate[]'] = new Array();
                }
                this.dpSubDate.forEach(function(value, i){
                    q['dpSubDate[]'].push(vm.toTimestamp(value));
                });

                if (this.bpSubDate) {
                    q['bpSubDate[]'] = new Array();
                }
                this.bpSubDate.forEach(function(value, i){
                    q['bpSubDate[]'].push(vm.toTimestamp(value));
                });

                if (this.dpIssueDate) {
                    q['dpIssueDate[]'] = new Array();
                }
                this.dpIssueDate.forEach(function(value, i){
                    q['dpIssueDate[]'].push(vm.toTimestamp(value));
                });

                if (this.bpIssueDate) {
                    q['bpIssueDate[]'] = new Array();
                }
                this.bpIssueDate.forEach(function(value, i){
                    q['bpIssueDate[]'].push(vm.toTimestamp(value));
                });

                //  status group
                if (this.rzStatus) {
                    q['rzStatus[]'] = new Array();
                }
                this.rzStatus.forEach(function(value, i){
                    q['rzStatus[]'].push(value);
                });

                if (this.bpStatus) {
                    q['bpStatus[]'] = new Array();
                }
                this.bpStatus.forEach(function(value, i){
                    q['bpStatus[]'].push(value);
                });

                if (this.dpStatus) {
                    q['dpStatus[]'] = new Array();
                }
                this.dpStatus.forEach(function(value, i){
                    q['dpStatus[]'].push(value);
                });
                if (this.listSearch) {
                    q = {};
                    q['search'] = this.listSearch;
                }
                if (this.developerSearch) {
                    q = {};
                    q['developer'] = this.developerSearch;
                }
                if (table) {
                    q['report'] = ['true'];

                    this.$router.push({ path: '/listing-new', query: q});
                }
                else {
                    this.$router.push({ path: '/listing-new', query: q});
                }
                this.$router.go();
            },
            toggleFloatingFilter() {
                this.floatingFilters = !this.floatingFilters;
            },
            toggleFloatingFilterSecond() {
                this.floatSecond = !this.floatSecond;
            },
            floatSecondOff() {
                if (this.floatSecond) {
                    this.floatSecond = false;
                }
                if (this.cityPreview) {
                    this.cityPreview = false;
                }
            },
            refreshResults() {
                if (this.selectedSummary.length > 0) {
                    this.filteredReportDetail = this.filteredReportDetail.filter(report => this.selectedSummary.includes(report.uid));
                }
            },
            onReportListing(table) {
                if (!this.role) {
                    return;
                }
                const vm = this;
                let q = {};
                q['type[]'] = new Array();
                q['city[]'] = new Array();
                q['status[]'] = new Array();
                q['constructionstatus[]'] = new Array();
                q['unittype[]'] = new Array();
                if (this.listSearch) {
                    q['search'] = this.listSearch;
                }
                if (this.unitsMin) {
                    q['unitsmin'] = this.unitsMin;
                }
                if (this.unitsMax) {
                    q['unitsmax'] = this.unitsMax;
                }
                if (this.storeyMin) {
                    q['storeymin'] = this.storeyMin;
                }
                if (this.storeyMax) {
                    q['storeymax'] = this.storeyMax;
                }
                if (this.developerSearch) {
                    q['developer'] = this.developerSearch;
                }
                q['report[]'] = new Array();
                if (this.aptIsActive) {
                    q['type[]'].push('2886');
                }
                if (this.townhomeIsActive) {
                     q['type[]'].push('2870');
                }
                if (this.mixedUseAptIsActive) {
                     q['type[]'].push('2884');
                }
                if (this.podiumIsActive) {
                     q['type[]'].push('5910');
                }
                if (this.stackedTownhomeIsActive) {
                     q['type[]'].push('3479');
                }
                if (this.commercialIsActive) {
                     q['type[]'].push('2962');
                }
                if (this.industrialIsActive) {
                     q['type[]'].push('3047');
                }
                if (this.rowhomeIsActive) {
                     q['type[]'].push('6240');
                }
                if (this.citiesSelected) {
                    q['city[]'] = this.citiesSelected;
                }
                if (this.statusSelected) {
                    q['status[]'] = this.statusSelected;
                }
                if (this.gutSelected) {
                    q['unittype[]'] = this.gutSelected;
                }
                if (this.dateSearch.length > 0) {
                    if (this.dateSearch[0]) {
                        q['salestart'] = this.toTimestamp(this.dateSearch[0]);
                    }
                    if (this.dateSearch[1]) {
                        q['saleend'] = this.toTimestamp(this.dateSearch[1]);
                    }
                }
                this.rzSubDate.forEach(function(value, i){
                    q['rzSubDate[]'].push(vm.toTimestamp(value));
                });

                if (this.rzAppDate) {
                    q['rzAppDate[]'] = new Array();
                }
                this.rzAppDate.forEach(function(value, i){
                    q['rzAppDate[]'].push(vm.toTimestamp(value));
                });

                if (this.dpSubDate) {
                    q['dpSubDate[]'] = new Array();
                }
                this.dpSubDate.forEach(function(value, i){
                    q['dpSubDate[]'].push(vm.toTimestamp(value));
                });

                if (this.bpSubDate) {
                    q['bpSubDate[]'] = new Array();
                }
                this.bpSubDate.forEach(function(value, i){
                    q['bpSubDate[]'].push(vm.toTimestamp(value));
                });

                if (this.dpIssueDate) {
                    q['dpIssueDate[]'] = new Array();
                }
                this.dpIssueDate.forEach(function(value, i){
                    q['dpIssueDate[]'].push(vm.toTimestamp(value));
                });

                if (this.bpIssueDate) {
                    q['bpIssueDate[]'] = new Array();
                }
                this.bpIssueDate.forEach(function(value, i){
                    q['bpIssueDate[]'].push(vm.toTimestamp(value));
                });

                //  status group
                if (this.rzStatus) {
                    q['rzStatus[]'] = new Array();
                }
                this.rzStatus.forEach(function(value, i){
                    q['rzStatus[]'].push(value);
                });

                if (this.bpStatus) {
                    q['bpStatus[]'] = new Array();
                }
                this.bpStatus.forEach(function(value, i){
                    q['bpStatus[]'].push(value);
                });

                if (this.dpStatus) {
                    q['dpStatus[]'] = new Array();
                }
                this.dpStatus.forEach(function(value, i){
                    q['dpStatus[]'].push(value);
                });
                if (table) {
                    q['report'] = ['true'];
                    this.$router.push({ path: '/listing-new', query: q});
                }
                else {
                    this.$router.push({ path: '/listing-new', query: q});
                }
                this.$router.go();
            },
            PlanningGo() {
                window.open('/planning-updates', '_blank');
            },
            PlanningUTCGo(report) {
                if (!this.role) {
                    return;
                }
                const vm = this;
                let q = {};
                q['type[]'] = new Array();
                q['city[]'] = new Array();
                q['status[]'] = new Array();
                q['unittype[]'] = new Array();
                if (this.subSelected) {
                    q['sub[]'] = this.subSelected;
                }
                if (this.bpSelected) {
                    q['bp[]'] = this.bpSelected;
                }
                if (this.dvpSelected) {
                    q['dvp[]'] = this.dvpSelected;
                }
                if (this.dpSelected) {
                    q['dp[]'] = this.dpSelected;
                }
                if (this.ocpSelected) {
                    q['ocp[]'] = this.ocpSelected;
                }
                if (this.rezoningSelected) {
                    q['rez[]'] = this.rezoningSelected;
                }
                if (this.citiesSelected) {
                    q['city[]'] = this.citiesSelected;
                }
                // if (this.statusSelected) {
                //     q['status[]'] = this.statusSelected;
                // }
                // q['status[]'] = ['in_planning'];
                if (this.gutSelected) {
                    q['unittype[]'] = this.gutSelected;
                    if (this.gutSelected.includes('2952')) {
                        q['status[]'] = ['selling_soon', 'in_planning'];
                    }
                    if (this.gutSelected.includes('2954')) {
                        q['unittype[]'].push('2970');
                        q['status[]'] = ['leasing_soon', 'in_planning'];
                    }
                    if (this.gutSelected.includes('3031') || this.gutSelected.includes('2960') || this.gutSelected.includes('3515')) {
                        q['status[]'] = ['leasing_soon', 'selling_soon', 'in_planning'];
                    }
                }
                else {
                    q['status[]'] = ['leasing_soon', 'selling_soon', 'in_planning'];
                    q['unittype[]'] = ['2952', '3031', '2954', '2960', '2970', '3515'];
                }
                if (this.aptIsActive) {
                    q['type[]'].push('2886');
                }
                if (this.townhomeIsActive) {
                     q['type[]'].push('2870');
                }
                if (this.mixedUseAptIsActive) {
                     q['type[]'].push('2884');
                }
                if (this.podiumIsActive) {
                     q['type[]'].push('5910');
                }
                if (this.stackedTownhomeIsActive) {
                     q['type[]'].push('3479');
                }
                if (this.commercialIsActive) {
                     q['type[]'].push('2962');
                }
                if (this.industrialIsActive) {
                     q['type[]'].push('3047');
                }
                if (this.rowhomeIsActive) {
                     q['type[]'].push('6240');
                }
                // $('#stepStatus').next().find('ul.list .selected').each(function() {
                //     q['status[]'].push($(this).attr('data-value'));
                // });
                if (this.listSearch) {
                    q = {};
                    q['search'] = this.listSearch;
                }
                if (this.developerSearch) {
                    q = {};
                    q['developer'] = this.developerSearch;
                }
                if (report) {
                    q['planningMap'] = '1';
                }
                else {
                    q['planningMap'] = '2';
                }
                this.$router.push({ path: '/listing-new', query: q});
                this.$router.go();
            },
            LandGo() {
                if (!this.role) {
                    return;
                }
                const vm = this;
                let q = {};
                q['type[]'] = new Array();
                q['city[]'] = new Array();
                q['status[]'] = new Array();
                q['unittype[]'] = new Array();
                q['landUse[]'] = new Array();
                q['area[]'] = new Array();
                q['proposed[]'] = new Array();
                q['ezone[]'] = new Array();
                q['construction[]'] = new Array();
                q['constructionStart[]'] = new Array();
                q['constructionCompletion[]'] = new Array();
                q['rezoningSelected[]'] = new Array();
                if (this.lotSizeMin) {
                    q['sizemin'] = this.lotSizeMin;
                }
                if (this.lotSizeMax) {
                    q['sizemax'] = this.lotSizeMax;
                }
                if (this.landPriceMin) {
                    q['salepricemin'] = this.landPriceMin;
                }
                if (this.landPriceMax) {
                    q['salepricemax'] = this.landPriceMax;
                }
                if (this.citiesSelected) {
                    q['city[]'] = this.citiesSelected;
                }
                if (this.landSelected) {
                    q['landUse[]'] = this.landSelected;
                }
                if (this.areaSelected) {
                    q['area[]'] = this.areaSelected;
                }
                if (this.proposedSelected) {
                    q['proposed[]'] = this.proposedSelected;
                }
                if (this.existingZSelected) {
                    q['ezone[]'] = this.existingZSelected;
                }
                if (this.fsrMin) {
                    q['fsrMin'] = this.fsrMin;
                }
                if (this.fsrMax) {
                    q['fsrMax'] = this.fsrMax;
                }
                if (this.typeSSelected) {
                    q['type[]'] = this.typeSSelected;
                }
                if (this.statusSSelected) {
                    q['status[]'] = this.statusSSelected;
                }
                if (this.gutSelected) {
                    q['unittype[]'] = this.gutSelected;
                }
                if (this.constructionSelected) {
                    q['construction[]'] = this.constructionSelected;
                }
                if (this.constructionStart.length > 0) {
                    q['constructionStart[]'] = this.constructionStart;
                }
                if (this.constructionCompletion.length > 0) {
                    q['constructionCompletion[]'] = this.constructionCompletion;
                }
                if (this.rezoningSelected) {
                    q['rezoningSelected[]'] = this.rezoningSelected;
                }
                if (this.subSelected) {
                    q['sub[]'] = this.subSelected;
                }
                if (this.bpSelected) {
                    q['bp[]'] = this.bpSelected;
                }
                if (this.dvpSelected) {
                    q['dvp[]'] = this.dvpSelected;
                }
                if (this.dpSelected) {
                    q['dp[]'] = this.dpSelected;
                }
                if (this.ocpSelected) {
                    q['ocp[]'] = this.ocpSelected;
                }
                if (this.rezoningSelected) {
                    q['rez[]'] = this.rezoningSelected;
                }
                this.$router.push({ path: '/land-list-new', query: q});
                this.$router.go();
            },
            devSearch(input) {
                const url = BACKEND_URL + `api/developers?search=${encodeURI(input)}`

                return new Promise((resolve) => {
                    if (input.length < 3) {
                    return resolve([])
                    }

                    fetch(url)
                        .then((response) => response.json())
                        .then((data) => {
                        resolve(data)
                    })
                })
            },
            nameSearch(input) {


                const url = BACKEND_URL + `api/search`

                return new Promise((resolve) => {
                    if (input.length < 3) {
                        return resolve([])
                    }

                    fetch(url, {
                        method: "POST", // *GET, POST, PUT, DELETE, etc.
                        mode: "cors", // no-cors, *cors, same-origin
                        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
                        // credentials: "same-origin", // include, *same-origin, omit
                        headers: {
                        "Content-Type": "application/json",
                        // 'Content-Type': 'application/x-www-form-urlencoded',
                        },
                        // redirect: "follow", // manual, *follow, error
                        referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
                        body: JSON.stringify({input: input}), // body data type must match "Content-Type" header
                    })
                        .then((response) => response.json())
                        .then((data) => {
                        resolve(data)
                    })
                })
            },
            getNameResultValue(result) {
                return result.name
            },
            getResultValue(result) {
                return result.title
            },
            onSubmit(result) {
                this.developerSearch = result.nid
            },
            onNameSubmit(result) {
                this.listSearch = result.uid
            },
            locationData: function(project) {
                let popuphtml = `
                <div class="map-popup-wrap">
                    <div class="map-popup">
                        <div class="infoBox-close"><i class="fa fa-times"></i></div>
                        <div class="listing-title fl-wrap">
                            <div style="padding: 0 5px; display: inline-block;">
                            <h4>`+project.status+`</h4>
                                <h4>`+project.name+`</h4>
                                <h4>`+project.type+`</h4>
                                <h4>`+project.total_units+` Units</h4>
                            </div>`;
                        popuphtml += `</div>
                    </div>
                </div>`;
                return popuphtml;
            },
            openModal: function (project) {
                var vm = this;
                $.get({
                    url: BACKEND_URL + 'api/get_utc?pid=' + project.nid + '&fid[]=' + project.fid + '&sid=' + project.status_tid + '&uid=' + project.uid,
                }, (data, status) => {
                    if (status === 'success') {
                        vm.unitComponent = data.unit_component;
                    }
                });

                this.modalContent.href = project.ref_link
                this.modalContent.address = project.address
                this.modalContent.presale_name = project.presale_name
                this.modalContent.project_type = project.project_type
                this.modalContent.construction_status = project.construction_status
                this.modalContent.developer = project.developer
                this.modalContent.deposit = project.deposit
                this.modalContent.storey = project.storey
                this.modalContent.sales_start_date = project.sales_start_date
                this.modalContent.type = project.type
                this.modalContent.city = project.city
                this.modalContent.rlsd_units = project.rlsd_units
                this.modalContent.sold_units = project.sold_units
                this.modalContent.available = project.available
                this.modalContent.dom = project.dom
                this.modalContent.total_avg_size = project.total_avg_size
                this.modalContent.total_avg_price = project.total_avg_price
                this.modalContent.total_avg_psf = project.total_avg_psf
                this.modalContent.updated = project.updated
                this.modalContent.total_units = project.total_units
                this.modalContent.gross_floor = project.gross_floor
                this.modalContent.fsr_far = project.fsr_far
                this.$refs['my-modal'].show()
            },
            jumpUTC: function (marker) {
                this.pickedProject = marker.project
                // this.modalContent.href = marker.project.ref_link
                // this.modalContent.address = marker.project.address
                // this.modalContent.presale_name = marker.project.presale_name
                // this.modalContent.project_type = marker.project.project_type
                // this.modalContent.construction_status = marker.project.construction_status
                // this.modalContent.developer = marker.project.developer
                // this.modalContent.deposit = marker.project.deposit
                // this.modalContent.storey = marker.project.storey
                // this.modalContent.sales_start_date = marker.project.sales_start_date
                // this.modalContent.type = marker.project.type
                // this.modalContent.city = marker.project.city
                // this.$refs['my-modal'].show()
            },
            mainMap: function() {
                const vm = this;
                var locations = this.locations;
                var map = new google.maps.Map(document.getElementById('map-main'), {
                    scrollwheel: false,
                    center: new google.maps.LatLng(49.18872777889199, -122.846467155292),
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    zoomControl: false,
                    mapTypeControl: false,
                    scaleControl: false,
                    panControl: false,
                    fullscreenControl: true,
                    navigationControl: false,
                    streetViewControl: false,
                    animation: google.maps.Animation.BOUNCE,
                    gestureHandling: 'greedy',
                    zoom: 11,
                    styles: [{
                        "featureType": "landscape",
                        "elementType": "labels",
                        "stylers": [{
                            visibility: 'off'
                        }]
                    },{
                        "featureType": "poi",
                        "elementType": "labels",
                        "stylers": [{
                            visibility: 'off'
                        }]
                    }]
                });
                vm.mapObj = map;

                google.maps.event.addListener(map, 'click', function () {
                    console.log(map.getZoom());
                    console.log(map.getCenter().lat());
                    console.log(map.getCenter().lng());
                });

                var oms = new OverlappingMarkerSpiderfier(map,{markersWontMove: true, markersWontHide: true, keepSpiderfied: true, legWeight: 0});
                var blueMarker = '<svg width="35" height="51" viewBox="0 0 35 51" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.5 0C7.8505 0 0 8.04326 0 17.9297C0 21.27 0.903098 24.5298 2.61226 27.3579L16.5039 50.2937C16.77 50.733 17.2388 51 17.743 51C17.7468 51 17.7506 51 17.7545 51C18.2631 50.9959 18.7329 50.7207 18.9941 50.2737L32.5316 27.1157C34.1465 24.3473 35 21.1709 35 17.9297C35 8.04326 27.1495 0 17.5 0Z" fill="#5E6274"/><path d="M26.2243 19.3671C26.2243 24.2778 22.3481 28.1962 17.6427 28.1962C12.9374 28.1962 9.06116 24.2778 9.06116 19.3671C9.06116 14.4564 12.9374 10.538 17.6427 10.538C22.3481 10.538 26.2243 14.4564 26.2243 19.3671Z" fill="#6EBBF8" stroke="white" stroke-width="3"/></svg>';
                var greenMarker = '<svg width="35" height="51" viewBox="0 0 35 51" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.5 0C7.8505 0 0 8.04326 0 17.9297C0 21.27 0.903098 24.5298 2.61226 27.3579L16.5039 50.2937C16.77 50.733 17.2388 51 17.743 51C17.7468 51 17.7506 51 17.7545 51C18.2631 50.9959 18.7329 50.7207 18.9941 50.2737L32.5316 27.1157C34.1465 24.3473 35 21.1709 35 17.9297C35 8.04326 27.1495 0 17.5 0Z" fill="#5E6274"/><path d="M26.2243 19.3671C26.2243 24.2778 22.3481 28.1962 17.6427 28.1962C12.9374 28.1962 9.06116 24.2778 9.06116 19.3671C9.06116 14.4564 12.9374 10.538 17.6427 10.538C22.3481 10.538 26.2243 14.4564 26.2243 19.3671Z" fill="#60B85F" stroke="white" stroke-width="3"/></svg>';
                var orangeMarker = '<svg width="35" height="51" viewBox="0 0 35 51" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.5 0C7.8505 0 0 8.04326 0 17.9297C0 21.27 0.903098 24.5298 2.61226 27.3579L16.5039 50.2937C16.77 50.733 17.2388 51 17.743 51C17.7468 51 17.7506 51 17.7545 51C18.2631 50.9959 18.7329 50.7207 18.9941 50.2737L32.5316 27.1157C34.1465 24.3473 35 21.1709 35 17.9297C35 8.04326 27.1495 0 17.5 0Z" fill="#5E6274"/><path d="M26.2243 19.3671C26.2243 24.2778 22.3481 28.1962 17.6427 28.1962C12.9374 28.1962 9.06116 24.2778 9.06116 19.3671C9.06116 14.4564 12.9374 10.538 17.6427 10.538C22.3481 10.538 26.2243 14.4564 26.2243 19.3671Z" fill="#FF9357" stroke="white" stroke-width="3"/></svg>';
                var yellowMarker = '<svg width="35" height="51" viewBox="0 0 35 51" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.5 0C7.8505 0 0 8.04326 0 17.9297C0 21.27 0.903098 24.5298 2.61226 27.3579L16.5039 50.2937C16.77 50.733 17.2388 51 17.743 51C17.7468 51 17.7506 51 17.7545 51C18.2631 50.9959 18.7329 50.7207 18.9941 50.2737L32.5316 27.1157C34.1465 24.3473 35 21.1709 35 17.9297C35 8.04326 27.1495 0 17.5 0Z" fill="#5E6274"/><path d="M26.2243 19.3671C26.2243 24.2778 22.3481 28.1962 17.6427 28.1962C12.9374 28.1962 9.06116 24.2778 9.06116 19.3671C9.06116 14.4564 12.9374 10.538 17.6427 10.538C22.3481 10.538 26.2243 14.4564 26.2243 19.3671Z" fill="#f5f242" stroke="white" stroke-width="3"/></svg>';
                var navyMarker = '<svg width="35" height="51" viewBox="0 0 35 51" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.5 0C7.8505 0 0 8.04326 0 17.9297C0 21.27 0.903098 24.5298 2.61226 27.3579L16.5039 50.2937C16.77 50.733 17.2388 51 17.743 51C17.7468 51 17.7506 51 17.7545 51C18.2631 50.9959 18.7329 50.7207 18.9941 50.2737L32.5316 27.1157C34.1465 24.3473 35 21.1709 35 17.9297C35 8.04326 27.1495 0 17.5 0Z" fill="#5E6274"/><path d="M26.2243 19.3671C26.2243 24.2778 22.3481 28.1962 17.6427 28.1962C12.9374 28.1962 9.06116 24.2778 9.06116 19.3671C9.06116 14.4564 12.9374 10.538 17.6427 10.538C22.3481 10.538 26.2243 14.4564 26.2243 19.3671Z" fill="#0b4add" stroke="white" stroke-width="3"/></svg>';
                var redMarker = '<svg width="35" height="51" viewBox="0 0 35 51" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.5 0C7.8505 0 0 8.04326 0 17.9297C0 21.27 0.903098 24.5298 2.61226 27.3579L16.5039 50.2937C16.77 50.733 17.2388 51 17.743 51C17.7468 51 17.7506 51 17.7545 51C18.2631 50.9959 18.7329 50.7207 18.9941 50.2737L32.5316 27.1157C34.1465 24.3473 35 21.1709 35 17.9297C35 8.04326 27.1495 0 17.5 0Z" fill="#5E6274"/><path d="M26.2243 19.3671C26.2243 24.2778 22.3481 28.1962 17.6427 28.1962C12.9374 28.1962 9.06116 24.2778 9.06116 19.3671C9.06116 14.4564 12.9374 10.538 17.6427 10.538C22.3481 10.538 26.2243 14.4564 26.2243 19.3671Z" fill="#ff1953" stroke="white" stroke-width="3"/></svg>';
                var newNSMarker = '<svg width="18" height="31" viewBox="0 0 18 31" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.69884 0C3.89487 0 0 3.89116 0 8.69055C0 13.4899 8.69884 31 8.69884 31C8.69884 31 17.3975 13.4903 17.3975 8.69055C17.3975 3.89081 13.503 0 8.69884 0ZM8.69884 12.5478C6.56682 12.5478 4.83802 10.8206 4.83802 8.69091C4.83802 6.56118 6.56682 4.83379 8.69884 4.83379C10.8309 4.83379 12.5595 6.56047 12.5595 8.69091C12.5595 10.8212 10.831 12.5478 8.69884 12.5478Z" fill="#008000"/></svg>';
                var newNLMarker = '<svg width="18" height="31" viewBox="0 0 18 31" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.69884 0C3.89487 0 0 3.89116 0 8.69055C0 13.4899 8.69884 31 8.69884 31C8.69884 31 17.3975 13.4903 17.3975 8.69055C17.3975 3.89081 13.503 0 8.69884 0ZM8.69884 12.5478C6.56682 12.5478 4.83802 10.8206 4.83802 8.69091C4.83802 6.56118 6.56682 4.83379 8.69884 4.83379C10.8309 4.83379 12.5595 6.56047 12.5595 8.69091C12.5595 10.8212 10.831 12.5478 8.69884 12.5478Z" fill="#5DB05D"/></svg>';
                var newIPMarker = '<svg width="18" height="31" viewBox="0 0 18 31" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.69884 0C3.89487 0 0 3.89116 0 8.69055C0 13.4899 8.69884 31 8.69884 31C8.69884 31 17.3975 13.4903 17.3975 8.69055C17.3975 3.89081 13.503 0 8.69884 0ZM8.69884 12.5478C6.56682 12.5478 4.83802 10.8206 4.83802 8.69091C4.83802 6.56118 6.56682 4.83379 8.69884 4.83379C10.8309 4.83379 12.5595 6.56047 12.5595 8.69091C12.5595 10.8212 10.831 12.5478 8.69884 12.5478Z" fill="#E7CE1C"/></svg>';
                var newSSLSMarker = '<svg width="18" height="31" viewBox="0 0 18 31" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.69884 0C3.89487 0 0 3.89116 0 8.69055C0 13.4899 8.69884 31 8.69884 31C8.69884 31 17.3975 13.4903 17.3975 8.69055C17.3975 3.89081 13.503 0 8.69884 0ZM8.69884 12.5478C6.56682 12.5478 4.83802 10.8206 4.83802 8.69091C4.83802 6.56118 6.56682 4.83379 8.69884 4.83379C10.8309 4.83379 12.5595 6.56047 12.5595 8.69091C12.5595 10.8212 10.831 12.5478 8.69884 12.5478Z" fill="#1227FA"/></svg>';
                var newSOMarker = '<svg width="18" height="31" viewBox="0 0 18 31" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.69884 0C3.89487 0 0 3.89116 0 8.69055C0 13.4899 8.69884 31 8.69884 31C8.69884 31 17.3975 13.4903 17.3975 8.69055C17.3975 3.89081 13.503 0 8.69884 0ZM8.69884 12.5478C6.56682 12.5478 4.83802 10.8206 4.83802 8.69091C4.83802 6.56118 6.56682 4.83379 8.69884 4.83379C10.8309 4.83379 12.5595 6.56047 12.5595 8.69091C12.5595 10.8212 10.831 12.5478 8.69884 12.5478Z" fill="#C2131E"/></svg>';
                var newLOMarker = '<svg width="18" height="31" viewBox="0 0 18 31" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.69884 0C3.89487 0 0 3.89116 0 8.69055C0 13.4899 8.69884 31 8.69884 31C8.69884 31 17.3975 13.4903 17.3975 8.69055C17.3975 3.89081 13.503 0 8.69884 0ZM8.69884 12.5478C6.56682 12.5478 4.83802 10.8206 4.83802 8.69091C4.83802 6.56118 6.56682 4.83379 8.69884 4.83379C10.8309 4.83379 12.5595 6.56047 12.5595 8.69091C12.5595 10.8212 10.831 12.5478 8.69884 12.5478Z" fill="#D96D74"/></svg>';

                var apartmentBlue = `<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8.88167" cy="9.6578" r="8.88167" fill="#1227FA"/></svg>`;
                var apartmentGreen = `<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8.88167" cy="9.6578" r="8.88167" fill="#008000"/></svg>`;
                var apartmentLightBlue = `<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8.88167" cy="9.6578" r="8.88167" fill="#5F6DFF"/></svg>`;
                var apartmentLightGreen = `<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8.88167" cy="9.6578" r="8.88167" fill="#5DB05D"/></svg>`;
                var apartmentLightRed = `<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8.88167" cy="9.6578" r="8.88167" fill="#E3676F"/></svg>`;
                var apartmentRed = `<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8.88167" cy="9.6578" r="8.88167" fill="#C2131E"/></svg>`;
                var apartmentYellow = `<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8.88167" cy="9.6578" r="8.88167" fill="#E7CE1C"/></svg>`;

                var commercialBlue = `<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg"><rect y="0.468506" width="18.1259" height="18.1259" fill="#1227FA"/></svg>`;
                var commercialGreen = `<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg"><rect y="0.468506" width="18.1259" height="18.1259" fill="#008000"/></svg>`;
                var commercialLightBlue = `<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg"><rect y="0.468506" width="18.1259" height="18.1259" fill="#5F6DFF"/></svg>`;
                var commercialLightGreen = `<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg"><rect y="0.468506" width="18.1259" height="18.1259" fill="#5DB05D"/></svg>`;
                var commercialLightRed = `<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg"><rect y="0.468506" width="18.1259" height="18.1259" fill="#E3676F"/></svg>`;
                var commercialRed = `<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg"><rect y="0.468506" width="18.1259" height="18.1259" fill="#C2131E"/></svg>`;
                var commercialYellow = `<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg"><rect y="0.468506" width="18.1259" height="18.1259" fill="#E7CE1C"/></svg>`;

                var industBlue = `<svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg"><rect y="0.993164" width="18.7972" height="18.7972" rx="5.06078" fill="#1227FA"/></svg>`;
                var industGreen = `<svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg"><rect y="0.993164" width="18.7972" height="18.7972" rx="5.06078" fill="#008000"/></svg>`;
                var industLightBlue = `<svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg"><rect y="0.993164" width="18.7972" height="18.7972" rx="5.06078" fill="#5F6DFF"/></svg>`;
                var industLightGreen = `<svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg"><rect y="0.993164" width="18.7972" height="18.7972" rx="5.06078" fill="#5DB05D"/></svg>`;
                var industLightRed = `<svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg"><rect y="0.993164" width="18.7972" height="18.7972" rx="5.06078" fill="#E3676F"/></svg>`;
                var industRed = `<svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg"><rect y="0.993164" width="18.7972" height="18.7972" rx="5.06078" fill="#C2131E"/></svg>`;
                var industYellow = `<svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg"><rect y="0.993164" width="18.7972" height="18.7972" rx="5.06078" fill="#E7CE1C"/></svg>`;

                var mixedUseBlue = `<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8.88167" cy="9.6578" r="8.88167" fill="#1227FA"/></svg>`;
                var mixedUseGreen = `<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8.88167" cy="9.6578" r="8.88167" fill="#008000"/></svg>`;
                var mixedUseLightBlue = `<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8.88167" cy="9.6578" r="8.88167" fill="#5F6DFF"/></svg>`;
                var mixedUseLightGreen = `<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8.88167" cy="9.6578" r="8.88167" fill="#5DB05D"/></svg>`;
                var mixedUseLightRed = `<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8.88167" cy="9.6578" r="8.88167" fill="#E3676F"/></svg>`;
                var mixedUseRed = `<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8.88167" cy="9.6578" r="8.88167" fill="#C2131E"/></svg>`;
                var mixedUseYellow = `<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8.88167" cy="9.6578" r="8.88167" fill="#E7CE1C"/></svg>`;

                var townhomeBlue = `<svg width="25" height="22" viewBox="0 0 25 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.7622 0.601318L24.6807 21.2447H0.84379L12.7622 0.601318Z" fill="#1227FA"/></svg>`;
                var townhomeGreen = `<svg width="25" height="22" viewBox="0 0 25 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.7622 0.601318L24.6807 21.2447H0.84379L12.7622 0.601318Z" fill="#008000"/></svg>`;
                var townhomeLightBlue = `<svg width="25" height="22" viewBox="0 0 25 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.7622 0.601318L24.6807 21.2447H0.84379L12.7622 0.601318Z" fill="#5F6DFF"/></svg>`;
                var townhomeLightGreen = `<svg width="25" height="22" viewBox="0 0 25 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.7622 0.601318L24.6807 21.2447H0.84379L12.7622 0.601318Z" fill="#5DB05D"/></svg>`;
                var townhomeLightRed = `<svg width="25" height="22" viewBox="0 0 25 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.7622 0.601318L24.6807 21.2447H0.84379L12.7622 0.601318Z" fill="#E3676F"/></svg>`;
                var townhomeRed = `<svg width="25" height="22" viewBox="0 0 25 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.7622 0.601318L24.6807 21.2447H0.84379L12.7622 0.601318Z" fill="#C2131E"/></svg>`;
                var townhomeYellow = `<svg width="25" height="22" viewBox="0 0 25 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.7622 0.601318L24.6807 21.2447H0.84379L12.7622 0.601318Z" fill="#E7CE1C"/></svg>`;

                function getIcon(icon_id, icon_type) {
                    var iconSvg = ''
                    switch (icon_id) {
                        case 1:
                            switch (icon_type) {
                                case 1:
                                    iconSvg = apartmentGreen;
                                    break;
                                case 2:
                                    iconSvg = townhomeGreen;
                                    break;
                                case 3:
                                    iconSvg = mixedUseGreen;
                                    break;
                                case 4:
                                    iconSvg = commercialGreen;
                                    break;
                                case 6:
                                    iconSvg = industGreen;
                                    break;
                                default:
                                    break;
                            }
                            break;
                        case 2:
                            switch (icon_type) {
                                case 1:
                                    iconSvg = apartmentLightGreen;
                                    break;
                                case 2:
                                    iconSvg = townhomeLightGreen;
                                    break;
                                case 3:
                                    iconSvg = mixedUseLightGreen;
                                    break;
                                case 4:
                                    iconSvg = commercialLightGreen;
                                    break;
                                case 6:
                                    iconSvg = industLightGreen;
                                    break;
                                default:
                                    break;
                            }
                            break;
                        case 3:
                            switch (icon_type) {
                                case 1:
                                    iconSvg = apartmentYellow;
                                    break;
                                case 2:
                                    iconSvg = townhomeYellow;
                                    break;
                                case 3:
                                    iconSvg = mixedUseYellow;
                                    break;
                                case 4:
                                    iconSvg = commercialYellow;
                                    break;
                                case 6:
                                    iconSvg = industYellow;
                                    break;
                                default:
                                    break;
                            }
                            break;
                        case 4:
                            switch (icon_type) {
                                case 1:
                                    iconSvg = apartmentBlue;
                                    break;
                                case 2:
                                    iconSvg = townhomeBlue;
                                    break;
                                case 3:
                                    iconSvg = mixedUseBlue;
                                    break;
                                case 4:
                                    iconSvg = commercialBlue;
                                    break;
                                case 6:
                                    iconSvg = industBlue;
                                    break;
                                default:
                                    break;
                            }
                            break;
                        case 5:
                            switch (icon_type) {
                                case 1:
                                    iconSvg = apartmentLightBlue;
                                    break;
                                case 2:
                                    iconSvg = townhomeLightBlue;
                                    break;
                                case 3:
                                    iconSvg = mixedUseLightBlue;
                                    break;
                                case 4:
                                    iconSvg = commercialLightBlue;
                                    break;
                                case 6:
                                    iconSvg = industLightBlue;
                                    break;
                                default:
                                    break;
                            }
                            break;
                        case 6:
                            switch (icon_type) {
                                case 1:
                                    iconSvg = apartmentRed;
                                    break;
                                case 2:
                                    iconSvg = townhomeRed;
                                    break;
                                case 3:
                                    iconSvg = mixedUseRed;
                                    break;
                                case 4:
                                    iconSvg = commercialRed;
                                    break;
                                case 6:
                                    iconSvg = industRed;
                                    break;
                                default:
                                    break;
                            }
                            break;
                        default:
                            switch (icon_type) {
                                case 1:
                                    iconSvg = apartmentLightRed;
                                    break;
                                case 2:
                                    iconSvg = townhomeLightRed;
                                    break;
                                case 3:
                                    iconSvg = mixedUseLightRed;
                                    break;
                                case 4:
                                    iconSvg = commercialLightRed;
                                    break;
                                case 6:
                                    iconSvg = industLightRed;
                                    break;
                                default:
                                    break;
                            }
                            break;
                        }
                    return iconSvg
                }
                
                oms.addListener('format', function(marker, status) {
                    marker.set('noHover', false);
                    if (status == OverlappingMarkerSpiderfier.markerStatus.SPIDERFIED) {
                        const tmp = map;
                        if (tmp.getZoom() < 16) {
                            map.setZoom(16);
                            map.setCenter(marker.getPosition())
                        }
                        // var iconSvg = apartmentGreen;
                        iconSvg = getIcon(marker.icon_id, marker.icon_type)
                        marker.setIcon({
                            url: 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(iconSvg),
                            origin: new google.maps.Point(0, 0),
                            anchor: new google.maps.Point(0, 0),
                            scaledSize: new google.maps.Size(40, 40)
                        });
                    }
                    // else if (status == OverlappingMarkerSpiderfier.markerStatus.UNSPIDERFIABLE) {
                        
                    // }
                    else if (status == OverlappingMarkerSpiderfier.markerStatus.SPIDERFIABLE) {
                        var iconSvg = apartmentGreen;
                        iconSvg = getIcon(marker.icon_id, marker.icon_type)
                        marker.setIcon({
                            url: 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(iconSvg),
                            origin: new google.maps.Point(0, 0),
                            anchor: new google.maps.Point(0, 0),
                            scaledSize: new google.maps.Size(40, 40)
                        });
                        marker.set('noHover', true);
                    }
                    else {
                        var iconSvg = apartmentGreen;
                        iconSvg = getIcon(marker.icon_id, marker.icon_type)
                        marker.setIcon({
                            url: 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(iconSvg),
                            origin: new google.maps.Point(0, 0),
                            anchor: new google.maps.Point(0, 0),
                            scaledSize: new google.maps.Size(40, 40)
                        });
                    }
                });
                // $(document).on('change', '.rzCheck, .dpCheck, .bpCheck', function() {
                //     statusFilter();
                // });

                var boxText = document.createElement("div");
                boxText.className = 'map-box'
                var currentInfobox;
                var boxOptions = {
                    content: boxText,
                    disableAutoPan: true,
                    alignBottom: true,
                    maxWidth: 0,
                    pixelOffset: new google.maps.Size(-145, -25),
                    zIndex: null,
                    boxStyle: {
                        width: "340px"
                    },
                    closeBoxMargin: "0",
                    closeBoxURL: "",
                    infoBoxClearance: new google.maps.Size(1, 1),
                    isHidden: false,
                    pane: "floatPane",
                    enableEventPropagation: false,
                    contextmenu:true,
                };
                var markerCluster, marker, i;
                var allMarkers = [];
                var clusterStyles = [{
                    textColor: 'white',
                    url: '',
                    height: 50,
                    width: 50
                }];

                var lightLightedMarker = null;

                var bounds = new google.maps.LatLngBounds();
        
                for (i = 0; i < locations.length; i++) {
                    var icon = navyMarker;
                    if (locations[i]['icon'] == 2) {
                        icon = orangeMarker;
                    }
                    if (locations[i]['icon'] == 3) {
                        icon = redMarker;
                    }
                    marker = new google.maps.Marker({
                        position: new google.maps.LatLng(locations[i]['geo']['lat'], locations[i]['geo']['lng']),
                        icon: icon,
                        icon_id: locations[i]['icon'],
                        icon_type: locations[i]['icon_type'],
                        id: i,
                        project: locations[i]['project'],
                        noHover: false
                    });
                    bounds.extend(marker.getPosition());
                    allMarkers.push(marker);
                    oms.addMarker(marker);
                    var ib = new InfoBox();
                    google.maps.event.addListener(ib, "domready", function () {
                        cardRaining()
                    });
                    google.maps.event.addListener(map, 'click', function () {
                        if (lightLightedMarker) {
                            var hlmarker = getIcon(lightLightedMarker.icon_id, lightLightedMarker.icon_type);
                                lightLightedMarker.setIcon({
                                    url: 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(hlmarker),
                                origin: new google.maps.Point(0, 0),
                                anchor: new google.maps.Point(0, 0),
                                scaledSize: new google.maps.Size(40, 40)
                            });
                            ib.close();
                            lightLightedMarker.setZIndex(1);
                        }
                    });
                    google.maps.event.addListener(marker, 'spider_click', (function (marker, i) {
                        return function () {
                            // map.setCenter(marker.getPosition());
                            if (lightLightedMarker) {
                                var hlmarker = getIcon(lightLightedMarker.icon_id, lightLightedMarker.icon_type);
                                    lightLightedMarker.setIcon({
                                        url: 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(hlmarker),
                                    origin: new google.maps.Point(0, 0),
                                    anchor: new google.maps.Point(0, 0),
                                    scaledSize: new google.maps.Size(40, 40)
                                });
                                lightLightedMarker.setZIndex(1);
                            }
                            lightLightedMarker = marker;
                            // $("#myModal").modal('show');
                            vm.jumpUTC(marker);
                            ib.setOptions(boxOptions);
                            let title = locations[i]['project']['name'];
                            if (title.length > 32) {
                                title = title.substring(0,32)+".."
                            }
                            boxText.innerHTML = '<span class="marker-title">'+title+'</span>';
                            // stroke="#FC5868"
                            var iconSvgOriginal = getIcon(marker.icon_id, marker.icon_type);
                            var iconSvgStrike = iconSvgOriginal.replace('/>', ' stroke="#FC5868" stroke-width="3.49999"/>');
                            marker.setIcon({
                                url: 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(iconSvgStrike),
                                origin: new google.maps.Point(0, 0),
                                anchor: new google.maps.Point(0, 0),
                                scaledSize: new google.maps.Size(40, 40)
                            });
                            ib.open(map, marker);
                            // map.setZoom(16);
                            // google.maps.event.addListener(map, 'click', function () {
                            //     ib.close();
                            //     vm.closeMapBox();
                            // });
                        }
                    })(marker, i));
                }
                if (locations.length > 0) {
                    map.setCenter(bounds.getCenter());
                    map.fitBounds(bounds);
                }
                var options = {
                    imagePath: '/images/',
                    styles: clusterStyles,
                    minimumClusterSize: 2
                };
                // markerCluster = new MarkerClusterer(map, allMarkers, options);
                // markerCluster.setMaxZoom(15);

                google.maps.event.addDomListener(window, "resize", function () {
                    var center = map.getCenter();
                    google.maps.event.trigger(map, "resize");
                    map.setCenter(center);
                });

                // Scroll enabling button
                var scrollEnabling = $('.scrollContorl');

                $(scrollEnabling).click(function(e){
                    e.preventDefault();
                    $(this).toggleClass("enabledsroll");

                    if ( $(this).is(".enabledsroll") ) {
                        map.setOptions({'scrollwheel': true});
                    } else {
                        map.setOptions({'scrollwheel': false});
                    }
                });       
                var zoomControlDiv = document.createElement('div');
                var zoomControl = new ZoomControl(zoomControlDiv, map);

                function ZoomControl(controlDiv, map) {
                    zoomControlDiv.index = 1;
                    map.controls[google.maps.ControlPosition.RIGHT_CENTER].push(zoomControlDiv);
                    controlDiv.style.padding = '5px';
                    var controlWrapper = document.createElement('div');
                    controlDiv.appendChild(controlWrapper);
                    var zoomInButton = document.createElement('div');
                    zoomInButton.className = "mapzoom-in";
                    controlWrapper.appendChild(zoomInButton);
                    var zoomOutButton = document.createElement('div');
                    zoomOutButton.className = "mapzoom-out";
                    controlWrapper.appendChild(zoomOutButton);

                    var fullButton = document.createElement('div');
                    fullButton.className = "fullscreen";
                    controlWrapper.appendChild(fullButton);
                    google.maps.event.addDomListener(fullButton, 'click', function () {
                        $('.gm-control-active.gm-fullscreen-control').trigger('click');
                    });
                    google.maps.event.addDomListener(zoomInButton, 'click', function () {
                        map.setZoom(map.getZoom() + 1);
                    });
                    google.maps.event.addDomListener(zoomOutButton, 'click', function () {
                        map.setZoom(map.getZoom() - 1);
                    });
                }

                $(document).on('click', '.focus-target', function() {
                    map.setZoom(15);
                    let clickedMarker = allMarkers[$(this).attr('marker')];
                    clickedMarker.setZIndex(5);
                    map.panTo(clickedMarker.getPosition())
                    setTimeout(() => {
                        new google.maps.event.trigger( clickedMarker, 'spider_click' );
                    }, "300")
                });

            },

            planningMap: function() {
                const vm = this;
                var locations = this.locations;
                var map = new google.maps.Map(document.getElementById('map-main'), {
                    scrollwheel: false,
                    center: new google.maps.LatLng(49.18872777889199, -122.846467155292),
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    zoomControl: false,
                    mapTypeControl: false,
                    scaleControl: false,
                    panControl: false,
                    fullscreenControl: true,
                    navigationControl: false,
                    streetViewControl: false,
                    animation: google.maps.Animation.BOUNCE,
                    gestureHandling: 'greedy',
                    zoom: 11,
                    styles: [{
                        "featureType": "landscape",
                        "elementType": "labels",
                        "stylers": [{
                            visibility: 'off'
                        }]
                    },{
                        "featureType": "poi",
                        "elementType": "labels",
                        "stylers": [{
                            visibility: 'off'
                        }]
                    }]
                });
                vm.mapObj = map;

                var oms = new OverlappingMarkerSpiderfier(map,{markersWontMove: true, markersWontHide: true, keepSpiderfied: true, legWeight: 0});
                var blueMarker = '<svg width="35" height="51" viewBox="0 0 35 51" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.5 0C7.8505 0 0 8.04326 0 17.9297C0 21.27 0.903098 24.5298 2.61226 27.3579L16.5039 50.2937C16.77 50.733 17.2388 51 17.743 51C17.7468 51 17.7506 51 17.7545 51C18.2631 50.9959 18.7329 50.7207 18.9941 50.2737L32.5316 27.1157C34.1465 24.3473 35 21.1709 35 17.9297C35 8.04326 27.1495 0 17.5 0Z" fill="#5E6274"/><path d="M26.2243 19.3671C26.2243 24.2778 22.3481 28.1962 17.6427 28.1962C12.9374 28.1962 9.06116 24.2778 9.06116 19.3671C9.06116 14.4564 12.9374 10.538 17.6427 10.538C22.3481 10.538 26.2243 14.4564 26.2243 19.3671Z" fill="#6EBBF8" stroke="white" stroke-width="3"/></svg>';
                var greenMarker = '<svg width="35" height="51" viewBox="0 0 35 51" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.5 0C7.8505 0 0 8.04326 0 17.9297C0 21.27 0.903098 24.5298 2.61226 27.3579L16.5039 50.2937C16.77 50.733 17.2388 51 17.743 51C17.7468 51 17.7506 51 17.7545 51C18.2631 50.9959 18.7329 50.7207 18.9941 50.2737L32.5316 27.1157C34.1465 24.3473 35 21.1709 35 17.9297C35 8.04326 27.1495 0 17.5 0Z" fill="#5E6274"/><path d="M26.2243 19.3671C26.2243 24.2778 22.3481 28.1962 17.6427 28.1962C12.9374 28.1962 9.06116 24.2778 9.06116 19.3671C9.06116 14.4564 12.9374 10.538 17.6427 10.538C22.3481 10.538 26.2243 14.4564 26.2243 19.3671Z" fill="#60B85F" stroke="white" stroke-width="3"/></svg>';
                var orangeMarker = '<svg width="35" height="51" viewBox="0 0 35 51" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.5 0C7.8505 0 0 8.04326 0 17.9297C0 21.27 0.903098 24.5298 2.61226 27.3579L16.5039 50.2937C16.77 50.733 17.2388 51 17.743 51C17.7468 51 17.7506 51 17.7545 51C18.2631 50.9959 18.7329 50.7207 18.9941 50.2737L32.5316 27.1157C34.1465 24.3473 35 21.1709 35 17.9297C35 8.04326 27.1495 0 17.5 0Z" fill="#5E6274"/><path d="M26.2243 19.3671C26.2243 24.2778 22.3481 28.1962 17.6427 28.1962C12.9374 28.1962 9.06116 24.2778 9.06116 19.3671C9.06116 14.4564 12.9374 10.538 17.6427 10.538C22.3481 10.538 26.2243 14.4564 26.2243 19.3671Z" fill="#FF9357" stroke="white" stroke-width="3"/></svg>';
                var yellowMarker = '<svg width="35" height="51" viewBox="0 0 35 51" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.5 0C7.8505 0 0 8.04326 0 17.9297C0 21.27 0.903098 24.5298 2.61226 27.3579L16.5039 50.2937C16.77 50.733 17.2388 51 17.743 51C17.7468 51 17.7506 51 17.7545 51C18.2631 50.9959 18.7329 50.7207 18.9941 50.2737L32.5316 27.1157C34.1465 24.3473 35 21.1709 35 17.9297C35 8.04326 27.1495 0 17.5 0Z" fill="#5E6274"/><path d="M26.2243 19.3671C26.2243 24.2778 22.3481 28.1962 17.6427 28.1962C12.9374 28.1962 9.06116 24.2778 9.06116 19.3671C9.06116 14.4564 12.9374 10.538 17.6427 10.538C22.3481 10.538 26.2243 14.4564 26.2243 19.3671Z" fill="#f5f242" stroke="white" stroke-width="3"/></svg>';
                var navyMarker = '<svg width="35" height="51" viewBox="0 0 35 51" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.5 0C7.8505 0 0 8.04326 0 17.9297C0 21.27 0.903098 24.5298 2.61226 27.3579L16.5039 50.2937C16.77 50.733 17.2388 51 17.743 51C17.7468 51 17.7506 51 17.7545 51C18.2631 50.9959 18.7329 50.7207 18.9941 50.2737L32.5316 27.1157C34.1465 24.3473 35 21.1709 35 17.9297C35 8.04326 27.1495 0 17.5 0Z" fill="#5E6274"/><path d="M26.2243 19.3671C26.2243 24.2778 22.3481 28.1962 17.6427 28.1962C12.9374 28.1962 9.06116 24.2778 9.06116 19.3671C9.06116 14.4564 12.9374 10.538 17.6427 10.538C22.3481 10.538 26.2243 14.4564 26.2243 19.3671Z" fill="#0b4add" stroke="white" stroke-width="3"/></svg>';
                var redMarker = '<svg width="35" height="51" viewBox="0 0 35 51" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.5 0C7.8505 0 0 8.04326 0 17.9297C0 21.27 0.903098 24.5298 2.61226 27.3579L16.5039 50.2937C16.77 50.733 17.2388 51 17.743 51C17.7468 51 17.7506 51 17.7545 51C18.2631 50.9959 18.7329 50.7207 18.9941 50.2737L32.5316 27.1157C34.1465 24.3473 35 21.1709 35 17.9297C35 8.04326 27.1495 0 17.5 0Z" fill="#5E6274"/><path d="M26.2243 19.3671C26.2243 24.2778 22.3481 28.1962 17.6427 28.1962C12.9374 28.1962 9.06116 24.2778 9.06116 19.3671C9.06116 14.4564 12.9374 10.538 17.6427 10.538C22.3481 10.538 26.2243 14.4564 26.2243 19.3671Z" fill="#ff1953" stroke="white" stroke-width="3"/></svg>';
                var newNSMarker = '<svg width="18" height="31" viewBox="0 0 18 31" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.69884 0C3.89487 0 0 3.89116 0 8.69055C0 13.4899 8.69884 31 8.69884 31C8.69884 31 17.3975 13.4903 17.3975 8.69055C17.3975 3.89081 13.503 0 8.69884 0ZM8.69884 12.5478C6.56682 12.5478 4.83802 10.8206 4.83802 8.69091C4.83802 6.56118 6.56682 4.83379 8.69884 4.83379C10.8309 4.83379 12.5595 6.56047 12.5595 8.69091C12.5595 10.8212 10.831 12.5478 8.69884 12.5478Z" fill="#008000"/></svg>';
                var newNLMarker = '<svg width="18" height="31" viewBox="0 0 18 31" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.69884 0C3.89487 0 0 3.89116 0 8.69055C0 13.4899 8.69884 31 8.69884 31C8.69884 31 17.3975 13.4903 17.3975 8.69055C17.3975 3.89081 13.503 0 8.69884 0ZM8.69884 12.5478C6.56682 12.5478 4.83802 10.8206 4.83802 8.69091C4.83802 6.56118 6.56682 4.83379 8.69884 4.83379C10.8309 4.83379 12.5595 6.56047 12.5595 8.69091C12.5595 10.8212 10.831 12.5478 8.69884 12.5478Z" fill="#5DB05D"/></svg>';
                var newIPMarker = '<svg width="18" height="31" viewBox="0 0 18 31" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.69884 0C3.89487 0 0 3.89116 0 8.69055C0 13.4899 8.69884 31 8.69884 31C8.69884 31 17.3975 13.4903 17.3975 8.69055C17.3975 3.89081 13.503 0 8.69884 0ZM8.69884 12.5478C6.56682 12.5478 4.83802 10.8206 4.83802 8.69091C4.83802 6.56118 6.56682 4.83379 8.69884 4.83379C10.8309 4.83379 12.5595 6.56047 12.5595 8.69091C12.5595 10.8212 10.831 12.5478 8.69884 12.5478Z" fill="#E7CE1C"/></svg>';
                var newSSLSMarker = '<svg width="18" height="31" viewBox="0 0 18 31" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.69884 0C3.89487 0 0 3.89116 0 8.69055C0 13.4899 8.69884 31 8.69884 31C8.69884 31 17.3975 13.4903 17.3975 8.69055C17.3975 3.89081 13.503 0 8.69884 0ZM8.69884 12.5478C6.56682 12.5478 4.83802 10.8206 4.83802 8.69091C4.83802 6.56118 6.56682 4.83379 8.69884 4.83379C10.8309 4.83379 12.5595 6.56047 12.5595 8.69091C12.5595 10.8212 10.831 12.5478 8.69884 12.5478Z" fill="#1227FA"/></svg>';
                var newSOMarker = '<svg width="18" height="31" viewBox="0 0 18 31" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.69884 0C3.89487 0 0 3.89116 0 8.69055C0 13.4899 8.69884 31 8.69884 31C8.69884 31 17.3975 13.4903 17.3975 8.69055C17.3975 3.89081 13.503 0 8.69884 0ZM8.69884 12.5478C6.56682 12.5478 4.83802 10.8206 4.83802 8.69091C4.83802 6.56118 6.56682 4.83379 8.69884 4.83379C10.8309 4.83379 12.5595 6.56047 12.5595 8.69091C12.5595 10.8212 10.831 12.5478 8.69884 12.5478Z" fill="#C2131E"/></svg>';
                var newLOMarker = '<svg width="18" height="31" viewBox="0 0 18 31" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.69884 0C3.89487 0 0 3.89116 0 8.69055C0 13.4899 8.69884 31 8.69884 31C8.69884 31 17.3975 13.4903 17.3975 8.69055C17.3975 3.89081 13.503 0 8.69884 0ZM8.69884 12.5478C6.56682 12.5478 4.83802 10.8206 4.83802 8.69091C4.83802 6.56118 6.56682 4.83379 8.69884 4.83379C10.8309 4.83379 12.5595 6.56047 12.5595 8.69091C12.5595 10.8212 10.831 12.5478 8.69884 12.5478Z" fill="#D96D74"/></svg>';

                var apartmentBlue = `<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8.88167" cy="9.6578" r="8.88167" fill="#1227FA"/></svg>`;
                var apartmentGreen = `<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8.88167" cy="9.6578" r="8.88167" fill="#008000"/></svg>`;
                var apartmentLightBlue = `<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8.88167" cy="9.6578" r="8.88167" fill="#5F6DFF"/></svg>`;
                var apartmentLightGreen = `<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8.88167" cy="9.6578" r="8.88167" fill="#5DB05D"/></svg>`;
                var apartmentLightRed = `<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8.88167" cy="9.6578" r="8.88167" fill="#E3676F"/></svg>`;
                var apartmentRed = `<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8.88167" cy="9.6578" r="8.88167" fill="#C2131E"/></svg>`;
                var apartmentYellow = `<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8.88167" cy="9.6578" r="8.88167" fill="#E7CE1C"/></svg>`;

                var commercialBlue = `<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg"><rect y="0.468506" width="18.1259" height="18.1259" fill="#1227FA"/></svg>`;
                var commercialGreen = `<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg"><rect y="0.468506" width="18.1259" height="18.1259" fill="#008000"/></svg>`;
                var commercialLightBlue = `<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg"><rect y="0.468506" width="18.1259" height="18.1259" fill="#5F6DFF"/></svg>`;
                var commercialLightGreen = `<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg"><rect y="0.468506" width="18.1259" height="18.1259" fill="#5DB05D"/></svg>`;
                var commercialLightRed = `<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg"><rect y="0.468506" width="18.1259" height="18.1259" fill="#E3676F"/></svg>`;
                var commercialRed = `<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg"><rect y="0.468506" width="18.1259" height="18.1259" fill="#C2131E"/></svg>`;
                var commercialYellow = `<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg"><rect y="0.468506" width="18.1259" height="18.1259" fill="#E7CE1C"/></svg>`;

                var industBlue = `<svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg"><rect y="0.993164" width="18.7972" height="18.7972" rx="5.06078" fill="#1227FA"/></svg>`;
                var industGreen = `<svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg"><rect y="0.993164" width="18.7972" height="18.7972" rx="5.06078" fill="#008000"/></svg>`;
                var industLightBlue = `<svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg"><rect y="0.993164" width="18.7972" height="18.7972" rx="5.06078" fill="#5F6DFF"/></svg>`;
                var industLightGreen = `<svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg"><rect y="0.993164" width="18.7972" height="18.7972" rx="5.06078" fill="#5DB05D"/></svg>`;
                var industLightRed = `<svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg"><rect y="0.993164" width="18.7972" height="18.7972" rx="5.06078" fill="#E3676F"/></svg>`;
                var industRed = `<svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg"><rect y="0.993164" width="18.7972" height="18.7972" rx="5.06078" fill="#C2131E"/></svg>`;
                var industYellow = `<svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg"><rect y="0.993164" width="18.7972" height="18.7972" rx="5.06078" fill="#E7CE1C"/></svg>`;

                var mixedUseBlue = `<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8.88167" cy="9.6578" r="8.88167" fill="#1227FA"/></svg>`;
                var mixedUseGreen = `<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8.88167" cy="9.6578" r="8.88167" fill="#008000"/></svg>`;
                var mixedUseLightBlue = `<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8.88167" cy="9.6578" r="8.88167" fill="#5F6DFF"/></svg>`;
                var mixedUseLightGreen = `<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8.88167" cy="9.6578" r="8.88167" fill="#5DB05D"/></svg>`;
                var mixedUseLightRed = `<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8.88167" cy="9.6578" r="8.88167" fill="#E3676F"/></svg>`;
                var mixedUseRed = `<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8.88167" cy="9.6578" r="8.88167" fill="#C2131E"/></svg>`;
                var mixedUseYellow = `<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8.88167" cy="9.6578" r="8.88167" fill="#E7CE1C"/></svg>`;

                var townhomeBlue = `<svg width="25" height="22" viewBox="0 0 25 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.7622 0.601318L24.6807 21.2447H0.84379L12.7622 0.601318Z" fill="#1227FA"/></svg>`;
                var townhomeGreen = `<svg width="25" height="22" viewBox="0 0 25 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.7622 0.601318L24.6807 21.2447H0.84379L12.7622 0.601318Z" fill="#008000"/></svg>`;
                var townhomeLightBlue = `<svg width="25" height="22" viewBox="0 0 25 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.7622 0.601318L24.6807 21.2447H0.84379L12.7622 0.601318Z" fill="#5F6DFF"/></svg>`;
                var townhomeLightGreen = `<svg width="25" height="22" viewBox="0 0 25 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.7622 0.601318L24.6807 21.2447H0.84379L12.7622 0.601318Z" fill="#5DB05D"/></svg>`;
                var townhomeLightRed = `<svg width="25" height="22" viewBox="0 0 25 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.7622 0.601318L24.6807 21.2447H0.84379L12.7622 0.601318Z" fill="#E3676F"/></svg>`;
                var townhomeRed = `<svg width="25" height="22" viewBox="0 0 25 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.7622 0.601318L24.6807 21.2447H0.84379L12.7622 0.601318Z" fill="#C2131E"/></svg>`;
                var townhomeYellow = `<svg width="25" height="22" viewBox="0 0 25 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.7622 0.601318L24.6807 21.2447H0.84379L12.7622 0.601318Z" fill="#E7CE1C"/></svg>`;

                function getIcon(icon_id, icon_type) {
                    var iconSvg = ''
                    switch (icon_id) {
                        case 1:
                            switch (icon_type) {
                                case 1:
                                    iconSvg = apartmentGreen;
                                    break;
                                case 2:
                                    iconSvg = townhomeGreen;
                                    break;
                                case 3:
                                    iconSvg = mixedUseGreen;
                                    break;
                                case 4:
                                    iconSvg = commercialGreen;
                                    break;
                                case 6:
                                    iconSvg = industGreen;
                                    break;
                                default:
                                    break;
                            }
                            break;
                        case 2:
                            switch (icon_type) {
                                case 1:
                                    iconSvg = apartmentLightGreen;
                                    break;
                                case 2:
                                    iconSvg = townhomeLightGreen;
                                    break;
                                case 3:
                                    iconSvg = mixedUseLightGreen;
                                    break;
                                case 4:
                                    iconSvg = commercialLightGreen;
                                    break;
                                case 6:
                                    iconSvg = industLightGreen;
                                    break;
                                default:
                                    break;
                            }
                            break;
                        case 3:
                            switch (icon_type) {
                                case 1:
                                    iconSvg = apartmentYellow;
                                    break;
                                case 2:
                                    iconSvg = townhomeYellow;
                                    break;
                                case 3:
                                    iconSvg = mixedUseYellow;
                                    break;
                                case 4:
                                    iconSvg = commercialYellow;
                                    break;
                                case 6:
                                    iconSvg = industYellow;
                                    break;
                                default:
                                    break;
                            }
                            break;
                        case 4:
                            switch (icon_type) {
                                case 1:
                                    iconSvg = apartmentBlue;
                                    break;
                                case 2:
                                    iconSvg = townhomeBlue;
                                    break;
                                case 3:
                                    iconSvg = mixedUseBlue;
                                    break;
                                case 4:
                                    iconSvg = commercialBlue;
                                    break;
                                case 6:
                                    iconSvg = industBlue;
                                    break;
                                default:
                                    break;
                            }
                            break;
                        case 5:
                            switch (icon_type) {
                                case 1:
                                    iconSvg = apartmentLightBlue;
                                    break;
                                case 2:
                                    iconSvg = townhomeLightBlue;
                                    break;
                                case 3:
                                    iconSvg = mixedUseLightBlue;
                                    break;
                                case 4:
                                    iconSvg = commercialLightBlue;
                                    break;
                                case 6:
                                    iconSvg = industLightBlue;
                                    break;
                                default:
                                    break;
                            }
                            break;
                        case 6:
                            switch (icon_type) {
                                case 1:
                                    iconSvg = apartmentRed;
                                    break;
                                case 2:
                                    iconSvg = townhomeRed;
                                    break;
                                case 3:
                                    iconSvg = mixedUseRed;
                                    break;
                                case 4:
                                    iconSvg = commercialRed;
                                    break;
                                case 6:
                                    iconSvg = industRed;
                                    break;
                                default:
                                    break;
                            }
                            break;
                        default:
                            switch (icon_type) {
                                case 1:
                                    iconSvg = apartmentLightRed;
                                    break;
                                case 2:
                                    iconSvg = townhomeLightRed;
                                    break;
                                case 3:
                                    iconSvg = mixedUseLightRed;
                                    break;
                                case 4:
                                    iconSvg = commercialLightRed;
                                    break;
                                case 6:
                                    iconSvg = industLightRed;
                                    break;
                                default:
                                    break;
                            }
                            break;
                        }
                    return iconSvg
                }
                
                oms.addListener('format', function(marker, status) {
                    marker.set('noHover', false);
                    if (status == OverlappingMarkerSpiderfier.markerStatus.SPIDERFIED) {
                        const tmp = map;
                        if (tmp.getZoom() < 16) {
                            map.setZoom(16);
                            map.setCenter(marker.getPosition())
                        }
                        // var iconSvg = apartmentGreen;
                        iconSvg = getIcon(marker.icon_id, marker.icon_type)
                        
                        marker.setIcon({
                            url: 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(iconSvg),
                            origin: new google.maps.Point(0, 0),
                            anchor: new google.maps.Point(0, 0),
                            scaledSize: new google.maps.Size(40, 40)
                        });
                    }
                    // else if (status == OverlappingMarkerSpiderfier.markerStatus.UNSPIDERFIABLE) {
                        
                    // }
                    else if (status == OverlappingMarkerSpiderfier.markerStatus.SPIDERFIABLE) {
                        var iconSvg = apartmentGreen;
                        iconSvg = getIcon(marker.icon_id, marker.icon_type)
                        marker.setIcon({
                            url: 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(iconSvg),
                            origin: new google.maps.Point(0, 0),
                            anchor: new google.maps.Point(0, 0),
                            scaledSize: new google.maps.Size(40, 40)
                        });
                        marker.set('noHover', true);
                    }
                    else {
                        var iconSvg = apartmentGreen;
                        iconSvg = getIcon(marker.icon_id, marker.icon_type)
                        marker.setIcon({
                            url: 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(iconSvg),
                            origin: new google.maps.Point(0, 0),
                            anchor: new google.maps.Point(0, 0),
                            scaledSize: new google.maps.Size(40, 40)
                        });
                    }
                });
                // $(document).on('change', '.rzCheck, .dpCheck, .bpCheck', function() {
                //     statusFilter();
                // });

                var boxText = document.createElement("div");
                boxText.className = 'map-box'
                var currentInfobox;
                var boxOptions = {
                    content: boxText,
                    disableAutoPan: true,
                    alignBottom: true,
                    maxWidth: 0,
                    pixelOffset: new google.maps.Size(-145, -25),
                    zIndex: null,
                    boxStyle: {
                        width: "340px"
                    },
                    closeBoxMargin: "0",
                    closeBoxURL: "",
                    infoBoxClearance: new google.maps.Size(1, 1),
                    isHidden: false,
                    pane: "floatPane",
                    enableEventPropagation: false,
                    contextmenu:true,
                };
                var markerCluster, marker, i;
                var allMarkers = [];
                var clusterStyles = [{
                    textColor: 'white',
                    url: '',
                    height: 50,
                    width: 50
                }];

                var lightLightedMarker = null;
                var bounds = new google.maps.LatLngBounds();
                for (i = 0; i < locations.length; i++) {
                    var icon = navyMarker;
                    if (locations[i]['icon'] == 2) {
                        icon = orangeMarker;
                    }
                    if (locations[i]['icon'] == 3) {
                        icon = redMarker;
                    }
                    marker = new google.maps.Marker({
                        position: new google.maps.LatLng(locations[i]['geo']['lat'], locations[i]['geo']['lng']),
                        icon: icon,
                        icon_id: locations[i]['icon'],
                        icon_type: locations[i]['icon_type'],
                        id: i,
                        project: locations[i]['project'],
                        noHover: false
                    });
                    bounds.extend(marker.getPosition());
                    allMarkers.push(marker);
                    oms.addMarker(marker);
                    var ib = new InfoBox();
                    google.maps.event.addListener(ib, "domready", function () {
                        cardRaining()
                    });
                    google.maps.event.addListener(map, 'click', function () {
                        if (lightLightedMarker) {
                            var hlmarker = getIcon(lightLightedMarker.icon_id, lightLightedMarker.icon_type);
                                lightLightedMarker.setIcon({
                                    url: 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(hlmarker),
                                origin: new google.maps.Point(0, 0),
                                anchor: new google.maps.Point(0, 0),
                                scaledSize: new google.maps.Size(40, 40)
                            });
                            ib.close();
                            lightLightedMarker.setZIndex(1);
                        }
                    });
                    google.maps.event.addListener(marker, 'spider_click', (function (marker, i) {
                        return function () {
                            // map.setCenter(marker.getPosition());
                            if (lightLightedMarker) {
                                var hlmarker = getIcon(lightLightedMarker.icon_id, lightLightedMarker.icon_type);
                                    lightLightedMarker.setIcon({
                                        url: 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(hlmarker),
                                    origin: new google.maps.Point(0, 0),
                                    anchor: new google.maps.Point(0, 0),
                                    scaledSize: new google.maps.Size(40, 40)
                                });
                                lightLightedMarker.setZIndex(1);
                            }
                            lightLightedMarker = marker;
                            // $("#myModal").modal('show');
                            vm.jumpUTC(marker);
                            ib.setOptions(boxOptions);
                            let title = locations[i]['project']['project_name'];
                            if (title.length > 32) {
                                title = title.substring(0,32)+".."
                            }
                            boxText.innerHTML = '<span class="marker-title">'+title+'</span>';
                            // stroke="#FC5868"
                            var iconSvgOriginal = getIcon(marker.icon_id, marker.icon_type);
                            var iconSvgStrike = iconSvgOriginal.replace('/>', ' stroke="#FC5868" stroke-width="3.49999"/>');
                            marker.setIcon({
                                url: 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(iconSvgStrike),
                                origin: new google.maps.Point(0, 0),
                                anchor: new google.maps.Point(0, 0),
                                scaledSize: new google.maps.Size(40, 40)
                            });
                            ib.open(map, marker);
                            // map.setZoom(16);
                            // google.maps.event.addListener(map, 'click', function () {
                            //     ib.close();
                            //     vm.closeMapBox();
                            // });
                        }
                    })(marker, i));
                    if (locations.length > 0) {
                        map.setCenter(bounds.getCenter());
                        map.fitBounds(bounds);
                    }
                }
                var options = {
                    imagePath: '/images/',
                    styles: clusterStyles,
                    minimumClusterSize: 2
                };
                // markerCluster = new MarkerClusterer(map, allMarkers, options);
                // markerCluster.setMaxZoom(15);

                google.maps.event.addDomListener(window, "resize", function () {
                    var center = map.getCenter();
                    google.maps.event.trigger(map, "resize");
                    map.setCenter(center);
                });

                // Scroll enabling button
                var scrollEnabling = $('.scrollContorl');

                $(scrollEnabling).click(function(e){
                    e.preventDefault();
                    $(this).toggleClass("enabledsroll");

                    if ( $(this).is(".enabledsroll") ) {
                        map.setOptions({'scrollwheel': true});
                    } else {
                        map.setOptions({'scrollwheel': false});
                    }
                });       
                var zoomControlDiv = document.createElement('div');
                var zoomControl = new ZoomControl(zoomControlDiv, map);

                function ZoomControl(controlDiv, map) {
                    zoomControlDiv.index = 1;
                    map.controls[google.maps.ControlPosition.RIGHT_CENTER].push(zoomControlDiv);
                    controlDiv.style.padding = '5px';
                    var controlWrapper = document.createElement('div');
                    controlDiv.appendChild(controlWrapper);
                    var zoomInButton = document.createElement('div');
                    zoomInButton.className = "mapzoom-in";
                    controlWrapper.appendChild(zoomInButton);
                    var zoomOutButton = document.createElement('div');
                    zoomOutButton.className = "mapzoom-out";
                    controlWrapper.appendChild(zoomOutButton);

                    var fullButton = document.createElement('div');
                    fullButton.className = "fullscreen";
                    controlWrapper.appendChild(fullButton);
                    google.maps.event.addDomListener(fullButton, 'click', function () {
                        $('.gm-control-active.gm-fullscreen-control').trigger('click');
                    });
                    google.maps.event.addDomListener(zoomInButton, 'click', function () {
                        map.setZoom(map.getZoom() + 1);
                    });
                    google.maps.event.addDomListener(zoomOutButton, 'click', function () {
                        map.setZoom(map.getZoom() - 1);
                    });
                }

                $(document).on('click', '.focus-target', function() {
                    map.setZoom(15);
                    let clickedMarker = allMarkers[$(this).attr('marker')];
                    clickedMarker.setZIndex(5);
                    map.panTo(clickedMarker.getPosition())
                    setTimeout(() => {
                        new google.maps.event.trigger( clickedMarker, 'spider_click' );
                    }, "300")
                });

            },
            getReportDetails (params) {
                const endPoint = `api/get_projects_utc_new?${params}`;
                this.is_loading = true;
                $.get({
                    url: BACKEND_URL + endPoint,
                }, (data, status) => {
                    this.is_loading = false;
                    if (status !== 'success') return;
                    const vm = this
                    _.each(data, (project) => {
                        this.projects.push(project);
                        vm.locations.push({
                            'icon': project.icons,
                            'icon_type': project.icon_type,
                            'geo' : project.geo,
                            'project': project,
                        });
                    });
                    this.mainMap();
                });
            },
            getPlanningDetails (params) {
                const endPoint = `api/get_utc_planning?${params}`;
                this.is_loading = true;
                $.get({
                    url: BACKEND_URL + endPoint,
                }, (data, status) => {
                    this.is_loading = false;
                    if (status !== 'success') return;
                    const vm = this
                    this.citySummary = data.city
                    this.planningUTC = data.permit_report
                    _.each(data.permit_report, (project) => {
                        this.projects.push(project);
                        vm.locations.push({
                            'icon': project.icons,
                            'icon_type': project.icon_type,
                            'geo' : project.geo,
                            'project': project,
                        });
                    });
                    this.planningMap();
                });
            }
        },
    }
</script>
<style>
.marker-status {
    position: fixed;
    bottom: 20px;
    z-index: 99999;
    background: #fff;
    padding: 0;
    text-align: left;
    right: 300px;
    font-weight: 700;
}
.marker-status .status-row span {
    width: 130px;
    text-align: center;
    padding-top: 10px;
    padding-bottom: 10px;
    color: #fff;
    display: inline-block;
    font-size: 1rem;
    float: left; 
}
.marker-status .status-row span.status-in {
    background: #E7CE1C;
}
.marker-status .status-row span.status-selling-soon {
    background: #5F6DFF;
}
.marker-status .status-row span.status-now-selling {
    background: #008000;
}
.marker-status .status-row span.status-sold-out {
    background: #C2131E;
}
.marker-status .status-row span.status-leasing-soon {
    background: #1227FA;
}
.marker-status .status-row span.status-now-leasing {
    background: #5DB05D;
}
.marker-status .status-row span.status-leased-out {
    background: #E3676F;
}
.marker-sample {
    position: fixed;
    bottom: 20px;
    z-index: 99999;
    background: #fff;
    padding: 10px 45px 15px 45px;
    text-align: left;
    right: 20px;
    font-weight: 700;
    width: 250px;
}
@media (max-width: 767px) {
    .map-col, #map-main {
        height: 500px !important;
    }
    .logo-holder img {
        width: 100px;
        height: auto;
        margin-top: -12px;
    }
    .listsearch-input-item .nice-select .list li:hover {
        background: none;
        color: #666;
    }
    .listsearch-input-item .nice-select .list li.selected {
        color: #fff;
    }
}
.new-list-unit .type-filter-button-sm,
.new-list .type-filter-button-sm {
    border: 3px solid #13293E;
    box-sizing: border-box;
    border-radius: 20px;
    font-size: 20px;
    line-height: 15px;
    text-align: center;
    display: inline-block;
    cursor: pointer;
    position: relative;
    width: 100%;
    margin: 10px 10px;
    color: #13293E;
    background: #FFFFFF;
    font-family: 'Poppins';
    font-weight: 500;
    padding: 25px 15px;
}
.new-list-unit .type-filter-button-sm-wrap,
.new-list .type-filter-button-sm-wrap {
    border: 3px solid #13293E;
    box-sizing: border-box;
    border-radius: 20px;
    font-size: 20px;
    line-height: 15px;
    text-align: center;
    display: inline-block;
    cursor: pointer;
    position: relative;
    width: 100%;
    margin: 10px 10px;
    color: #13293E;
    background: #FFFFFF;
    font-family: 'Poppins';
    font-weight: 500;
}
.new-list-unit .type-filter-button-sm-wrap > div,
.new-list .type-filter-button-sm-wrap > div {
    float: left;
    padding: 18px 15px 25px 15px;
}
.buttonWithOpt {
    padding-bottom: 12px !important;
}
.new-list-unit .input-border-new {
    background: transparent;
    border: 3px solid #13293E;
    border-radius: 10px;
    font-size: 1.2rem;
    color: #000;
    padding: 10px 10px;
    height: 60px;
    margin: 10px 0;
    width: 100%;
}
.new-list-unit .developer-input .autocomplete input,
.new-list .developer-input .autocomplete input {
    background: transparent;
    border: 3px solid #13293E;
    border-radius: 10px;
    font-size: 1.2rem;
    color: #000;
    padding: 10px 10px;
    height: 60px;
    margin: 10px 0;
    width: 100%;
}
.new-list .listsearch-input-text input {
    background: transparent;
    border: 3px solid #13293E;
    border-radius: 10px;
    font-size: 1.2rem;
    color: #000;
    padding: 10px 10px;
    height: 60px;
    margin: 10px 0;
    width: 100%;
}
.new-list .input-field input {
    background: transparent;
    border: 3px solid #13293E;
    border-radius: 10px;
    font-size: 1.2rem;
    color: #000;
    padding: 10px 10px;
    margin: 10px 0;
    width: 100%;
}
.new-list-unit .filter-checkbox .vue-treeselect,
.new-list .filter-checkbox .vue-treeselect {
    border: 3px solid #13293E;
}
.new-list-unit .filter-select .nice-select.better-select,
.new-list .filter-select .nice-select.better-select {
    border: 3px solid #13293E;
}
.new-list-unit .filter-select .nice-select.better-select span,
.new-list .filter-select .nice-select.better-select span {
    color: #13293E;
}
.new-list-unit .demo-date input,
.new-list .demo-date input {
    background: transparent;
    border: 3px solid #13293E;
    border-radius: 10px;
    font-size: 1.2rem;
    color: #000;
    padding: 10px 10px;
    height: 50px;
    margin: 10px 0;
    width: 100%;
}
.new-list .demo-date.mx-datepicker.mx-datepicker-range {
    width: 100%;
    margin: 0 10px;
}
.new-list-wrapper .nav-tabs .nav-link.active, .new-list-wrapper .nav-tabs .nav-item.show .nav-link {
    background: #fff;
    color: #13293E;
    padding-top: 10px;
    border: 3px solid #13293E;
    border-bottom: 3px solid #fff;
    border-radius: 10px;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
    margin-bottom: -3px;
    font-size: 22px;
    font-weight: 500;
}
.new-list-wrapper .nav-tabs .nav-link {
    font-size: 22px;
    font-weight: 500;
}
.new-list-wrapper .nav-tabs {
    border-bottom: 3px solid #13293E !important;
}
.type-filter-button-sm.selected {
    color: #ffffff;
    background-color: #13293E;
}
.new-list-wrapper .tabs ul li {
    font-size: 1.2rem;
    font-family: 'Poppins';
    text-transform: uppercase;
    font-weight: 500;
    width: 33%;
    padding-top: 5px;
    text-align: center;
}
.new-list-wrapper .tabs ul.autocomplete-result-list li {
    width: 100%;
}
.detail-title {
    float: left;
    margin-left: 50px;
}
.detail-address {
    float: right;
    margin-right: 50px;
}
.detail-row {
    width: 100%;
}
.detail-link {
    position: absolute;
    top: 25px;
    left: 50px;
    background: #FFFFFFCC;
    padding: 15px 50px;
    border-radius: 50px;
    font-size: 1.2rem;
    font-weight: 500;
}
#listing-modal .modal-header {
    background: url('/images/assets/placeholder.png');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    color: #fff;
    font-family: Poppins;
    font-weight: 600;
    font-size: 1.7rem;
    text-transform: uppercase;
    height: 300px;
    display: flex;
    align-items: flex-end;
}
#listing-modal .modal-header .logo-modal {
    right: 75px;
    top: 40px;
}
#listing-modal .modal-header button {
    color: #fff;
    border: none;
    text-shadow: none;
    opacity: 1;
    position: absolute;
    top: 20px;
    right: 20px;
    font-size: 2rem;
}
.marker-title {
    background: #1227FA;
    color: #fff;
    padding: 15px;
    border-radius: 20px;
    font-size: 1.2rem;
}
.vue-treeselect__multi-value-item {
    background: #426586;
    border-radius: 7px;
    color: #fff;
    font-size: 0.8rem;
    font-weight: bold;
}
.vue-treeselect__menu {
    background: #F8F7F7;
    border: 3px solid #13293E;
    margin-top: 45px;
    border-top: 3px solid #13293E !important;
    border-top-left-radius: 10px !important;
    border-top-right-radius: 10px !important;
    border-bottom-right-radius: 10px !important;
    border-bottom-left-radius: 10px !important;
}
.new-list .filter-checkbox-longer .vue-treeselect {
    padding-left: 65px;
}
.new-list .vue-treeselect {
    padding-left: 50px;
}
.new-list .no-extra-p-l.vue-treeselect {
    padding-left: 5px;
}
.new-list .const .vue-treeselect {
    padding-left: 5px;
}
.new-list.land-extra .vue-treeselect {
    padding-left: 5px;
}
.autocomplete-result-list {
    top: 100% !important;
    bottom: auto !important;
    max-height: 203px;
    overflow-y: scroll;
}
</style>
<style scoped>
.ml-10 {
    margin-left: 10px !important;
}
.p-0 {
    padding: 0 !important;
}
.mx-0 {
    margin-left: 0 !important;
    margin-right: 0 !important;
}
.filter-update-unit {
    margin-top: 30px;
    background: #13293E;
    border: 3px solid #fff;
    border-radius: 30px;
    padding: 20px 50px;
    font-size: 1.2rem;
    display: inline-block;
    float: none;
    color: #fff;
    font-weight: bold;
}
.filter-update-unit.hollow:hover {
    background: #fff;
    color: #13293E;
    border: 3px solid #13293E;
}
.popover-icons {
    background: #b4c1e0;
    color: #485f73;
}
.city-inner {
    padding: 25px;
}
.city-header {
    background: #13293E;
    display: inline-block;
    width: 100%;
    height: auto;
}
h5 {
    font-size: 3rem;
    color: #fff;
    font-weight: bold;
    text-align: left;
    padding: 25px;
}
.modal-close {
    position: absolute;
    color: #fff;
    top: 0;
    right: 7px;
    font-size: 2rem;
    opacity: 1;
}
.city-tables {
    position: fixed;
    width: 80%;
    left: 10%;
    right: 10%;
    z-index: 999;
    background: #fff;
}
.floating-filters {
    width: 700px;
    position: absolute;
    z-index: 9999999;
    background: #fff;
    right: 50px;
    margin-top: 63px;
    padding: 45px 45px 45px 30px;
    border: 3px solid #13293E;
    border-radius: 24px;
}
.no-p-right {
    padding-right: 0 !important;
}
b, strong {
    font-weight: bolder !important;
}
.square-wrapper {
    width: 33.33333333%;
    text-align: center;
}
.square-wrapper:nth-child(1) {
    padding-right: 5px;
}
.square-wrapper:nth-child(3) {
    padding-left: 5px;
}
.square-white {
    background: #fff;
    padding-top: 5px;
    min-height: 50px;
}
.square-blue {
    background: #e7ecf6;
    padding-top: 5px;
    min-height: 50px;
}
.scroll-popup {
    max-height: 300px;
    overflow-y: scroll;
}
.scroll-popup::-webkit-scrollbar {
  width: 8px;
}
.scroll-popup::-webkit-scrollbar-track {
  background-color: transparent;
  border-radius: 100px;
}
.scroll-popup::-webkit-scrollbar-thumb {
  background-color: #a6a6a6;
  border-radius: 100px;
}
.max-h-100 {
    max-height: 100%;
    overflow-y: scroll;
}
.city-special {
    border-radius: 20px;
    min-height: 70px;
    padding-top: 10px;
    padding-bottom: 10px;
}
.land-extra {
    float: left;
    width: calc(100% - 700px);
    padding: 0 30px;
    max-width: 1200px;
}
.land-extra .type-filter-button-sm-wrap {
    height: 52px;
    border-radius: 17px;
    cursor: text;
}
.ptitle {
    position: absolute;
    margin-top: 12px;
    margin-left: 9px;
}
.choosen-opts {
background: #426586;
    color: #fff;
    font-size: 1rem;
    padding: 8px;
    white-space: nowrap;
    float: left;
    border-radius: 7px;
    font-weight: normal;
    margin-left: 5px;
    margin-bottom: 4px;
}
.list-group-item {
    background: #D9D9D9;
    color: #13293E;
    font-size: 0.9rem;
    border: none;
}
.selected-fields .list-group-item {
    background: #FC5868;
    color: #fff;
}
.fields-toggle-bar {
    border-bottom: 3px solid #13293E;
    margin-left: -30px;
    margin-right: -30px;
    margin-top: 20px;
    margin-bottom: 20px;
}
.list-group {
    flex-direction: inherit;
}
.list-group-item {
    width: calc( 50% - 20px );
    margin-left: 10px;
    margin-right: 10px;
    margin-bottom: 10px;
}
.fields-toggle-title {
    color: #13293E;
    font-size: 1.4rem;
    text-align: left;
    font-weight: bold;
    margin-bottom: 10px;
}
.fields-toggle-wrapper {
    zoom: 1.4;
    border: 3px #13293E solid;
    position: absolute;
    right: 70px;
    width: 450px;
    border-radius: 20px;
    z-index: 999;
    background: #F8F7F7;
    margin-top: 56px;
    padding: 30px;
}
.city-tb-wrapper {
    background: #13293E1A;
    padding: 40px;
}
.city-tb-wrapper .table td {
    border-bottom: 2px #545454 solid;
    border-top: none;
}
.city-tb-wrapper .table th {
    border-bottom: 2px #545454 solid;
    border-top: 2px #545454 solid;
}
.filter-label {
    font-weight: 500;
    font-size: 1.5rem;
    color: #ffffff;
    font-family: Poppins;
    text-align: left;
    margin-left: 10px;
    text-transform: capitalize;
}
h3.filter-label {
    color: #13293E;
}
.demo-input-normal {
    background: transparent;
    border: 3px solid #fff;
    border-radius: 10px;
    font-size: 1.2rem;
    /* padding: 10px 15px 10px 50px; */
    width: 100%;
    margin: auto 10px;
    background-repeat: no-repeat;
    background-position: 12px;
}
.demo-input {
    background: transparent;
    border-radius: 10px;
    font-size: 1.2rem;
    color: #000;
    padding: 10px 15px 10px 50px;
    width: 100%;
    margin: auto 10px;
    background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjNjY2IiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PGNpcmNsZSBjeD0iMTEiIGN5PSIxMSIgcj0iOCIvPjxwYXRoIGQ9Ik0yMSAyMWwtNC00Ii8+PC9zdmc+");
    background-repeat: no-repeat;
    background-position: 12px;
    border: 3px solid #13293E;
}
.permits {
    display: inline-block;
    width: 100%;
}
.type-group-inner.closed {
    max-height: 182px;
    overflow: hidden;
}
.type-group .open-btn {
    width: 160px;
    padding: 10px;
    background: #D9D9D9;
    display: block;
    text-align: center;
    font-weight: 700;
    margin-top: 10px;
    cursor: pointer;
}
.type-group input {
    width: 20px;
    height: 20px;
}
.type-group label {
    font-size: 1.5rem;
}
.filter-label {
    text-transform: capitalize;
}
.marker-label {
    margin-top: 15px;
}
.hidden-listing-filter {
    float: left;
}
.start-label {

}
.inner-wrapper {
    width: 100%;
    float: left;
}
.map-container #map-main {
    bottom: 0;
}
.filter-update {
    margin-top: 30px;
    background: #13293E;
    border: 3px solid #fff;
    border-radius: 50px;
    padding: 30px 10px;
    font-size: 1.5rem;
    width: 280px;
    display: inline-block;
    float: none;
}
.listing-modal-wrapper {
    padding: 30px;
    font-size: 1.5rem;
}
.listing-modal-wrapper h2 {
    font-size: 2rem;
}
.listing-modal-wrapper .modal-address {
    font-size: 2rem;
}
.listsearch-options {
    padding: 0 40px;
}
.start-label {
    color: #13293E;
    display: inline-block;
    text-align: center;
    width: 100%;
    font-size: 3rem;
    font-weight: bold;
    font-family: 'Poppins';
    margin-top: 20px;
    margin-bottom: 20px;
}
.map-container.column-map.right-pos-map {
    right: 0;
    width: calc(100% - 700px);
}
.map-container.column-map.right-pos-map.right-on.right-collapse {
    width: calc(100% - 780px);
}
.map-container.column-map.right-pos-map.right-on {
    width: calc(100% - 1400px);
}
.map-container.column-map.right-pos-map.left-on {
    width: calc(100% - 780px);
}
.map-container.column-map.right-pos-map.left-on.right-collapse {
    width: calc(100% - 160px);
}
.map-container.column-map.land-on {
    display: none;
}
.right-menu {
    width: 800px;
}
.result-title {
    font-size: 3rem;
    font-weight: 700;
    margin-bottom: 10px;
    text-align: center !important;
}
.right-list {
    height: 100%;
    background: #F5F8FF;
}
.result-wrapper {
    overflow-y: scroll;
    overflow-x: hidden;
    padding: 5px 5px;
    max-height: 100%;
    background: #F5F8FF;
    margin-left: 0;
    margin-right: 0;
}
.result-row {
    margin-bottom: 30px;
    margin-top: 15px;
    cursor: pointer;
}
.result-row-feature {
    margin-top: 5px;
    cursor: pointer;
}
.result-name {
    font-size: 1.2rem;
    font-weight: 700;
}
.result-type {
    font-size: 1.2rem;
    font-weight: 700;
}
.result-status {
    position: absolute;
    top: 15px;
    color: #fff;
    padding: 5px 20px;
    border-radius: 21px;
    font-weight: 700;
    left: 30px;
}
.result-city {
    position: absolute;
    top: 15px;
    color: #000;
    padding: 5px 20px;
    border-radius: 21px;
    font-weight: 700;
    right: 30px;
    background: #fff;
}
.result-pic {
    height: 130px;
    border-radius: 30px;
    margin-bottom: 20px;
    width: 100%;
    overflow: hidden;
}
.result-pic img {
    width: 100%;
}
.picked-result-pic-feature {
    height: 200px;
    border-radius: 30px;
    margin-bottom: 20px;
    width: 350px;
    overflow: hidden;
    margin-left: auto;
    margin-right: auto;
}
.picked-result-pic-feature img {
    width: 100%;
}
.result-pic-feature {
    height: 140px;
    border-radius: 30px;
    margin-bottom: 20px;
    width: 400px;
    overflow: hidden;
    margin-left: auto;
    margin-right: auto;
}
.result-pic-feature img {
    width: 100%;
}
.picked-result-status-feature {
    position: absolute;
    top: 15px;
    color: #fff;
    padding: 5px 20px;
    border-radius: 21px;
    font-weight: 700;
    left: 40px;
}
.picked-result-city-feature {
    position: absolute;
    top: 15px;
    color: #000;
    padding: 5px 20px;
    border-radius: 21px;
    font-weight: 700;
    right: 40px;
    background: #fff;
}
.result-status-feature {
    position: absolute;
    top: 15px;
    color: #fff;
    padding: 5px 20px;
    border-radius: 21px;
    font-weight: 700;
    left: 100px;
}
.result-city-feature {
    position: absolute;
    top: 15px;
    color: #000;
    padding: 5px 20px;
    border-radius: 21px;
    font-weight: 700;
    right: 100px;
    background: #fff;
}
.result-report {
    font-size: 1.2rem;
    text-decoration: underline;
    margin-top: 10px;
    cursor: pointer;
}
.left-disabled {
    display: none;
}
.left-activated {
    display: block;
}
.left-info {
    background: #E7ECF6;
    height: 100%;
    float: left;
    position: relative;
    width: 80px
}
.right-info {
    background: #E7ECF6;
    height: 100%;
    float: right;
    position: relative;
    width: 80px
}
.right-info.right-activated {
    display: none;
}
.info-open-inline {
    width: 50px;
    float: right;
}
.info-open {
    width: 50px;
    position: absolute;
    bottom: 70px;
    left: 10px;
    cursor: pointer;
}
.custom-search-wrapper {
    align-items: end;
    display: flex;
    align-self: flex-end;
}
.custom-search {
    font-size: 22px;
    font-weight: 500;
    text-decoration: underline;
    cursor: pointer;
}
.left-toggle {
    width: 43px;
    float: right;
}
.info-collapse {
    width: 43px;
    position: absolute;
    bottom: 10px;
    left: 14px;
}
.sort-icon {
    width: 45px;
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 30px;
}
.right-t-icon {
    width: 45px;
    position: absolute;
    left: 10px;
    cursor: pointer;
    top: 30px;
}
.sort-block {
    background: #D5DBEA;
    width: 500px;
    padding: 25px 15px;
    font-size: 20px;
    position: absolute;
    z-index: 9;
    right: 0;
    display: none;
    top: 80px;
}
.sort-block.sort-display {
    display: block;
}
.sort-label {
    text-align: left;
    font-weight: 700;
    color: #13293E;
}
.sort-btn {
    color: #13293E;
    font-size: 20px;
    font-weight: 700;
    border: 2px solid;
    padding: 12px 0;
    border-radius: 11px;
    cursor: pointer;
}
.in-planning-legend {
    color: #E7CE1C;
}
.in-planning-legend .circle {
    background-color: #E7CE1C;
}
.selling-soon-legend {
    color: #5F6DFF;
}
.selling-soon-legend .circle {
    background-color: #5F6DFF;
}
.leasing-soon-legend {
    color: #1227FA;
}
.leasing-soon-legend .circle {
    background-color: #1227FA;
}
.now-selling-legend {
    color: #008000;
}
.now-selling-legend .circle {
    background-color: #008000;
}
.now-leasing-legend {
    color: #5DB05D;
}
.now-leasing-legend .circle {
    background-color: #5DB05D;
}
.sold-out-legend {
    color: #C2131E;
}
.sold-out-legend .circle {
    background-color: #C2131E;
}
.leased-out-legend {
    color: #E3676F;
}
.leased-out-legend .circle {
    background-color: #E3676F;
}
.circle {
    height: 25px;
    width: 25px;
    border-radius: 50%;
    display: inline-block;
    position: relative;
    top: 5px;
    background: #13293E;
}
.triangle {
    width: 0px;
    height: 0px;
    border-left: 15px solid transparent;
    border-right: 15px solid transparent;
    border-bottom: 25px solid #2f2f2f;
}
.indust {
    height: 25px;
    width: 25px;
    border-radius: 25%;
    display: inline-block;
    position: relative;
    top: 5px;
    background: #13293E;
}
.square {
    height: 25px;
    width: 25px;
    display: inline-block;
    position: relative;
    top: 5px;
    background: #13293E;
}
.result-header-block {
    background: #e7ecf6;
    padding: 20px 0 10px 0;
}
.checkbox-square {
    width: 1.3em;
    height: 1.3em;
    background-color: #D9D9D9;
    vertical-align: middle;
    appearance: none;
    -webkit-appearance: none;
    outline: none;
    cursor: pointer;
}
.checkbox-round {
    width: 1.3em;
    height: 1.3em;
    background-color: #D9D9D9;
    border-radius: 50%;
    vertical-align: middle;
    border: 1px solid #13293E;
    appearance: none;
    -webkit-appearance: none;
    outline: none;
    cursor: pointer;
}
.dropdown-background-grey {
    background-color: #fff;
    border: 3px solid #13293E;
    border-radius: 25px;
}
.dropdown-background-light {
    background-color: #E7ECF6
}
.dropdown-background-dark {
    background-color: #D5DBEA
}
.right-menu {
    display: none;
}
.right-menu.right-on {
    display: block;
}
.checkbox-round:checked {
    background-color: gray;
}
.checkbox-square:checked {
    background-color: gray;
}
.sale-pop {
    text-align: left;
    font-size: 1.2rem;
    position: absolute;
    z-index: 10;
    width: 295px;
    font-weight: 500;
    padding: 20px;
    display: none;
}
.sale-pop label {
    margin-bottom: 15px;
    margin-left: 10px;
}
.sale-pop.active {
    display: block
}
.sale-pop-status {
    font-size: 1.2rem;
    position: absolute;
    z-index: 10;
    width: 280px;
    font-weight: 500;
    padding: 20px;
    left: 310px;
    display: none;
}
.sale-pop-status.active {
    display: block
}
.sale-pop-status label {
    margin-bottom: 15px;
    margin-left: 10px;
}
.status-color-selling-soon {
    background: #5F6DFF;
}
.status-color-in-planning {
    background: #E7CE1C;
}
.status-color-leasing-soon {
    background: #1227FA;
}
.status-color-now-selling {
    background: #008000;
}
.status-color-now-leasing {
    background: #5DB05D;
}
.status-color-leased-out {
    background: #E3676F;
}
.status-color-sold-out {
    background: #C2131E;
}
</style>
<style scoped>
.st-symbol {
    margin-left: 5px;
}
.col-list-wrap {
    width: 700px;
}
.table {
    font-family: Poppins;
    font-weight: 300;
}
th>div {
    position: relative;
}
th>div>span {
    white-space: nowrap;
}
th>div>div {
    position: absolute;
}
fa {
    font-size: 18px;
}
th ul {
    border: 1px solid #eee;
    border-radius: 4px;
    position: absolute;
    left: 50%;
    top: 24px;
    transform: translateX(-50%);
    overflow: hidden;
}
.visible {
    /* max-height: 100px; */
    transition: max-height .3s;
}
.invisible {
    max-height: 0px;
    transition: max-height .3s;
}
.rotate-180 {
    transform: rotate(180deg);
    transition: transform .3s;
}
.rotate-360 {
    transform: rotate(360deg);
    transition: transform .3s;
}
th ul li {
    background: #fff;
    padding: 8px 16px;
    border-bottom: 1px solid #dee2e6;
    color: #212529;
    text-transform: none;
    font-size: 12px;
    white-space: nowrap;
    height: 32px;
    text-align: left;
    cursor: pointer;
}
th ul li:hover {
    background: #4db7fe;
    color: #fff;
}
th ul li:last-child {
    border-bottom: none;
}
.selected {
    background: #4db7fe;
    color: #fff;
}
.withOptions {
    background: #13293E;
    color: #fff;
}
a {
    font-weight: 500;
}
.report-container {
    padding: 30px 50px;
}
.map-btn {
    background: #0B4ADD;
    border-radius: 25px;
    font-size: 20px;
    line-height: 18px;
    color: #fff;
    font-weight: bold;
    padding: 10px 30px;
    margin-right: 30px;
    display: inline-block;
    cursor: pointer;
}
.status-line {
    line-height: 5;
}
.list-table thead.summary-table-header th {
    top: 0;
}
#map-main {
    height: 800px;
}
.summary-sort {
    position: sticky;
    background: #476E93;
    color: #fff;
    font-family: Poppins;
    font-weight: 500;
}
h1 {
    font-size: 3rem;
    font-family: Poppins;
    font-weight: 600;
}
h2 {
    font-family: Poppins;
    font-weight: 600;
    font-size: 2rem;
    text-align: left;
    margin-top: 10px;
    margin-bottom: 10px;
}
h3 {
    font-family: Poppins;
    font-weight: 500;
    font-size: 1.5rem;
    text-align: left;
}
.status-btn {
    font-family: Poppins;
    font-weight: 300;
    font-size: 1.3rem;
    text-align: left;
    margin-top: 8px;
    display: inline-block;
    float: left;
}
.bottom-line {
    border-bottom: 2px solid #545454;
}
.list-table.table th {
    padding: 2.5rem 1.5rem;
}
.list-table.table th {
    font-family: Poppins;
    font-weight: 500;
    font-size: 1.2rem;
}
.list-table.table td {
    font-family: Poppins;
    font-weight: 300;
    font-size: 1.2rem;
    line-height: 30px;
}
th {
    line-height: 24px;
}
.view-result {
    font-family: Poppins;
    font-weight: 600;
    font-size: 2rem;
    text-align: left;
    margin-top: 10px;
    margin-bottom: 10px;
}
.project-status-btn {
    float: right;
    margin-right: 30px;
    font-size: 1.8rem;
    font-weight: 500;
    padding: 15px 50px;
    border-radius: 42px;
    color: #fff;
    margin-top: 20px;
    margin-bottom: 20px;
}
.project-status-btn.now_selling,
.project-status-btn.new_leasing {
    background: #18A01B;
}
.project-status-btn.selling_soon,
.project-status-btn.leasing_soon {
    background: #E97E21;
}
.project-status-btn.in_planning {
    background: #E7CE1C;
}
.project-status-btn.sold_out,
.project-status-btn.leased_out {
    background: #C2131E;
}
.project-status-btn.leasing_soon {
    background: #1227FA;
}
.report-title {
    text-align: left;
}
.report-logo {
    text-align: right;
}
.spinner {
    width: 300px;
}
.report-col > div {
    width: 16.66666667%;
    float: left;
    position: relative;
    min-height: 1px;
    padding-left: 15px;
    padding-right: 15px;
    flex: 0 0 16.666667%;
    max-width: 16.666667%;
}
@media screen and (max-width: 1100px) {
    .type-col {
        margin-top: 20px;
    }
    .table-wrap {
        width: 100%;
        overflow: scroll;
    }
    .hidden-xs {
        display:none !important
    }
    h3 {
        font-size: 1.1rem;
    }
    .report-title {
        text-align: center;
        order: 2;
        margin-bottom: 20px;
    }
    .report-logo {
        text-align: center;
        order: 1;
    }
    .status-wrapper {
        text-align: center;
    }
    .project-status-btn {
        float: none;
        width: 350px;
        margin-left: auto;
        margin-right: auto;
    }

}
@media print {
	.report-container {
		padding: 0;
	}
	.list-table.table th {
		padding: 10px 0;
		font-size: 0.8rem;
	}
    .summary-sort {
        position: relative;
    }
}
</style>
<style>
.city-special .vue-treeselect__multi-value-label {
    font-size: 1rem;
}
.popover-custom .popover-body {
    background: #000;
    color: #fff;
}
.popover-custom.popover .arrow {
    display: none;
}
.listing-title {
    background: #fff;
    padding: 25px 20px;
    z-index: 20;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
}
.table th, .table td {
    border-top: none;
}
.vue-treeselect--has-value .vue-treeselect__multi-value {
    margin-bottom: 0;
}
.vue-treeselect__x-container > svg {
    background: #426586;
    font-size: 0.8rem;
    padding: 10px 6px;
    border-radius: 7px;
    margin-top: 0px;
    font-weight: bold;
    height: 31px;
    width: 22px;
}
.autocomplete-result-list::-webkit-scrollbar {
  width: 8px;
}
.autocomplete-result-list::-webkit-scrollbar-track {
  background-color: transparent;
  border-radius: 100px;
}
.autocomplete-result-list::-webkit-scrollbar-thumb {
  background-color: #a6a6a6;
  border-radius: 100px;
}
.autocomplete-result-list {
    background-color: #fff;
    border: 3px solid #13293E;
    border-radius: 25px;
    text-align: left !important;
}
.autocomplete-result-list li:not(:last-child) {
    border-bottom: 1px solid grey;
}
.autocomplete-result-list li {
    font-weight: normal;
    text-align: left !important;
}
.autocomplete-result-list li:not(:first-child) {
    padding-top: 9px !important;
    padding-bottom: 8px !important;
}
[data-position=above] .autocomplete-result-list {
    border-bottom: 3px solid #13293E;
    border-radius: 8px 8px 8px 8px;
}
.auto-title {
    text-align: left;
    font-size: 1.4rem;
    color: #13293E;
    margin-left: 10px;
}
.auto-second {
    text-align: left;
    font-size: 0.9rem;
    font-weight: normal;
    margin-left: 10px;
    color: #13293E;
}
.autocomplete-result {
    background-image: none;
}
</style>